export type PromiseContentType = {
  index: number;
  title1: string;
  title2: string;
  isRead: boolean;
  text_1: string;
  text_2: string;
  text_3: string;
  text_4: string;
  thumbnail: string;
  img: string;
  readDt?: string;
};

export type PromiseContentsType = {
  [val: string]: PromiseContentType[];
};

const shoes: PromiseContentType[] = [
  {
    index: 1,
    isRead: false,
    thumbnail: "thum_shoe1_1",
    title1: "부모를 따라하는 모델링 효과",
    text_1:
      "해도 해도 끝이 없는 집안일, 조금이라도 알아서 정리 정돈을 해주면 얼마나 좋을까? 부모님이시라면 한 번쯤은 이런 질문을 해보시지 않았을까 싶습니다.<br><br> 정리 정돈을 하는 습관은 보통 “모델링(modelling)”을 통해 학습되고는 합니다. 예를 들어 물건을 정리하는 부모님의 모습을 보고 아이들이 똑같이 물건 정리를 하는 것을 바로 “모델링 효과”라고 합니다.",
    text_2:
      "하지만 이렇게 부모님이 모델링을 함에도 불구하고 정리 정돈을 어려워하는 아이들에게 어떻게 정리 정돈 습관을 가질 수 있도록 도와줄 수 있을까요?",
    img: "shoe1_21",
    title2: "스스로 정리를 하지 않는 아이의 심리",
    text_3:
      "정리를 스스로 하기를 거부하거나 싫어하는 이유는 간단합니다 : 정리를 하기 싫다. 정리를 하는 시간 동안 본인이 원하는 다른 것을 하고 싶기 때문입니다.<br><br> 아이들이 게임과 정리를 하는 것 중에 선택을 하라면 대부분의 아이들은 당연히 본인이 원하고 흥미를 느끼는 것을 선택할 것입니다.",
    text_4:
      "이런 아이를 바라보면서 부모님은 화가 나기도 하고 더 아이를 컨트롤하고 싶은 욕구가 생겨날 것입니다.<br><br> 이런 아이의 행동에 감정적으로 반응 하기보다는 정리를 하고 싶지 않은 이유에 대해 생각해 보시고 아이와 이야기를 나눠보면 어떨까요?",
  },
  {
    index: 2,
    isRead: false,
    thumbnail: "thum_shoe1_2",
    title1: "아이가 이해할 수 있는 언어로 설명하기",
    text_1:
      "정리를 왜 해야 하는지 처음부터 이해하고 행동하는 아이는 드물 것입니다. 그렇다면 아이가 이해할 수 있는 방법과 언어로 정리를 해야 하는 이유를 설명해 주는 것이 중요합니다.<br><br> 아이와 함께 대화를 나눌 수 있는 질문들은 무엇이 있을까요?  <br><br>- 물건을 놓고 어떻게 하고 있니? <br><br> - 제자리에 정리해야 하는 이유는 무엇일까? (정리하지 않으면 어떻게 될까?) <br><br> - 어떻게 정리하면 좋을까?",
    text_2:
      "여기서 중요한 포인트는 아이가 정리해야 하는 이유에 대해서 이해해야 하고, 정리를 할 위치를 기억하는 것입니다. 물건의 “제자리”를 알려주며 스스로 정리를 할 수 있도록 도와주세요.",
    img: "shoe1_31",
    title2: "부모님이 먼저 해보세요.",
    text_3:
      "부모는 먼저 모범이 되어야 합니다. 자신의 물건을 항상 정리하고 제자리에 두는 모습을 보이면, 아이들도 이를 따라할 가능성이 높습니다.",
    text_4:
      "사소한 물건이라도 먼저 제자리에 두는 모습을 보여주세요.<br><br> 정기적으로 물건을 정리하고 불필요한 물건을 버리는 습관을 가르치세요. 아이들에게 물건을 관리하고 책임져야 함을 알립니다.",
  },
  {
    index: 3,
    isRead: false,
    thumbnail: "thum_shoe1_3",
    title1: "가족이 함께 정리하는 집안일에 참여해보세요.",
    text_1:
      "가족 모두가 함께 물건을 정리하고 제자리에 두는 것을 공동 작업으로 만들어보세요. 이렇게 하면 가족 간 협력과 책임감을 높일 수 있습니다.",
    text_2:
      "어릴 때부터 작은 집안일에 참여할 수 있게 도와주세요. 장난감을 정리하거나, 수건을 정리하는 일도 좋습니다. 아이가 잘 따라오면 충분한 칭찬을 해주세요.",
    img: "shoe1_32",
    title2: "아이가 스스로 할 수 있는 환경이 필요해요.",
    text_3:
      "아이들이 어떤 물건을 어디에 두어야 하는지 시각적으로 나타내는 것이 도움이 됩니다. 물건을 분류하고 라벨링하거나 색깔로 표시하여 물건을 찾는 데 도움이 됩니다.",
    text_4:
      "아이들의 작업 공간이나 방을 자극적으로 꾸미고, 물건을 정리하기 쉽도록 도구와 수납 공간을 제공하세요.",
  },
  {
    index: 4,
    isRead: false,
    thumbnail: "thum_shoe1_4",
    title1: "물건을 정리하며 조직화를 배우게 됩니다.",
    text_1:
      "아이들에게 물건을 정리하고 제자리에 두는 습관을 가르치면, 그들은 일상적인 생활에서 조직적으로 행동하는 방법을 배울 수 있습니다. 이는 학교나 직장에서 필요한 조직 능력을 키우는 기반이 됩니다.",
    text_2:
      "아이들은 물건을 빠르게 찾고, 중요한 일을 먼저 처리하는 방법을 습득하게 됩니다.",
    img: "shoe1_42",
    title2: "본인 물건에 대한 책임감을 배우게 됩니다.",
    text_3:
      "물건을 정리하고 관리하는 것은 책임감과 독립성을 배우는 데 도움이 됩니다. 아이들은 자신의 물건을 책임져야 하며, 스스로 독립적으로 물건을 관리할 수 있어야 합니다.",
    text_4:
      "장난감이 너무 많아지면, 사고 버리는 연습을 해야 합니다. 아이에게 필요한 물건과 그렇지 않은 물건을 구별할 수 있게 도와주세요. 버리는 과정을 배우는 것도 필요합니다.",
  },
  {
    index: 5,
    isRead: false,
    thumbnail: "thum_shoe1_5",
    title1: "아이와 함께 시작하기",
    text_1:
      "집안일을 하는 것은 아이의 두뇌 발달과도 연관이 있습니다. 예측력, 수리력, 주의력, 기억력 등 다양한 발달에 도움이 된답니다. 집안일 중에서도 아이가 비교적 쉽게 참여할 수 있는 영역은 “정리”의 영역입니다.<br><br> 아이가 스스로 정리하는 습관을 들이기를 원하신다면 먼저, 아이와 함께 시도해보세요.",
    text_2:
      "함께 외출하고 집에 돌아왔을 때, “우리 신발 혹은 외투를 정리해 볼까?”라는 질문으로 정리를 유도해주세요.<br><br> 물론 처음부터 쉽지 않겠지만 이 과정을 반복한다면 부모님이 함께하지 않아도 자연스럽게 정리하는 습관이 생겨날 것입니다.",
    img: "shoe1_51",
    title2: "아이가 습관이 될 때까지 기다려주기",
    text_3:
      "익숙하지 않은 행동을 습관으로 만들기까지는 충분한 시간이 필요합니다. 이 시간 동안 부모님이 과도하게 혼을 내거나 억지로 시키게 만드는 것은 오히려 역효과를 불러일으킬 수 있습니다.<br><br> 아이가 스스로 신발 정리를 하기 시작했다면 꾸준히 할 수 있을 때까지 기다려주세요.",
    text_4:
      "정리가 되지 않았을 때 “너 왜 이거 정리 안 했어?”라고 다그치기보다는 “정리가 안 되어있네, 혹시 깜빡했어?”라는 질문으로 아이가 정리를 하지 못한 이유에 대해서 물어봐 주세요.",
  },
];
const drug: PromiseContentType[] = [
  {
    index: 1,
    isRead: false,
    thumbnail: "thum_pill1_1",
    title1: "부모님의 도움이 꼭 필요해요.",
    text_1:
      "만약 병원으로부터 처방받아서 복용하고 있는 약이 있다면 처방지침에 맞춰 올바르게 약을 먹는 것은 매우 중요합니다.<br><br> 질병이나 상태를 치료하는 데 처방된 약보가 중요한 것은 없습니다. 처방된 약을 정확하게 복용하지 않으면 질병이 악화될 수 있습니다.",
    text_2:
      "따라서 정해진 기간 동안 약을 끊지 말고 아이가 꾸준히 잘 복용할 수 있도록 부모님의 세심한 도움이 필요합니다.<br><br> 아이가 약을 잘 챙겨 먹도록 부모님은 어떻게 도움을 줄 수 있을까요?",
    img: "pill1_11",
    title2: "아이에게 왜 약을 먹는지 이야기해주세요.",
    text_3:
      "아이에게 약을 먹어야 하는 이유와, 약이 아이에게 어떤 도움을 주는지 설명해주세요. 이해하고 동의하는 아이는 약을 먹는 것에 거부감이 없을 것입니다.",
    text_4:
      "특히 장기적으로 복용해야 하는 약이 있으면 그 약이 아이에게 어떤 도움을 주는지 자세히 설명해주세요. 부모가 복약 시간을 잊어도, 아이가 기억할 수 있습니다.",
  },
  {
    index: 2,
    isRead: false,
    thumbnail: "thum_pill1_2",
    title1: "아이와 대화를 나누며 권유해보세요.",
    text_1:
      '아이에게 그저 약을 강요하는 방식으로 먹이기보다, 올바르게 복용하는 방법과 약을 먹음으로써 얻을 수 있는 장단기적인 효과를 친절하게 설명해 주세요.<br><br> 만약 대화가 아이가 약을 계속 거부하는 쪽으로 흘러가게 된다면, "몸이 나아서 친구들이랑 놀고 싶지 않아?"라는 말로 권유해보세요.',
    text_2:
      "또한 약 복용 후 아이의 상태를 주의 깊게 관찰하고 약의 효과를 기록해 주세요. 만약 아이가 약 복용을 거부한다면 실제로 아이가 체감한 효과를 정리해서 설명해주는 것도 좋습니다.",
    img: "pill1_21",
    title2: "아이의 변화를 기록해보세요.",
    text_3:
      "아이가 장기적으로 약물을 복용해야 한다면, 해당 약이 아이에게 적합한지를 먼저 확인해야 합니다. 약을 먹고 아이가 호전되었는지, 혹은 상태가 더 안좋아졌는지, 혹은 다른 이상 증상이 없는지 확인해보세요.",
    text_4:
      "약물 복용에 대한 아이의 반응을 기록으로 남겨두면, 의사와의 상담에서 유용하게 활용할 수 있습니다.",
  },
  {
    index: 3,
    isRead: false,
    thumbnail: "thum_pill1_3",
    title1: "아이가 약을 스스로 복용할 수 있도록 도와주세요.",
    text_1:
      "아이가 스스로 약을 먹게끔 이끌어주는 것은 중요합니다. 아이는 스스로 의지를 다지고 동기를 부여할 수 있는 능력이 있는 존재로, 아이 스스로 약을 주도적으로 먹을 수 있도록 충분한 인정과 칭찬, 그리고 보상을 제공해주세요.",
    text_2:
      "만약 아이가 스스로 먹기를 힘들어한다면, 약을 어떻게 먹을지(컵 또는 주사기), 무슨 맛을 원하는지 물어보는 것도 방법입니다.<br><br> 이렇게 아이가 상황을 주도적으로 이끌어간다는 느낌이 들 수 있도록 도와주세요.",
    img: "pill1_31",
    title2: "약이 오남용되지 않도록 각별히 주의해야 합니다.",
    text_3:
      "달콤한 맛의 물약은 아이가 더 먹으려고 할 수 있으므로 주의해야 합니다. 약을 처방받을 당시, 복용 시간 등이 적혀있는 사용 방법을 아이와 함께 읽어 보는 것도 좋습니다.",
    text_4:
      "처방받은 약은 본인이 외에 가족, 친구 누구와도 공유해서는 안 되며, 오남용 및 과다 복용할 경우 중독 등의 위험 문제를 발생시킨다는 것을 꼭 알려주세요. 처방 약은 반드시 주치의에 지침에 따라 투약할 수 있도록 도와주세요.",
  },
  {
    index: 4,
    isRead: false,
    thumbnail: "thum_pill1_4",
    title1: "제 시간에 복약할 수 있게 도와주세요.",
    text_1:
      "일정한 시간에 약을 복용하도록 스케줄을 설정합니다. 약사 선생님이 알려준 것과 같이, 식사 후 또는 잠들기 전 등 시간을 정해보세요.",
    text_2:
      "필요한 경우, 스마트폰 알람이나 디지털 타이머를 사용하여 약물 복용 시간을 알림으로 설정합니다. 물론, 뽀미와 함께 제 시간에 약을 먹을 수도 있답니다.",
    img: "pill1_41",
    title2: "비타민이나 영양제도 좋아요.",
    text_3:
      "부모가 스스로 약을 챙겨먹이는 모습을 보이면, 아이들은 더 긍정적으로 본인의 약물 복용을 따를 가능성이 높아집니다.",
    text_4: "비타민이나 영양제도 좋습니다. 아이와 함께 건강을 챙겨보아요.",
  },
  {
    index: 5,
    isRead: false,
    thumbnail: "thum_pill1_5",
    title1: "약물도 여러가지 형태가 있어요.",
    text_1:
      "어린 아이들은 알약을 꿀꺽 삼키기 어렵습니다. 아이가 약을 삼키기 어려운 경우, 액체나 젤 형태로 제공할 수 있습니다. 아이에게 적합한 형태를 선택하세요.",
    text_2:
      "아이가 약을 먹는 데 어려움을 겪을 경우, 의사나 약사에게 상담하고 조언을 구하세요. 필요한 경우 대체 약물을 고려할 수도 있습니다.",
    img: " pill1_51",
    title2: "상비약은 안전한 곳에 보관해주세요.",
    text_3:
      "약물을 안전하게 보관해주세요. 특히 아이의 손이 닿지 않는 곳에 보관하시는 것을 추천드립니다.",
    text_4:
      "약물을 잘 복약하는 것은 아이의 건강을 보호하고 질병 치료에 도움을 주는 중요한 부분입니다. 따라서 부모의 지원과 관리가 필요하며, 아이가 협조하기 쉽도록 도움을 주는 것이 중요합니다.",
  },
];
const spoon: PromiseContentType[] = [
  {
    index: 1,
    isRead: false,
    thumbnail: "thum_spoon_1",
    title1: "더이상 아기가 아니에요, 스스로 할 수 있는 어린이예요",
    text_1:
      "부모님이 인식하고 있는 우리 아이는? 우리 아이는 아기일까요? 어린이일까요? 많은 부모님들은 우리 아이를 아기, 즉 부모의 도움이 꼭 필요한 존재로 바라봅니다. 물론 영유아기는 성인의 도움이 필요한 시기이지만, 무조건적인 것은 아닙니다.",
    text_2:
      "이처럼 부모님이 아이를 어떻게 인식하고 있는지는 행동으로 나타나게 됩니다. 부모님의 인식은 아이의 기본생활습관 형성에 긍정적인 영향을 미칠 수도, 부정적인 영향을 미칠 수도 있습니다. 따라서 부모님께서는 자신의 아이를 '아기'가 아닌 '어린이'로 바라보고, 아이가 가지고 있는 잠재력 및 능력을 믿고 지지해줄 필요가 있습니다. ",
    img: "spoon_12",
    title2: "스스로 할 수 있는 어린이임을 인식시켜 주세요.",
    text_3:
      "4-5세가 되면 타인이 생각하는 '나'에 대해 관심을 가지게 됩니다. 즉, 자기중심적인 성향은 줄어들고 타인과의 관계에 대한 관심이 생기며 타인이 자신을 어떻게 생각하는 지에 대해 의식하게 됩니다. 타인이 인식하고 말하는 '나'는 아이가 자아를 형성하는 데에 있어 지대한 영향을 미치게 됩니다.",
    text_4:
      "따라서 부모님께서는 아이에게 스스로 할 수 있는 힘을 가지고 있는 어린이임을 지속적으로 이야기하며 긍정적인 자아를 형성할 수 있도록 도와주세요.",
  },
  {
    index: 2,
    isRead: false,
    thumbnail: "thum_spoon_2",
    title1: "스스로 하기의 중요성 ",
    text_1:
      '"초등학교 초기 적응으로 인해 힘든 아이들, 왜 그런 걸까요?\n' +
      '유치원과 초등학교 모두 단체 생활이기는 하지만, 개별적인 지원 정도에 있어서는 차이가 있습니다. 유치원의 경우, 아이가 스스로 하기 힘든 경우 교사가 즉각적으로 도와주는 반면 초등학교는 교사의 도움 없이 스스로 해내야 하는 것들이 많습니다."',
    text_2:
      '"유아기에 부모 또는 교사의 지원 정도가 높다보면 초등학교에 입학하고 극심한 혼란을 느낄 수 있습니다. \n' +
      "'얼마 전까지 부모님, 선생님이 도와줬는데, 지금은 왜 안 도와주는 거지?'\n" +
      '또한, 스스로 못하는 자신을 다른 친구와 비교하게 되어 좌절감을 느끼고, 결국 자아존중감이 낮아질 수 있습니다.  "',
    img: "spoon_22",
    title2: "초등학교 준비를 위해 필요한 과정",
    text_3:
      "\"따라서 초등학교 입학를 위해 '스스로 하기'는 꼭 필요한 준비과정입니다.  \n" +
      '유아들에게 유치원과 초등학교의 공통점과 차이점에 대해 이야기해주시면서 스스로 해보는 것의 중요성을 느낄 수 있도록 해주세요. "',
    text_4:
      '"초등학교에 대한 두려움보다는 기대감을 느낄 수 있게 해주세요. 초등학생이 된다는 것에 대한 자부심을 느낄 수 있게 도와주는 건 어떨까요? \n' +
      '""네가 초등학생이 되면 스스로 할 수 있는 게 더 많아질 거야."""',
  },
  {
    index: 3,
    isRead: false,
    thumbnail: "thum_spoon_3",
    title1: "아이의 물건을 스스로 관리할 수 있게 도와주세요.",
    text_1:
      '"""유치원에 갔다오면 어떤 걸 꺼내두어야 할까?""\n' +
      "부모님께서는 하원 후에 잊지 않고 물건을 꺼내둘 수 있도록 유도해주세요.\n" +
      '"',
    text_2:
      "아이에게 물건을 잃거나 빠뜨릴 경우의 불편함을 이해시키고, 물건을 잘 챙기면 어떤 이점이 있는지 강조해주세요.",
    img: "spoon_32",
    title2: "본인 물건에 대한 책임감을 배우게 됩니다.",
    text_3:
      "물건을 정리하고 관리하는 것은 책임감과 독립성을 배우는 데 도움이 됩니다. 아이들은 자신의 물건을 책임져야 하며, 스스로 독립적으로 물건을 관리할 수 있어야 합니다.",
    text_4:
      '"또한, 자신의 물건을 스스로 관리하며 소중한 물건을 잃어버리거나 \n' +
      '다루지 못하는 상황을 예방할 수 있습니다. "',
  },
  {
    index: 4,
    isRead: false,
    thumbnail: "thum_spoon_4",
    title1: "초등학교 준비를 위해 꼭 필요한 과업",
    text_1:
      '"초등학교 준비를 위해 꼭 필요한 과업에는 어떤 것들이 있을까요? \n' +
      '초등학교 입학 전에 스스로 수행해야 하는 과업에는 어떤 것들이 있는지 파악해놓을 필요가 있습니다.  "',
    text_2:
      '"기본생활기술\n' +
      "-자신의 물건 관리 <br/>" +
      '-기본적인 독립생활기술: 화장실 사용, 옷 입기, 신발 신기 등의 기본적인 독립생활기술"',
    img: "spoon_42",
    title2: "과업 수행을 돕기 위한 체크리스트를 만들어보세요. ",
    text_3:
      '"아이의 과업 수행을 돕기 위한 체크리스트를 만들어보세요. \n' +
      '아이는 체크리스트를 통해 자신이 수행해야 할 과업을 쉽게 확인할 수 있습니다. "',
    text_4:
      "아이가 과업을 수행하였을 때, 구체적으로 칭찬하고 긍정적인 피드백을 제공하세요. 긍정적인 피드백은 아이가 자신의 노력과 성과에 대한 자신감을 높이는 데 도움을 줍니다.",
  },
  {
    index: 5,
    isRead: false,
    thumbnail: "thum_spoon_5",
    title1: "물건을 스스로 관리하며 자립심과 독립심이 강화됩니다.",
    text_1:
      "아이가 자신의 물건을 스스로 관리하고 돌보는 경험은 자립심과 독립심을 강화시킵니다. ",
    text_2:
      "이는 아이가 성장함에 따라 자신의 일을 스스로 처리하고 책임을 질 수 있도록 도와주는 중요한 요소입니다. ",
    img: "spoon_52",
    title2: "아이가 습관이 될 때까지 기다려주기",
    text_3:
      '"익숙하지 않은 행동을 습관으로 만들기까지는 충분한 시간이 필요합니다. 이 시간 동안 부모님이 과도하게 혼을 내거나 억지로 시키게 만드는 것은 오히려 역효과를 불러일으킬 수 있습니다. 아이가 스스로 신발 정리를 하기 시작했다면 꾸준히 할 수 있을 때까지 기다려주세요."',
    text_4:
      "물건을 꺼내두지 않았을 때 “너 왜 이거 안 꺼내놨어?”라고 다그치기보다는 “오늘은 물건을 안 꺼내놨네, 혹시 깜빡했어?”라는 질문으로 아이가 정리를 하지 못한 이유에 대해서 물어봐 주세요.",
  },
];
const washHand: PromiseContentType[] = [
  {
    index: 1,
    isRead: false,
    thumbnail: "thum_hand1_1",
    title1: "손 씻는 습관 형성이 중요한 이유",
    text_1:
      "손 씻는 습관은 특히 면역력이 약한 어린이들에게 매우 중요합니다. 코로나19 이후로 손 씻기 실천율이 98%까지 확산하면서 설사질환이 30%, 호흡기질환이 20% 감소하였다고 하니 손 씻는 습관만으로도 다양한 질환을 예방할 수 있다는 것이 만연한 사실입니다.",
    text_2:
      "손을 씻을 때는 물로만 헹구는 것이 아니라 비누로 올바르게 씻어야만 손에 묻는 99.8%의 세균을 없앨 수 있기 때문에 아이들에게 올바른 방법을 알려주는 것과, 행동이 지속 될 수 있도록 습관 형성을 도와주는 것이 아주 중요합니다.",
    img: "hand1_11",
    title2: "왜 손을 씻어야하는지 아이에게 설명해주세요.",
    text_3:
      "손씻기에 관련된 시각적 도구를 활용할 수 있습니다. 예를 들어, 세균을 보여주는 플래시 카드나 세균 모형을 사용하여 아이들에게 왜 손을 씻어야 하는지 시각적으로 설명할 수 있습니다.",
    text_4:
      "시각적 도구로 아이들을 이해시켜보세요. 이러한 방법들은 아이들이 손씻기를 재미있게 여기고 습관으로 만들 수 있도록 도와줍니다. ,",
  },
  {
    index: 2,
    isRead: false,
    thumbnail: "thum_hand1_2",
    title1: "올바른 손 씻기 방법을 지도해 주세요.",
    text_1:
      "손을 씻을 때는 흐르는 물에 비누로 30초 이상, 손바닥, 손등, 손가락 사이, 두 손 모아, 엄지손가락, 손톱 밑까지 30초 이상 씻어주어야 한다는 것을 알려줍니다.",
    text_2:
      "손 씻기는 우리의 일상생활에서 자주 해야 하는 꼭 필요한 습관이기 때문에 외출 후, 화장실 사용 후, 식사 전, 애완동물을 만진 후, 손이 더러워졌을 때 등 손을 언제 씻어야 하는지도 친절히 알려주세요.",
    img: "hand1_21",
    title2: "손 씻기는 일상적인 습관이 되어야 해요.",
    text_3:
      "손씻기를 아이의 일상적인 습관으로 만들어주세요. 아침, 점심, 저녁 식사 전후, 화장실 사용 후, 외출 후 등 손을 씻을 수 있는 기회를 활용하여 아이가 습관적으로 손을 씻을 수 있도록 도와주세요.",
    text_4:
      "한 번에 여러 상황이 아닌, 특정 상황부터 시작해봐요. 뽀미와 함께 상황을 정해두고, 시작해봅시다!,",
  },
  {
    index: 3,
    isRead: false,
    thumbnail: "thum_hand1_3",
    title1: "부모님과 함께 손을 씻는 경험을 시켜주세요.",
    text_1:
      "손을 씻어야 하는 상황이 생기면 부모님께서 함께 씻자고 권유해보세요. 손을 씻어야 하는 이유를 짧고 굵게 한 문장으로 아이에게 알려줍니다. (예: “손에 묻은 세균을 지금 씻어내면 나중에 아픈 병들이 찾아와도 피할 수 있어!”)",
    text_2:
      "또한 손을 씻을 때는 그 자체로 아이들이 즐거운 경험이 될 수 있도록 노래를 불러줘도 좋고 이야기를 들려주어도 좋습니다. 강제가 아닌 스스로 즐겁게 하고 있다는 느낌을 받을 수 있도록 도와주세요.",
    img: "hand1_31",
    title2: "오늘 비누 거품 놀이는 어떤가요?",
    text_3:
      "비누를 사용하여 손씻기를 놀이로 만들어보세요. 아이는 비누 거품을 만드는 것이 재미있어할 것이며, 거품을 만들면서 손을 씻을 수 있습니다.",
    text_4:
      "재미있는 활동은 새로운 습관을 형성하는데 중요한 역할을 합니다. 비누 거품 놀이로 아이에게 좋은 경험을 만들어주세요.,",
  },
  {
    index: 4,
    isRead: false,
    thumbnail: "thum_hand1_4",
    title1: "습관 형성을 위해 매일 같은 시간에!",
    text_1:
      "습관을 일상화하기 위해서는 몇 가지 중요한 요소가 있습니다. 그 중 하나가 일관성 입니다.",
    text_2:
      "즉, 일관된 루틴을 만들어야 합니다. 예를 들어, 매일 같은 시간에 특정 습관을 수행하도록 노력하세요. 뽀미와 함께 정해진 시간에 손을 씻게 도와주세요.",
    img: "hand1_41",
    title2: "뽀미와 같은 상황에 손을 씻어봐요!",
    text_3:
      "언제 손을 씻어야 하는지 잊지 않도록 뽀미를 사용하세요. 뽀미의 목소리를 통해 수행해야 할 시간을 상기시킬 수 있습니다.",
    text_4:
      "습관을 일상화하는 것은 시간과 노력이 필요한 작업이지만, 이러한 요소들을 활용하면 성공할 확률을 크게 높일 수 있습니다.,",
  },
  {
    index: 5,
    isRead: false,
    thumbnail: "thum_hand1_5",
    title1: "스스로 손을 씻고 왔을 때 충분히 칭찬해 주세요.",
    text_1:
      "아이가 스스로 손을 씻고 왔다면 그것이 당연한 것이 아닌 아이의 자기 주도 능력이 향상되었다고 생각해 주세요. <br><br> 아이의 입장에서는 당연하지 않은 일을 부모님의 말씀을 듣고 스스로 노력해 실천 한 것이나 다름이 없습니다.",
    text_2:
      "아이의 이러한 성공 경험들은 지금은 비록 사소해 보이지만 아이가 건강하게 성장하는데 소중한 자양분이 된답니다. <br><br> 아이의 노력을 충분히 인정해주고 칭찬해 주세요!",
    img: "hand1_51",
    title2: "부모의 칭찬은 긍정적 강화로 작용합니다.",
    text_3:
      "아이가 원하는 행동을 반복하도록 유도하고 강화하는 데 칭찬은 매우 큰 도움이 됩니다. 즉, 어떤 행동이 원하는 방향으로 나아가도록 사람들을 동기부여하고 강화하는 데 사용됩니다.",
    text_4:
      "하지만 너무 과도한 칭찬은 효과가 반대로 나타날 수 있으므로, 아이의 노력을 정확하게 인식하고 칭찬해주는 것이 중요합니다.",
  },
];
const brush: PromiseContentType[] = [
  {
    index: 1,
    isRead: false,
    thumbnail: "thum_brsh1_1",
    title1: "어린 시절의 양치질 습관 형성이 중요한 이유",
    text_1:
      "어릴 때부터 건강한 치아 관리 습관은 아주 중요합니다. 특히 학령기는 유치가 빠지고 영구치가 나기 시작하는 시점으로 관리가 더 중요한 시기입니다.<br><br> 하지만 학령기의 아이들은 손에 힘이 없고 세밀한 작업으로 혼자서 제대로 양치질하기 어려울 수 있습니다. ",
    text_2:
      "또한 아직 올바른 양치질 습관이 배지 않아 하루 3번 양치하게 만드는 것조차 어렵기 때문에 부모님의 주의 깊은 지도가 필요합니다.<br><br> 그렇다면 양치질 습관을 형성하는데 부모님은 어떤 도움을 주면 좋을까요?",
    img: "brsh1_11",
    title2: "아이와 함께 양치질을 해보아요.",
    text_3:
      "가족 모두가 함께 양치하는 시간을 공유하세요. 이러한 방법은 아이에게 양치질을 중요하게 여기도록 도와줍니다.",
    text_4:
      "양치질 습관은 아이의 평생 건강에 영향을 미치므로 부모님의 지도와 지원이 중요합니다. 아이들이 양치질을 즐기고 정기적으로 실천하도록 도와주면, 건강한 치아를 유지하는 데 도움이 될 것입니다.",
  },
  {
    index: 2,
    isRead: false,
    thumbnail: "thum_brsh1_2",
    title1: "즐거운 양치 시간, 부모님이 만들어 주세요",
    text_1:
      "양치하는 것을 당연하게 받아들일 수 있도록 부모님이 양치하는 모습을 아이 앞에서 먼저 보여줌으로써 아이가 자연스럽게 모델링할 수 있도록 하는 것이 중요합니다. 이에 따라 아이는 양치질을 과제가 아닌 자연스러운 루틴으로 느낄 수 있습니다.",
    text_2:
      "양치를 놀이로 느끼도록 유도하는 것도 좋습니다. “오늘은 어떤 입 속 세균이 있는지 볼까?”, “OO가 양치해서 입 속 세균을 다 물리쳤네!” 등 놀이로 접근하는 것도 좋은 방법입니다. 혹은 아이가 좋아하는 캐릭터가 그려진 칫솔 혹은 아이가 좋아하는 치약 맛을 활용해 보는 것도 좋습니다.",
    img: "brsh1_21",
    title2: "아이가 양치질을 좋아하게 도와주세요.",
    text_3:
      "아이가 좋아할만한 스타일의 칫솔과 아이가 좋아하는 향이 나는 치약을 선택하세요. 아이에게 칫솔이나 치약을 고르게 해주는 것은 아이에게 더 많은 관여감을 주고 거부감을 줄일 수 있습니다. 아이가 좋아하는 색상이나 캐릭터를 가진 칫솔을 선택하게 해보세요.",
    text_4:
      "아이가 양치질에 거부감을 가지지 않고 더 긍정적으로 다가갈 수 있도록 도와보세요. ",
  },
  {
    index: 3,
    isRead: false,
    thumbnail: "thum_brsh1_3",
    title1: "아이의 양치질이 미덥지 않더라도 기다려주세요.",
    text_1:
      "양치질을 유치원과 학교에서 배우긴 하지만 처음부터 꼼꼼하게 하지 못할 수 있다는 점을 기억해주세요. 아이는 여러 시행착오를 겪어가며 성장한답니다. 부모님께서는 처음부터 도와주려고 하기보다, 아이가 최대한 스스로 실천하고 난 후, 도움이 필요한 곳에 개입해 주세요.",
    text_2:
      "예를 들어, 아이가 7살쯤이 되면 어금니가 새로 나오기 시작합니다. 어금니는 칫솔이 잘 닿지 않는 입 안의 가장 안쪽에 있기 때문에, 아이 혼자서 깨끗하게 관리하기가 어렵습니다. 아이가 저녁 양치질을 마친 후, 어금니 부분을 부모님께서 한 번 더 체크해주세요.",
    img: "brsh1_31",
    title2: "올바른 칫솔 사용법을 알려주세요.",
    text_3:
      "아이의 연령에 맞는 양치질의 각 단계를 가르쳐주세요. 양치질 순서, 칫솔 사용법, 칫솔질 시간 등을 단계적으로 설명하고 연습하도록 도와주세요.",
    text_4:
      "칫솔질은 손끝을 사용하는 세밀한 작업이라서 조금 어려울 수 있어요. 하지만 걱정하지 마세요, 연습하면 점점 능숙해질 거예요.",
  },
  {
    index: 4,
    isRead: false,
    thumbnail: "thum_brsh1_4",
    title1: "청결에 대한 강박감이 있지는 않은지 점검해 보세요.",
    text_1:
      "혹시 부모님께서 청결에 대한 강박감이 있지는 않으신가요?<br><br> 아이에게 양치질에 대한 과도한 훈육 혹은 양치질을 안할 경우 생기게 되는 질병에 대해 설명을 과하게 하게 된다면, 불안이 높은 기질의 아이들은 바이러스에 대한 막연한 두려움을 갖게 될 수 있습니다. ",
    text_2:
      "과장하지 않고 사실 그대로 말해주는 것이 좋습니다. 아이가 이를 잘 닦게 된다면, 바이러스에 감염되지 않을 거라고 말해주어 양치에 대한 시선을 '건강을 위한 것', '안심할 수 있는 것' 으로 인식하게끔 도와주는 것이 좋습니다.",
    img: "brsh1_41",
    title2: "정기적인 치과 방문도 필수입니다.",
    text_3:
      "정기적인 치과 의사 방문을 유지하고, 아이에게 치과 의사의 중요성을 설명하세요. 치과에서 정기적으로 치아 검진과 치아 청결을 유지하는 도움을 받으면 치아 건강을 유지할 수 있습니다. ",
    text_4:
      "치과를 무서워하는 어린이들이 많습니다. 치과를 정기적으로 방문하여, 두려움을 낮춰주세요.",
  },
  {
    index: 5,
    isRead: false,
    thumbnail: "thum_brsh1_5",
    title1: "실제로 양치질을 싫어하는 아이들이 많습니다.",
    text_1:
      "사실, 양치질을 싫어하는 아이들이 아주 많습니다. 불편하게 느끼기도 하고, 깨끗하게 완료 하는 것도 어렵습니다. 어떤 이유로 양치질을 싫어하는지 들어보세요. ",
    text_2:
      "우리 아이가 이야기하는 이유를 고려하여 양치질을 긍정적인 경험으로 바꾸도록 노력해야 합니다. 아이들에게 양치질의 중요성을 설명하고, 양치질을 더 즐겁게 만들기 위한 방법을 찾아보세요.",
    img: "brsh1_51",
    title2: "필요하다면 천천히 해도 좋아요.",
    text_3:
      "아이가 양치질에 익숙해질 때까지 서서히 접근하세요. 처음에는 양치질을 간단하게 시작하고, 시간이 지남에 따라 양치질 습관을 키워나가세요.",
    text_4:
      "아이가 양치질을 긍정적으로 받아들이도록 하려면 차분하고 인내심을 가지고 부모님이 도움을 주는 것이 중요합니다. 뽀미와 함께 양치질 습관을 만들어봐요.",
  },
];

export const initPromiseContents: PromiseContentsType = {
  Homework: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_stdy1_1",
      title1: "스스로 공부할 수 있는 습관 형성 방법",
      text_1:
        "집중력은 몸의 근육과도 같아서 꾸준히 훈련을 한다면 강화될 수 있습니다. <br><br>집중력은 공부를 하는데 매우 중요한 요소이기도 하기 때문에 무조건 앉아서 공부를 하라고 지시하는 것이 아니라, 집중력을 높일 수 있는 훈련을 하는 것이 필요합니다.",
      text_2:
        "보통의 아이들은 재밌는 것을 할 때는 집중을 잘하는 편이지만 어려운 수학 문제를 풀 때나 하기 싫은 것을 할 때에는 집중하기 어려워합니다. <br><br>집중력이 높은 아이들은 자신감과 자존감을 갖게 됩니다. 그렇다면 우리 아이의 집중력 어떻게 높여줄 수 있을까요?",
      img: "stdy1_12",
      title2: "우리 아이의 관심사에 따른 공부 시간 설정",
      text_3:
        "초등학교 저학년 아이들 기준으로, 아이들의 집중력은 약 5-20분 정도입니다. <br><br>특히 어렵거나 흥미가 낮은 공부를 할 때는 집중할 수 있는 시간이 훨씬 짧을 수 있기 때문에, 초반에는 시간을 짧게 잡아 충분히 환기할 수 있는 시간을 가져주세요.",
      text_4:
        "예를 들어 수학을 어려워하는 아이에게는 수학 문제집 한 장을 풀라고 하는 대신, “우선 3문제만 풀어보자”라고 제안하며 점차 문제 수를 늘려가는 것도 좋은 방법입니다.",
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_stdy1_2",
      title1: "공부를 재미있게 여길 수 있게 도와주세요.",
      text_1:
        "아이의 호기심을 자극하고 질문에 답하도록 도와주세요. 자연 현상, 과학적 현상, 역사적 사건 등 다양한 주제에 대해 이야기하고 함께 찾아보세요. <br><br>학습을 게임 또는 즐거운 활동으로 만들어보세요. 수학 문제를 풀 때 게임처럼 경쟁하거나, 역사 상황을 연극으로 연출하는 등 학습을 더 흥미롭게 만들 수 있습니다. ",
      text_2:
        "무엇보다도 아이의 노력을 칭찬하고 성취를 축하하세요. 어려운 과제를 해결했을 때나 새로운 스킬을 습득했을 때 긍정적인 피드백을 주는 것이 중요합니다.",
      img: "study1_22",
      title2: "필요하면 밖으로 나가보세요!",
      text_3:
        "자연과 야외 활동을 통해 아이가 자연과 연결될 수 있도록 도와주세요. 등산, 자연 탐험, 정원 가꾸기 등을 통해 환경과 관련된 지식을 습득할 수 있습니다. <br><br>도서관, 박물관, 과학 센터 등 다양한 외부 자원을 활용하세요. 외부에서의 학습 경험은 새롭고 흥미로운 지식을 얻을 수 있습니다.",
      text_4:
        "방 안에서 연필을 쥐고 하는 공부에서 생각을 넓혀보세요. 이 나이 어린이들에게는 모든 것이 공부랍니다. 우리 아이에게 세상에서 가장 좋은 선생님이 되어주세요.",
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_stdy1_3",
      title1: "멀티태스킹이 아닌 싱글태스킹",
      text_1:
        "멀티태스킹(multi-tasking)은 엄청난 능력이라고도 많이 알려져 있죠. 하지만 수많은 연구 결과, 멀티태스킹은 집중력을 떨어뜨리고 학습 능력에도 부정적인 영향을 준다고 합니다. <br><br>한 가지에 집중할 수 있도록 집중에 방해가 되는 물건들을 정리하는 것도 좋은 방법입니다. 그리고 가능하다면 공부를 하는 공간에서는 공부만 할 수 있도록 유도를 해주세요.",
      text_2:
        "집중을 많이 어려워하는 아이라면 숙제들을 한 번에 전달해주고 끝내라고 하는 것보다는 한 가지씩 해야 하는 숙제를 이야기 해주는 것도 좋은 방법입니다.",
      img: "stdy1_32",
      title2: "공부를 재미있게 느낄 수 있게 여러 매체를 활용해봐요.",
      text_3:
        "우리 아이가 배우는 내용을 다양한 매체로 배울 수 있게 도와주세요.책, 동영상, 게임 등 다양한 학습 자료를 활용하세요. <br><br>그림, 그래프, 그림책 등 시각적인 자료를 활용하면 학습이 더 흥미로울거예요.",
      text_4:
        "공부에 거부감 없이 다가갈 수 있는 환경을 조성해주세요. <br><br>아이가 좋아하는 과목부터 시작하면 더 좋을 것 같아요!",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_stdy1_4",
      title1: "아이의 집중력을 떨어뜨리는 내부 자극 찾기",
      text_1:
        "아이들은 신체적인 감각 혹은 갑자기 떠오르는 웃긴 이야기 혹은 기억과 같은 “내부 자극”으로 인해 산만해지기도 합니다. <br><br>아이들의 상상력은 풍부하기 때문에 어떤 내부의 자극이 집중력을 방해하는지 파악하는 것도 중요합니다.",
      text_2:
        "아이의 집중력이 떨어졌다고 느껴지신다면 아이의 마음에 지금 어떤 생각들과 이야기들이 가득한지 귀 기울여 주세요. <br><br>내부의 자극이 충분히 해소가 된다면 다시 공부에 집중할 수 있게 될 것입니다",
      img: "stdy1_42",
      title2: "뽀모도로 기법을 아시나요?",
      text_3:
        "뽀모도로 기법은 공부나 일을 더 효율적으로 할 수 있도록 도와주는 시간 관리 방법이에요. 짧은 시간 동안만 집중해서 공부를 하고, 그 후에 짧은 휴식을 취하게 돼요.이것을 여러 번 반복하면 우리가 하는 공부를 효율적으로 할 수 있어요.",
      text_4:
        "뽀모도로 기법은 시간을 나눠서 일하는 것이 더 효과적이라는 아이디어에서 시작되었어요. 공부나 숙제, 레고 블록 쌓기, 그림 그리기 등 다양한 활동에 적용할 수 있어요.",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_stdy1_5",
      title1: "아이가요즘 배우는 내용에 관심을 가져주세요.",
      text_1:
        "자녀의 학습에 대한 관심을 표현하고 학습에 대한 질문을 하며 자녀의 학습 과정에 참여하세요.<br>아이가 부모에게 배운 것을 설명할 수 있게 해주면 더 좋은 학습이 될거예요.",
      text_2:
        "부모가 자녀의 학습을 지원하는 것은 자녀의 학업 성과와 자신감을 향상시키는데 큰 도움이 됩니다. 그러나 학습을 즐거운 경험으로 만들기 위해서는 자녀의 관심과 성향을 고려하여 학습 방법을 조절하는 것이 중요합니다.",
      img: "stdy1_52",
      title2: "아이가 공부를 너무 어려워하면 어떻게 해야 할까요?",
      text_3:
        "아이가 열심히 하였지만, 목표 달성에 실패할 때도 있을 것입니다. 누구나 어려움이 있기 때문이지요. 이럴때에는 자녀에게 압박을 주지 않고, 실패를 배우는 기회로 삼을 수 있도록 유연하게 대처하세요.",
      text_4:
        '함께 자녀의 목표를 재설정하고 새로운 계획을 세워보세요. 어떻게 다음 번에 성공할 수 있는지에 대해 함께 생각해보는 것이 중요합니다.자녀의 자신감을 회복시키기 위해 긍정적인 언어와 행동을 사용하세요. "넌 할 수 있어"와 같은 격려의 말을 자주 해주세요.',
    },
  ],
  WashHands: [...washHand],
  WashHand: [...washHand],
  WatchTV: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_tmtv1_1",
      title1: "TV, 정말 끊어야 하나요?",
      text_1:
        '"TV는 바보상자"라는 말이 있듯이, TV 가 아이에게 좋지 않다는 것은 누구나 알고 있는 사실이죠. 하지만 때로는 부모님도 육아로부터 분리되고 싶을 때가 있습니다.<br><br> TV를 틀어 놓으면 말괄량이 아이들도 잠잠해지니, 마음이 불편하지만 리모컨에 손이 자꾸 가는 것만 같습니다.',
      text_2:
        "특히나 아이들에게 미디어란 또래 친구들과 소통할 때 빠질 수 없는 이야깃거리가 되기도 하지요.<br><br> 마치 만능 육아 도우미처럼 느껴지는 TV, 우리 아이들에게 정말 나쁜 영향만 주는 걸까요?",
      img: "tmtv_11",
      title2: "TV의 긍정적인 효과",
      text_3:
        "실제로 TV에서 방영되는 좋은 프로그램들은 오히려 아이들의 상상력을 자극하고, 놀이를 풍부하게 해주며, 여러 가지 교육 목적의 개념들을 쉽게 배울 수 있게 알려주기도 합니다.",
      text_4:
        "아이가 초등학생이 되면서 스스로 정보를 해석하고 흡수할 수 있는 이 시기에, 단순히 TV를 끊어내는 것이 아니라 오히려 긍정적인 효과를 누릴 수 있는 요령에 대해 부모님께선 고민해 볼 필요가 있습니다.",
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_tmtv1_2",
      title1: "적절한 규제는 필요해요.",
      text_1:
        "TV를 유용하게 활용하기에 앞서, 아이가 적정한 규칙 안에서 TV를 시청할 수 있도록 가이드라인을 먼저 설정하는 것이 필요합니다.",
      text_2:
        "아이와 규칙을 조율하기 전, 부모님께서는 어떤 가이드를 적용하고 싶은지 아래 항목을 보며 고민해보세요.<br><br>- 총 시청 시간 혹은 시간대는 언제가 적당할까? <br><br> - 어떤 프로그램을 볼 것인가? <br><br> - 식사 도중이나 가족 간의 대화 시간 등과 같은 TV를 보지 않는 때에 대한 규칙이 있을까? ",
      img: "tmtv_21",
      title2: "규칙의 일관성을 적용해야 해요.",
      text_3:
        "규칙을 일관성 있게 적용하고, 아이에게 언제 TV를 보거나 보지 말아야 하는지에 대한 예측 가능한 규칙을 만들어주세요. 아이는 이러한 일관성을 통해 안정감을 느낄 수 있습니다.",
      text_4:
        "아이가 TV를 보고 싶다고 할 때, 대화와 협상을 통해 상황을 관리하는 것은 가족 관계를 향상시키고, 스크린 타임을 효과적으로 관리하는 데 도움이 됩니다. 중요한 것은 아이의 요구를 듣고 이해하되, 동시에 건강한 스크린 타임 관리를 유지하는 것입니다.",
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_tmtv1_3",
      title1: "아이와 함께 시청해보세요.",
      text_1:
        "TV는 스마트폰과 다르게 부모님과 함께 시청할 수 있다는 장점이 있습니다. 아이가 즐겨 보는 프로그램을 같이 보며 아이와의 대화의 주제를 확장해보세요.<br><br> 예를 들어, 스토리를 물어보거나, 아이가 가장 좋아하는 캐릭터는 누구인지 물어보며 대화를 넓힐 수 있겠죠.",
      text_2:
        "특히 아동용 프로그램의 경우에 교육적인 메시지를 전달하는 경우가 많습니다. 이때, 아이가 전달되는 메시지를 어떻게 해석하고 받아들이는지 대화해보는 것도 좋습니다.<br><br> 아이들은 어른과 전혀 다른 방식으로 받아들이는 경우도 많기 때문에, 서로의 다른 점을 비교해보며 풍성한 대화를 나눠보세요.",
      img: "tmtv_31",
      title2: "아이를 이해할 수 있는 도구가 되기도 해요.",
      text_3:
        "어른들과 마찬가지로, 아이들에게 TV는 다양한 문화를 접할 수 있는 기회의 창이기도 합니다.<br><br> TV를 보며 아이들은 자신도 모르게 선호하는 캐릭터, 말투, 옷 스타일 등을 정하게 되며 자신만의 취향을 만들어가기도 합니다.",
      text_4:
        "TV가 우리 아이의 행동에 어떤 영향을 미치고 있는지 관찰해보세요. 어느샌가 모르게 달라져 있는 우리 아이를 이해할 수 있는 좋은 지표가 되기도 한답니다.<br><br> 아이의 취향을 잘 알고 있는 부모님의 말과 행동은 아이에게 공감받는다고 느껴지기도 합니다.",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_tmtv1_4",
      title1: "아이가 TV로 떼를 쓰면 어떻게 해야 할까요?",
      text_1:
        "부모가 직면하는 일상적인 도전 중 하나는 아이가 TV를 보고 싶다고 떼쓸 때 어떻게 대처할지입니다. 이러한 상황에서 효과적인 대화 전략은 아이의 요구를 이해하고, 동시에 균형 잡힌 스크린 타임을 유지하는 데 중요합니다.",
      text_2:
        "아이가 TV를 보고 싶다고 할 때, 먼저 그 이유를 들어주세요. 아이가 무엇을 보고 싶어하는지, 그리고 그것이 왜 중요한지 이해해보세요. 아이의 의견을 존중하고 듣는다는 것은 양쪽 간의 신뢰를 증진시킬 수 있는 첫걸음입니다.",
      img: "tmtv_41",
      title2: "아이에게 선택의 기회를 주세요.",
      text_3:
        "아이에게 TV 시청을 선택하는 기회를 주세요. 예를 들어, 아이가 무엇을 보고 싶은지 물어보고 그 중에서 어떤 프로그램을 선택할지 고를 수 있게 해주세요. ",
      text_4:
        "이것은 아이에게 자기 결정 능력을 부여하고, 스크린 타임을 조절하는데 도움이 됩니다. 물론, 적절한 프로그램인지, 부모님이 꼭 확인해주세요.",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_tmtv1_5",
      title1: "교육적인 목적으로 사용할 수 있어요.",
      text_1:
        "TV는 다양한 세상을 보여주는 창이 될 수 있어요. 적절한 프로그램은, 아이들이 쉽게 마주할 수 없는 상황에 대한 이해를 증진시킵니다. 캐릭터 간의 관계와 사회적 상황을 이해하는 데 도움이 됩니다. ",
      text_2:
        "아이들은 사회적 상호작용, 감정 표현, 다른 사람들의 생각과 언어 등을 배울 수 있습니다.",
      img: "tmtv_51",
      title2: "언어 발달 도구로 사용할 수 도 있죠.",
      text_3:
        "다양한 언어와 문화적 배경을 가진 프로그램을 시청함으로써, 언어 능력을 향상시킬 수 있습니다. 다양한 문화적 배경을 가진 캐릭터와 이야기를 통해, 다른 문화에 대한 이해를 증진시킬 수 있습니다. ",
      text_4:
        "그러나 TV 시청은 적절한 양과 내용으로 관리되어야 합니다. 지나치게 TV를 시청하는 것은 신체적 활동과 사회적 상호작용에 부정적인 영향을 미칠 수 있으므로 부모는 어린이의 TV 시청을 지도하고 관리해야 합니다.",
    },
  ],
  PrepSchool: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_grsc1_1",
      title1: "아침에는 불가능하지만 저녁에는 가능한 것",
      text_1:
        "책가방을 싸는 것, 내일 아침에 입을 옷을 세팅해두는 것 모두 저녁에 미리 준비해둔다면 아침을 조금은 평화롭게 보낼 수 있을 것입니다.<br><br> 이때, 아이들과 함께 준비하는 시간을 가져보시면 어떨까요?",
      text_2:
        "자녀들과 함께 준비물을 선택하고 가방 챙기는 시간을 즐겁게 만들어 보세요. 이를 통해 자녀들이 학교 준비를 기대하고 긍정적으로 생각할 수 있습니다.",
      img: "grsc1_12",
      title2: "아이가 먼저 가방을 챙길 수 있게 기다려주세요.",
      text_3:
        "학교 준비를 마지못해 급하게 하지 않도록 일찍 시작해주세요. 필요한 준비물, 교과서를 알림장을 보고 스스로 챙길 수 있게 도와주세요. 그리고 다 챙겼는지 함께 확인해주세요. ",
      text_4:
        "학교 준비는 자녀의 미래를 위한 중요한 시작입니다. 부모님의 지원과 함께 자녀들은 자신의 잠재력을 최대한 발휘할 수 있을 것입니다. 함께 긍정적인 학교 생활을 시작해봅시다!",
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_grsc1_2",
      title1: "내일의 생활을 위해 미리 준비할 것들",
      text_1:
        "미리 해두면 마음이 한 결 편할거예요. 가방 챙기기 뿐만 아니라, 내일의 아이를 위해 미리 해둘게 뭐가 있을까요?",
      text_2:
        "아이들에게 부모님이 원하는 옷을 입기를 강요하는 것이 아닌, 스스로 원하는 옷을 고를 수 있는 충분한 시간을 허락해 주세요.<br><br> 이때 다음날 날씨를 함께 확인하면서 날씨에 따른 옷을 고를 수 있게 도와준다면 계절별로 입어야 하는 옷에 대해 학습할 수 있습니다.",
      img: "grsc1_22",
      title2: "아이의 다음날을 미리 파악해두세요.",
      text_3:
        "다음날 아이의 일정을 확인하세요. 특별한 행사나 일정이 있는지, 아이의 수업 시간이나 방과 후 활동을 고려해주세요.  ",
      text_4:
        "아이가 예민한 편이라면, 내일 있을 수 있는 일을 미리 이야기해줘도 좋아요. 우리 아이가 처음 하는 줄넘기를 잘 하지 못할 수도 있어요. 그런 경우 너무 당황하지 않을 수 있게, 줄넘기를 한다고 미리 말해줘도 좋아요.",
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_grsc1_3",
      title1: "전쟁 같은 등교 준비를 수월하게 만드는 방법",
      text_1:
        "아이를 키우는 부모님 입장에서 아이가 학교에 간다면 조금은 나만의 시간과 여유를 찾을 수 있지 않을까라는 기대를 하기도 합니다.<br><br> 물론 여유가 생기는 것도 맞지만 이 과정에서 새롭게 등장한 등교 준비는 마치 전쟁터와 흡사합니다. 아이를 깨우는 것부터, 씻기고, 아침을 먹이고 제시간에 등교를 시키는 것이 보통 쉬운 일은 아니지요.",
      text_2:
        "이를 돕기 위해서는 전날 저녁 등교를 준비할 수 있는 “저녁 등교 루틴”을 만드는 것이 중요합니다.<br><br> 그렇다면 이러한 저녁 루틴은 어떻게 만들 수 있을까요?",
      img: "grsc1_32",
      title2: "아이와 함께하는 저녁 루틴 만들기",
      text_3:
        "가정 내에서 아이들에게 루틴을 만들어주는 것은 아이들의 건강한 사회성, 정서 발달에 도움이 됩니다. 아이들의 경우 관계 또는 마주하는 상황들이 예측 가능하였을 때 안정감을 느끼게 됩니다.<br><br> 잠자리에 들기 전에 함께 책을 읽는 습관 혹은 숙면에 도움이 되는 스트레칭을 하는 것도 좋은 방법입니다.",
      text_4:
        "저녁 루틴을 형성하게 된다면 아이들은 루틴을 하고 난 후에는 잠자리에 들 시간이라는 것을 스스로 학습할 수 있게 될 것입니다.<br><br> 루틴을 정할 때에는 아이들이 직접 원하는 루틴을 정할 수 있도록 충분한 대화를 통해 만들어주세요.",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_grsc1_4",
      title1: "처음 학교를 보내는 경우, 미리 준비해주세요.",
      text_1:
        "학교에 대한 얘기를 아이와 함께 나누어주세요. 학교는 새로운 친구를 사귀고 재미있는 경험을 쌓는 곳이라고 설명해주세요. <br><br>아이가 학교에 대한 걱정이나 기대를 표현하면 귀 기울여 들어주세요. 그들의 감정을 이해하고 공감해주는 것이 중요합니다.",
      text_2:
        "학교를 처음 보내는 부모님은 자녀의 변화와 성장을 함께 지켜보는 특별한 순간을 경험하게 됩니다. 자녀와의 소통을 강화하고 긍정적인 마음가짐으로 학교 첫 경험을 풍요롭게 만들어보세요.",
      img: "grsc1_42",
      title2: "학교를 아이의 일상 범주에 포함시켜 주세요.",
      text_3:
        "학교에 다니기 시작했다면, 이제는 학교를 일상으로 포함시키는 것이 중요합니다. 유치원과 다르게 학교는 다소 통제된 환경이고, 정해진 규칙에 따라야 합니다. 아이가 규칙을 잘 지킬 수 있게 도와주세요.",
      text_4:
        "학교 후에 자녀와 그날 있었던 일에 대해 이야기하고, 다음 날을 준비하세요. 학교를 가기 전 날 밤에는 아이에게 긍정적인 마음가짐을 전달하세요. ",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_grsc1_5",
      title1: "아이가 학교를 좋아하게 하려면",
      text_1:
        "자녀가 학교에서 배우거나 수행하는 것에 관심을 표현하세요. 그들의 미술 작품이나 숙제에 대한 관심을 보여주면 자녀는 학교 생활을 더 가치있게 느낄 것입니다.",
      text_2:
        "자녀가 학교에서 친구를 사귀도록 도와주세요. 친구들과 함께 놀고 대화하며 사회적 관계를 쌓는 것은 학교를 즐기는 데 도움이 됩니다.",
      img: "grsc1_52",
      title2: "숙면을 위한 저녁 식사 준비",
      text_3:
        "아이가 균형 잡힌 저녁식사를 할 수 있도록 도와주는 것이 중요해요. 탄수화물만으로 이루어진 식사가 아닌, 양질의 단백질로 구성된 식사는 아이의 숙면에 도움이 됩니다. <br><br>숙면에 도움이 되는 음식을 먹었다면, 숙면에 방해되는 음식들은 피하는 것도 매우 중요합니다.",
      text_4:
        "카페인이 들어가 있는 초콜릿, 설탕 함유량이 높은 간식들보다는 견과류나 체리 혹은 키위 등의 과일로 저녁 간식을 대체해 주세요. <br><br>숙면을 통해 아이가 다음 날을 잘 준비하는 것이 아침 등교를 준비하는 첫 단계입니다.",
    },
  ],
  WatchYouTube: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_tmyt1_1",
      title1: "자극적인 유튜브, 아이에겐 참을 수 없는 유혹",
      text_1:
        "유튜브의 CEO 수전 워치스키(Susan Wojcicki)조차 자신의 어린 자녀들에게 ‘유튜브 키즈’ 만 볼 수 있게 하고, 그조차도 시청 시간에 제한을 둔다는 사실을 아시나요?<br><br> 유튜브 동영상은 조회 수를 증가시키기 위한 목적으로 자극적이고 산만한 형태를 지닙니다. 아이들이 동화책, 자연 등 웬만한 자극에 무뎌지게 만들지요.",
      text_2:
        "특히 아직 자기조절능력이 발달하지 않은 아이들이 유튜브 시청을 조절하지 못하는 것은 너무나 당연합니다. 그렇다면 부모님은 아이의 절제된 유튜브 시청을 위해 어떤 도움을 줄 수 있을까요?",
      img: "tmyt1_21",
      title2: "자녀가 원하는 것을 질문하고 들어주세요.",
      text_3:
        "우선 자녀가 유튜브를 보길 좋아하는 이유와 즐겨 시청하는 영상의 내용, 그리고 얼마만큼 보고 싶은지 등의 시간과 같은 질문들로 아이의 취향에 대해 관심을 가지고 들어주세요.<br><br> 무작정 유튜브를 그만 보게 하기 위해 훈육하려고 하면 아이를 너무 억압하게 되고, 점점 아이의 내면에는 분노나 충동이 쌓일 수 있습니다.",
      text_4:
        "아이가 원하는 것을 최대한 자유롭게 표현할 수 있도록 해주세요.<br><br> 그리고 아이가 그렇게 느낄 수도 있겠다는 것을 인정하고 수용해주세요.",
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_tmyt1_2",
      title1: "조율을 통해 유튜브 시청 규칙을 정해보세요.",
      text_1:
        "아이들은 만족지연 능력이 약하기 때문에 부모님이 자신의 요구를 들어주지 않으면 먼저 감정적으로 반응하게 됩니다.<br><br> 만족지연 능력이란 '지금 하고 있는 일이 매우 재미나지만, 딱 그 일을 그만둘 수 있는 힘'을 뜻합니다.",
      text_2:
        "아이의 요구사항을 들어주되 조율이 필요하다는 점을 알려주세요. 요구사항을 절반만 수용하거나 부모님의 요구를 받아들였을 때 보상을 준다든지, 규칙을 지키지 않았을 때 어떻게 할지 등의 조율을 아이와 맞추어 가보세요.<br><br> 조율하는 연습을 부모님과 잘 쌓아가게 된다면 또래와의 사회적 관계 능력에도 긍정적인 영향을 준답니다.",
      img: "tmyt1_11",
      title2: "시청 시간과 시청 콘텐츠를 생각해보세요.",
      text_3:
        "부모와 아이들이 함께 앉아 유튜브 시청 규칙을 정하는 것은 가장 좋은 방법입니다. 아이가 적당한 시간을 말 할 수 있게 도와주세요.",
      text_4:
        "부모와 아이의 대화를 통해 유튜브 시청 규칙을 정하고 준수하는 것은 온라인 환경에서의 안전하고 유익한 활동을 촉진하는데 큰 역할을 할 것입니다.",
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_tmyt1_3",
      title1: "콘텐츠 선정에 부모의 관여가 필요합니다.",
      text_1:
        "유튜브는 현대 아이들의 일상에서 떼놓을 수 없는 중요한 역할을 하고 있습니다. 다양한 콘텐츠를 제공하며, 아이들이 새로운 지식을 습득하고 창의성을 발휘하는 데 큰 도움을 줍니다. 그러나, 유튜브에서 아이들을 위한 콘텐츠를 선택할 때 부모의 관여와 지도가 필요합니다.",
      text_2:
        "부모는 아이들의 연령과 발달 수준에 맞는 콘텐츠를 선택해야 합니다. 유튜브는 모든 연령층을 대상으로 하는 콘텐츠를 제공하므로, 부모가 어떤 콘텐츠가 아이에게 적합한지 판단할 필요가 있습니다.",
      img: "tmyt1_31",
      title2: "신뢰할 수 있는 채널과 크리에이터를 생각해보세요.",
      text_3:
        "어떤 채널, 어떤 크리에이터의 콘텐츠를 우리 아이에게 추천할 수 있는지 생각해보세요. 지금 떠오르는 대상을 넘어, 적어도 3개 콘텐츠를 시청해보세요.",
      text_4:
        "그리고, 아이들에게 신뢰할 수 있는 유튜버와 채널을 소개해주세요. 학습적 가치가 높은 크리에이터와 채널을 찾아 아이들이 안전하고 유익한 콘텐츠를 시청할 수 있도록 도와주세요.",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_tmyt1_4",
      title1: "만약 규칙을 어긴다면 분명하게 제재해주세요.",
      text_1:
        "아이가 규칙을 지키지 않았을 때는 분명하게 제재해주는 것이 필요합니다. 이때, 단호함도 중요하지만 아이의 마음을 공감해주는 것도 꼭 곁들여주세요. ",
      text_2:
        "“유튜브를 더 보고 싶어서 속상하구나. 하지만 더는 안돼. 왜냐하면 유튜브의 중독성이 위험하기 때문에 우리가 함께 조율해서 시청 시간을 합의했기 때문이야.”라고 아이가 이해할 수 있도록 차분하지만 단호한 목소리로 알려주세요.",
      img: "tmyt1_41",
      title2: "자녀보호 애플리케이션을 사용하셔도 좋습니다.",
      text_3:
        "다양한 자녀보호 애플리케이션이 출시되어 있습니다. 사용 시간을 정해둘 수 있어요.",
      text_4:
        "혹은 유튜브의 시청 제한 기능을 활용하는 것도 좋습니다. 시청 제한 기능을 통해 자녀가 시청할 수 있는 동영상을 제한하거나 시청 시간을 시스템적으로 제한하는 것도 활용해보세요.",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_tmyt1_5",
      title1: "아이가 좋아하는 채널을 함께 시청해보세요.",
      text_1:
        "아이들과 함께 유튜브 채널을 시청해보세요. 어떤 콘텐츠를 시청할지 결정하고, 이를 통해 학습 및 토론의 기회를 제공하세요.",
      text_2:
        "우리가 쉽게 접하지 못하는 다양한 콘텐츠를 마주할 수 있기 때문에, 더 풍부한 언어로 아이와 이야기할 수 있을거예요. 이 상황에서 우리 아이라면 어떤 기분이었을지, 어떤 행동을 할 것인지, 어떤 생각을 할 것 같은지 여러가지 이야기를 해보세요.",
      img: "tmyt1_51",
      title2: "콘텐츠 확인은 필수입니다.",
      text_3:
        "유튜브는 연령별로 적절한 콘텐츠를 제공하고 있습니다. 아이들의 연령에 맞게 적절한 콘텐츠를 선택하도록 도와주세요.",
      text_4:
        "아이가 시청하는 콘텐츠가 어떤 내용의 콘텐츠인지, 어떤 언어 표현이 이루어지는지, 한번 쯤은 꼭 확인해보셔야 합니다. 부모님께서 먼저 콘텐츠를 시청하고, 아이에게 적절한 콘텐츠인지 확인해보세요.",
    },
  ],
  Diary: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_diry1_1",
      title1: "일기쓰기가 주는 긍정적인 효과",
      text_1:
        "일기 쓰기는 아이들의 인지 및 정서 조절 능력 등에 다방면으로 도움이 됩니다.<br><br> 특히 아이들에게 일기는 하루 있었던 일들을 다시 떠올려보면서 사건의 순서나 인과관계를 다시 정립해보는 과정을 통해 사고력을 향상시키는 역할을 합니다.",
      text_2:
        "그리고 그 과정에서 자기 생각과 감정을 떠올리고 적어보기 때문에 감정을 해소하는 것에도 도움이 됩니다. 더불어 글을 쓰는 작업을 통해 글쓰기 능력과 어휘력이 모두 향상됩니다.<br><br> 그럼 아이들이 일기를 쉽게 작성할 수 있도록 부모님께선 어떻게 도움을 줄 수 있을까요?",
      img: "diry1_12",
      title2: "일기 주제를 정할 수 있도록 도와주세요.",
      text_3:
        "아이는 글을 쓰는 것에 익숙하지 않을 수 있기 때문에, 처음부터 스스로 일기 주제를 선정하는 것은 어려울 수 있습니다.<br><br> 이때, 부모님께서 아이에게 대화를 건네며 주제를 떠올릴 수 있도록 도와주는 것은 어떨까요?",
      text_4:
        "“오늘 기억에 제일 남는 일이 뭐야?”, “오늘 가장 기분이 좋았을 때는 언제야?”, “오늘 가장 기분이 좋지 않았을 때는 언제야?” 등의 질문을 통해 아이가 떠오르는 것을 자연스럽게 일기에 적어볼 수 있도록 유도해보세요.",
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_diry1_2",
      title1: "감정 혹은 생각 위주로 작성하도록 이끌어주세요.",
      text_1:
        "일기를 쓸 때의 옳고 그름의 기준은 없지만, 객관적인 상황을 적는 것 보다는 감정 혹은 생각을 적는 것이 아이의 정서 발달에 더욱 도움이 됩니다.<br><br> 부모님과 함께 대화하며 일기의 주제를 선정할 때, “그랬구나, 그 상황에서 OO는 무슨 마음이 들었어?” 등의 질문으로 아이의 생각과 감정이 자연스럽게 떠오르도록 질문해 주세요.",
      text_2:
        "만약 아이가 생각이나 감정을 잘 떠올리지 못한다면, 당시 상황을 더 구체적으로 질문하는 것이 당시의 생각이나 감정을 떠올리는 것에 도움이 됩니다.",
      img: "diry1_22",
      title2: "일기 쓰기가 긍정적인 경험이 되도록 도와주세요.",
      text_3:
        "일기 쓰기 습관을 들이기 시작하는 아이들에게는 일기 쓰기가 무엇보다 '긍정적인 경험'이 될 수 있도록 도와주는 것이 중요합니다.<br><br> 이를 위해 아이에게 일기 쓰기를 숙제처럼 강요하거나 맞춤법, 띄어쓰기, 글의 양 등을 평가하지 않도록 주의해주세요.",
      text_4:
        "이러한 부분들은 아이가 성장하면서 자연스럽게 나아질 부분입니다.<br><br> 그리고 만약 꾸준히 일기 쓰는 아이를 만들고 싶다면 부모님께서 옆에서 일기를 꾸준히 쓰는 모습을 보여주는 것도 도움이 됩니다.",
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_diry1_3",
      title1: "감정 표현 연습이 중요한 이유",
      text_1:
        "일기 쓰기를 통해 아이들이 마음을 표현하는 법을 훈련할 수 있습니다.<br><br>마음을 잘 표현하는 방법은 어떤걸까요? 첫번째 절차는 바로 ‘감정 선택하기’ 입니다. 감정을 표현하는 것은 아이의 건강한 정서 발달에 중요한 영향을 미치는데요.",
      text_2:
        "자신의 감정을 인지하고, 또 자신이 느끼는 감정을 이해하는 법을 배운 아이는 살아가며 다양한 상황 속에서 보다 유연한 방식으로 스스로를 다룰 수 있는 힘을 갖게 될 수 있습니다.",
      img: "diry1_32",
      title2: "감정 선택지를 활용해보세요.",
      text_3:
        "아이들이 감정을 표현하기 어려워하는 이유는 단순하게 자기가 느끼고 있는 감정이 무엇인지 잘 모르기 때문인 경우가 많습니다.<br><br> 이럴 때는 몇 가지의 감정 선택지를 주어 골라보도록 하는 것이 좋습니다.",
      text_4:
        "오늘 하루 아이에게 어떤 일이 있었는지, 그때 느꼈던 감정이 기쁨, 슬픔, 화남, 황당 중 어떤 감정에 속하는지 골라볼 수 있도록 재미있게 대화하며 옆에서 지도해주세요.<br><br> 이러한 과정을 연습하다 보면, 아이는 자신의 감정을 구체적으로 표현할 수 있는 아이로 성장하게 됩니다.",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_diry1_4",
      title1: "아이의 감정을 표현하게 해주세요.",
      text_1:
        "아이에게 감정을 표현하는 것을 연습시키기 전에, 부모님께서 평소에 아이가 감정을 표현하는 것을 억누르는 상황을 만들고 계시지는 않은지 점검 해볼 필요가 있습니다.<br><br> 특히나 한국 문화에서는, 보통 부정적이거나 불편한 감정을 드러내지 않는 것이 익숙하기도 합니다.",
      text_2:
        "그러다 보니 아이에게도 '울면 안돼', '화내면 안 돼' 라는 말을 자주 사용하는 경우가 많습니다.<br><br> 이런 말들을 자주 듣다 보면 아이는 다양한 감정을 수용하지 못하고 내면에 계속 쌓아두게 됩니다.",
      img: "diry1_42",
      title2: "좋은 감정, 나쁜 감정?",
      text_3:
        "따라서 아이들이 슬픔, 불안, 분노, 질투 등의 부정적인 감정을 억누르기 보다는 이러한 감정들도 건강한 감정의 표현이며, 우리가 살아가는 데 있어서 필요한 역할을 하기도 한다는 것을 알려주어야 합니다.<br><br> 그러기 위해서 먼저 부모님께서 좋은 감정, 혹은 나쁜 감정을 분류하고 있지는 않은지 점검해보세요.",
      text_4:
        "아이가 성장하는 과정에서 다양한 감정들을 느끼며, 그런 감정들이 자신에게 어떤 영향을 주는지, 또한 그것들을 어떻게 건강하게 처리해야 하는지 등 아이 스스로 '감정 소화 능력'을 키울 수 있도록 부모님께서도 함께해주세요.",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_diry_1_5",
      title1: "기록을 통한 자기 파악",
      text_1:
        "일기는 아이들에게 자기 자신을 더 잘 이해하게 해주고, 자신감을 키우는 데 도움을 줍니다. 일기를 통해 아이들은 자신의 강점과 약점을 파악하고, 어떻게 성장할 수 있는지를 고민하게 됩니다.",
      text_2:
        "일기는 아이들의 성장과 경험을 기록하는 좋은 방법입니다. 나중에 그들은 과거의 일기를 통해 어떻게 성장했는지를 돌아볼 수 있습니다.",
      img: "diry1_52",
      title2: "언어 능력 향상에도 도움이 되는 일기쓰기",
      text_3:
        "일기쓰기는 글쓰기와 언어 능력을 향상시키는 데 도움이 됩니다. 아이들이 자주 글을 쓰면서 언어 능력이 향상되며, 미래에는 논리적으로 생각하고 표현하는 데 도움이 됩니다.",
      text_4:
        "꾸준히 일기를 쓸 수 있게 독려해주세요. 아이들에게 일기를 쓰는 즐거움과 중요성을 알려주며, 그들의 성장과 발달을 지원해주시기를 권합니다. 함께 성장하고 배우는 아름다운 순간을 만들어봐요.",
    },
  ],
  Book: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_book1_1",
      title1: "꾸준한 독서가 아이에게 미치는 영향",
      text_1:
        "책은 어휘력, 독해력, 집중력과 인내력, 학습 성과 향상과 더불어 다양한 지식과 지혜를 얻어갈 수 있는 유용한 도구입니다.<br><br> 특히 아이의 독서의 경우, 교과 학습에서 문제를 이해하고 분석하는 것에 바탕이 되는 중요한 역할을 합니다.",
      text_2:
        "그리고 나아가 책은 양질의 내용을 통해 아이들이 다양한 지식과 지혜를 자연스럽게 습득할 수 있도록 도와줍니다.<br><br> 그렇다면 스스로 책 읽는 아이로 성장하기 위해서 부모님이 어떻게 도와주면 좋을까요? ",
      img: "book1_12",
      title2: "재밌고 쉬운 책으로 독서를 시작하도록 도와주세요.",
      text_3:
        "초등학교 저학년의 아이에게는 무엇보다 책 읽는 것이 놀이처럼 느껴질 수 있도록 도와주어야 합니다.<br><br> 큰 서점 내 아동 서재의 아이가 좋아하는 분야 (예, 동물 등) 에 데려가서 좋아하는 책을 고르도록 해주세요. 처음에는 만화도 좋습니다.",
      text_4:
        "무엇보다 아이들이 책에 재미를 붙이고 자연스럽게 독서 시간이 늘어나는 것이 중요합니다.<br><br> 부모님의 역할은 아이가 고른 책이 어휘, 내용 등의 난이도가 적합한지를 판단하는 정도로 충분합니다.",
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_book1_2",
      title1: "책의 내용을 바탕으로 아이와 대화를 나누세요.",
      text_1:
        "책을 읽는 것이 익숙하지 않은 아이들은 내용을 제대로 이해하지 못하고 글자를 읽는 수준의 독서를 할 수도 있습니다.<br><br> 이 경우 아이가 책을 읽으며 줄거리의 내용을 이해할 수 있도록 부모가 질문을 통해 도움을 줄 수 있습니다.",
      text_2:
        "예를 들어, 아이에게 “주인공이 어떤 행동을 했지?”, “주인공이 왜 그런 행동을 했지?” 등의 질문을 하고, 아이가 이에 답을 생각해보는 과정 자체가 도움이 될 수 있습니다.<br><br> 그리고 더 나아가 “~라면 어땠을까?”, “~라면 어떤 생각이 들었을까?” 등의 아이의 관점에서 더 확장해서 생각해볼 수 있는 질문도 도움이 됩니다.",
      img: "book1_22",
      title2: "책 이야기를 아이를 통해 들어보세요.",
      text_3:
        "아이가 책 내용을 부모에게 설명할 수 있는 기회를 주세요. 완전히 다른 이야기를 할 수도 있습니다. 하지만 이야기를 처음부터 끝까지 이야기해볼 수 있게 도와주세요. 아이 스스로 이야기를 구성해 볼 수 있는 기회가 됩니다.",
      text_4:
        "어린 아이들을 위해서는 동화책과 그림책을 활용하세요. 아름다운 그림과 이야기가 아이들의 상상력을 자극할 것입니다.<br><br> 부모님은 아이들이 책을 읽고 상상력을 키울 수 있도록 도울 수 있습니다. 책은 아이들에게 지식을 넘어, 상상력과 창의력을 키우는 소중한 도구입니다.",
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_book1_3",
      title1: "부모님이 아이와 함께 책을 읽어주세요.",
      text_1:
        "결국에는 책이 익숙한 아이들이 책을 더 많이 읽게 됩니다. 이를 위해 가장 좋은 방법은 부모님이 아이와 함께 책을 읽는 것입니다. <br><br>부모님께서 꾸준히 정해진 시간에 아이를 데리고 책을 읽어주세요. 아이에게 책을 읽어주다가 일부는 아이 스스로 책을 읽도록 유도하는 것도 좋은 방법입니다.",
      text_2:
        "책을 통해 부모님과 자연스럽게 소통하고, 함께 책을 읽음으로써 아이가 부모님의 온기를 느낄 수 있다면 아이의 정서발달에도 더할 나위 없이 좋을 것입니다. <br><br>혹은 부모님이 먼저 책을 읽는 습관을 기르고 아이가 자연스럽게 보고 따라 할 수 있도록 하는 것도 좋은 방법입니다.",
      img: "book1_32",
      title2: "이야기에 대해 아이와 토론해보세요.",
      text_3:
        "아이들이 책을 읽을 때 그들의 생각과 감정을 공감하고 이해해주는 것이 중요합니다. 책에 대해 토론하고 함께 이야기를 나누는 것은 아이들의 이해와 상상력을 키우는 데 도움이 됩니다.",
      text_4:
        "책을 읽는 경험이 즐거운 기억이 될 수 있게 도와주세요. 많이 읽는 것도 중요하지만, 어떤 생각을 했는지도 중요한 문제입니다. 아이가 책을 읽고 어떤 생각을 하는지 꼭 물어봐주세요.",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_book1_4",
      title1: "아이 수준에 적합한 책을 골라주세요.",
      text_1:
        "책을 읽는 것은 언어 능력을 향상시키는데 큰 역할을 합니다. 어휘력, 문법, 읽기 이해력을 향상시켜주며, 이는 글쓰기 및 의사 표현 능력을 키우는데 도움이 됩니다.",
      text_2:
        "아이가 읽고 이해할 수 있는 표현의 책을 권해주세요. 너무 어려운 책은 아이에게 반감을 줄 수 있습니다.",
      img: "book1_42",
      title2: "아이가 좋아할만한 책으로 선택해주세요.",
      text_3:
        "자녀가 읽고 싶은 책을 선택하고, 자신의 관심사에 맞게 독서를 즐길 수 있도록 존중해주세요. 아이와 함께 서점에서 책을 골라보는 것은 좋은 경험이 될 거예요.",
      text_4:
        "너무 어려워서 아이가 거부할만한 책은 좋지 않습니다. 아이가 흥미를 느낄 수 있는 내용을 담는 책을 함께 골라보세요.",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_book1_5",
      title1: "독서 시간을 만들어주세요",
      text_1:
        "가정에서 정기적인 독서 시간을 만들어주세요. 특히 취침 전 독서 시간을 만들면, 자녀가 스트레스를 풀고 편안하게 책을 즐길 수 있습니다.",
      text_2:
        "독서는 즐거운 경험이어야 합니다. 자녀가 강제로 독서를 해야한다고 느끼지 않도록 주의해주세요.",
      img: "book1_52",
      title2: "함께 독서를 실천해보세요.",
      text_3:
        "부모님 스스로 독서 습관을 가지고, 자녀에게 모범이 되어주세요. 가정에서 부모님이 책을 읽고 있는 모습을 자주 보이면, 자녀도 자연스럽게 독서에 흥미를 느낄 수 있습니다.",
      text_4:
        "부모님도 독서를 즐기는 모습을 보여야, 아이도 '일'이나 '공부'로 받아들이지 않을 수 있습니다. 가족으로 독서 시간을 갖는 것도 좋습니다. ",
    },
  ],
  Coat: [...shoes],
  PlayGame: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_tmgm1_1",
      title1: "긴 호흡으로 천천히 연습해야 합니다.",
      text_1:
        "게임은 다양한 자극적인 요소를 포함하고 있기 때문에 쉽게 아이들의 관심을 빼앗아 갑니다. 아무런 지도 없이 그대로 방치하게 되면 게임 중독에 빠질 확률이 높아지죠.<br><br>다만, 게임이 또래 친구들과의 공통적인 관심주제가 될 수도 있기에 아이들에게서 게임을 분리하는 것은 매우 어려운 일이 될 수 있습니다.",
      text_2:
        "부모님께서는 게임이라는 강렬한 매체로부터 아이의 자기조절능력을 키워간다는 긴 호흡을 가지고 아이를 대해야 합니다. 그렇다면 구체적으로 부모님이 할 수 있는 노력에는 어떤 것들이 있을까요?",
      img: "tmgm1_12",
      title2: "조율하며 함께 게임 시간을 정해보세요.",
      text_3:
        "게임 시간을 정하기에 앞서, 게임을 과하게 하는 것이 위험한 이유와 게임 시간 제한의 중요성에 대해 충분히 설명해 주세요.<br><br>예를 들어, “게임은 하면 할수록 더 하고 싶어서 너의 의지와 다르게 중독될 수 있어. 그건 너를 해칠 수 있기 때문에 게임 시간 규칙이 필요해”라고 말해주세요.",
      text_4:
        "아이에게 무작정 규칙을 지키라고 말하는 것보다, 아이의 대화를 들어주며 조율하는 느낌을 주는 것이 중요합니다.<br><br> 시간을 정할 때, 아이의 의견을 최대한 들어주고 반영하여 부모님과 함께 일일 게임 시간 규칙을 설정해 보세요.",
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_tmgm1_2",
      title1: "아이들은 규칙을 세우고 실천하는 것을 좋아합니다.",
      text_1:
        "게임 시간을 정해두고 그 시간을 엄수하도록 아이에게 도움을 주세요. 게임이 끝날 시간을 미리 알려주고, 시간이 다가올 때 알람을 설정하는 등의 방법을 사용해보세요. 이렇게 하면 아이가 시간을 더 잘 지킬 수 있을 것입니다 ",
      text_2:
        " 게임 시간을 효과적으로 관리하는 것은 아이의 발달에 도움을 주는 중요한 역할을 합니다. 부모와 아이가 함께 협력하여 게임 시간을 관리하면, 아이는 게임을 즐기면서도 시간을 잘 지키는 습관을 키울 수 있을 것입니다.",
      img: "tmgm1_22",
      title2: "규칙을 만들었다면 꼭 지켜야 합니다.",
      text_3:
        "아이는 어떻게든 게임을 더 하고 싶어 할 것입니다. 떼를 써보기도 하고, 울기도 하겠지요. 이때 부모님께서 많이 흔들릴 수 있을 거라 예상됩니다.<br><br> 하지만 이럴 때일수록, 아이가 세운 규칙을 잘 지킬 수 있도록 부모님의 단호한 대응이 필요하며, 규칙의 예외가 생기지 않도록 각별히 주의해야 합니다.",
      text_4:
        "만약 예외가 생길 경우 그 다음번의 아이가 규칙을 다시 지키는 것은 더욱 힘들어지게 될 것이라는 점을 기억해주세요.",
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_tmgm1_3",
      title1: "부모님의 감정조절이 중요합니다.",
      text_1:
        "어른들도 드라마 시청 중간에 스스로 그만두는 게 어려운 것처럼, 아이들도 마찬가지입니다. 더구나 자기 조절력이 낮은 아이들은 더 쉽지 않을 것이고, 게임을 너무 좋아하는 아이라면, 아이의 입장에서는 규칙을 만드는 것 자체가 반강제적으로 느껴질 수 있습니다.",
      text_2:
        "따라서 부모님께서는 아이의 이런 마음에 공감해 줄 필요가 있습니다.<br><br> 아이가 게임을 더 한다고 해서 바로 불호령을 내리지 말고 이 과정이 평생 아이가 게임에 중독되지 않고 즐기기 위한 과정이라고 생각하며 조금은 여유를 가지고 차분하지만 단호하게, 그리고 반복적으로 말해주세요.",
      img: "tmgm1_32",
      title2: "아이가 좋아하는 게임을 함께 해보세요.",
      text_3:
        "아이가 어떤 게임을 좋아하는지, 그 게임에선 어떤 콘텐츠가 진행되는지 살펴보세요. 우리 아이를 이해하는데 한 걸음 더 나아가게 될 것이예요.",
      text_4:
        "게임을 즐기는 과정에서 부모와 아이가 함께 웃고 즐거운 경험을 공유할 수 있습니다. 부모와 게임을 함께 하는 것이 가족 간의 유대감을 형성에 도움이 됩니다.",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_tmgm1_4",
      title1: "컴퓨터 게임의 대안을 찾아보세요.",
      text_1:
        "아이가 게임 외에 흥미를 느낄만한 활동을 같이 찾아주세요.<br><br> 예를 들어 보드게임, 그림 그리기, 요리, 야외활동 등 세상엔 게임 이외에 즐거운 대체안들이 많다는 것을 경험시켜주는 것이 아이가 게임으로부터 분리되는 데 유용한 도움이 될 수 있습니다.",
      text_2:
        "게임을 하고 싶은 마음이 강하게 들 때, 이렇게 다른 활동들을 통해 잠시 주의를 환기해줄 수 있다면, 우리 아이가 순간적으로 충동을 맞닥뜨릴 때 조절하기 조금 더 쉬워질 수 있습니다.",
      img: "tmgm1_42",
      title2: "몸으로 하는 즐거운 게임을 알려주세요.",
      text_3:
        "야외에서 물리적 활동을 즐길 수 있는 게임도 아이들에게 좋은 옵션입니다. 축구, 농구 등 무궁무진한 활동이 가능하며, 이를 통해 아이들은 운동 능력과 팀워크를 향상시킬 수 있습니다.",
      text_4:
        "아이들의 창의력을 키우는 게임도 매우 중요합니다. '레고', '퍼즐'과 같은 게임은 아이들의 상상력과 문제 해결 능력을 발전시킵니다.",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_tmgm1_5",
      title1: "게임을 많이 하는 경우 아이의 내면을 헤아려보세요.",
      text_1:
        "우리 아이가 지나치게 게임을 많이 한다고 생각이 들면, 아이의 내면이 어떤지 고민해 볼 필요가 있습니다.<br><br> 부모님과의 갈등, 학업 스트레스, 또래 관계 문제 등과 같은 이유로, 혹시 현실에서 도피하기 위한 수단으로서 아이가 게임을 대하고 있지는 않은지 고려해 보세요.",
      text_2:
        "아이에게 채워지지 않는 욕구가 있지는 않은지 부모님께서 심층적인 대화를 이끌어 보는 것이 좋습니다. 만약 아이와 대화가 어렵다면 전문가의 도움을 받아보는 것도 좋은 방법입니다.",
      img: "tmgm1_52",
      title2: "온라인 안전에 대한 교육이 필요해요.",
      text_3:
        "게임을 온라인으로 즐기는 경우, 부모는 온라인 안전에 대한 교육을 제공해야 합니다. 아이를 온라인 위험으로부터 보호하고 올바른 온라인 행동을 가르쳐야 합니다.",
      text_4:
        "아이들에게 개인 정보를 절대로 공유하지 말라고 가르쳐주세요. 온라인에서는 개인 정보가 유출될 수 있으므로, 아이들은 실명, 주소, 학교 정보 등을 온라인에서 공개하지 않아야 합니다.",
    },
  ],
  Inform: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_rmdr1_1",
      title1: "아이의 학교 생활에 관심을 주세요.",
      text_1:
        "알림장을 통해 아이의 학교에서 어떤 일이 있었는지, 과제나 학교 행사에 관한 정보를 얻을 수 있어요. 알림장은 우리가 아이의 학교 생활을 지원하고 함께 참여할 수 있는 좋은 방법이에요. 함께 알림장을 확인하고 아이의 성장과 학습 과정을 지켜보도록 해요.",
      text_2:
        "학교에서 배포되는 알림장 혹은 알림장 애플리케이션을 꼭 확인해주세요.",
      img: "rmdr1_12",
      title2: "내일 학교 생활을 아이와 함께 준비해요.",
      text_3:
        "알림장을 통해 내일 가져갈 준비물, 숙제를 확인해보세요. 내일 가져갈 가방을 아이가 챙기게 하고, 잘 챙겼는지 지켜봐주세요.",
      text_4:
        " 부모가 학교 생활을 함께 지원하고 관심을 가지는 것은 아이에게 큰 힘이 됩니다. 아이가 무엇을 배우고 성장하는지를 확인해주세요.",
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_rmdr1_2",
      title1: "아이가 물건을 빠뜨리고 와요.",
      text_1:
        "이가 물건을 빠뜨렸을 때 먼저 아이를 진정시켜주세요. 아이가 불안해하거나 자책감을 느낄 수 있으므로 부모는 차분하고 안정적인 태도로 대화를 시작해야 합니다. 그리고 물건을 어떻게 빠뜨렸는지, 어디서 놓고 왔는지에 대한 이야기를 나누는 것이 도움이 됩니다.",
      text_2:
        "아이가 어떤 물건을 빠뜨렸는지 파악하고, 그 물건을 찾는 데 도움을 주세요. 함께 아이의 물건을 찾아보며 어떻게 빠뜨렸는지 이해하고 다음에는 이러한 일이 없도록 도와주세요. <br>아이가 물건을 빠뜨렸을 때 자신을 비난하지 않도록 도와주세요. 실패는 누구에게나 일어날 수 있는 일이며, 그것을 통해 더 배울 수 있는 기회임을 강조하세요.",
      img: "rmdr1_22",
      title2: "구체적인 대응책을 생각해봐요.",
      text_3:
        "물건을 빠뜨리는 일이 반복된다면, 아이와 함께 이를 방지하기 위한 조치 계획을 수립하세요. 더 주의깊게 물건을 챙길 수 있는 방법을 고민해보고 실행해보세요. 아이가 이동하기 전에 챙겨야 할 물건에 대한 체크리스트를 만들어둬도 좋아요.",
      text_4:
        "물건을 빠뜨리는 일이 자주 발생한다면, 아이에게 가방이나 학습 장소 등을 정리하고 물건을 두는데 도움을 주는 실용적인 조언을 제공하세요.",
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_rmdr1_3",
      title1: "아이가 숙제를 빠뜨렸어요.",
      text_1:
        "아이에게 숙제를 빼먹었을 때 비난하거나 벌을 주는 대신, 이해와 지원을 제공하세요. 아이에게 ",
      text_2:
        "아이와 함께 숙제를 어떻게 해결할 수 있을지 물어보고, 함께 해결책을 찾아보세요. 아이가 스스로 문제를 해결하는 데 도움을 주는 것이 중요합니다.",
      img: "rmdr1_32",
      title2: "숙제 시간을 정해서 아이 숙제를 도와줘요.",
      text_3:
        "아이가 숙제를 빠트리는 이유 중 하나는 시간 관리나 계획 능력이 부족할 수 있습니다. 일정을 짜고 계획을 세우는 데 도움을 주세요.<br> 일정한 숙제 시간을 정하여 아이가 언제 숙제를 할지 알 수 있도록 도와주세요.",
      text_4:
        "만약 숙제 빠뜨리기가 계속되는 경우, 아이의 선생님과 협력하여 문제를 해결하는 방안을 모색해보세요. 선생님의 지도와 지원이 도움이 될 수 있습니다.",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_rmdr1_4",
      title1: "아이의 물건을 스스로 관리할 수 있게 도와주세요.",
      text_1:
        "아이에게 자기 물건을 관리하는 책임을 부여하세요. 가방이나 물건의 위치를 일관되게 정해두고 아이 스스로 관리하도록 유도하세요.",
      text_2:
        "아이에게 물건을 잃거나 빠뜨릴 경우의 불편함을 이해시키고, 물건을 잘 챙기면 어떤 이점이 있는지 강조해주세요.",
      img: "rmdr1_42",
      title2: "필요하다면 다양한 도구를 활용해봐요.",
      text_3:
        "아이가 자주 사용하는 물건들에 대한 체크리스트를 만들어보세요. 아이는 체크리스트를 통해 어떤 물건을 챙겨야 하는지 쉽게 확인할 수 있습니다.",
      text_4:
        "아이가 물건을 잘 챙겼을 때 칭찬하고 긍정적인 피드백을 제공하세요. 아이가 노력하고 성공했을 때 자신감을 얻을 수 있습니다.",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_rmdr1_5",
      title1: "아이에게 학교 생활을 물어봐요.",
      text_1:
        "아이와 학교 생활에 대한 대화를 가지세요. 아이의 하루를 물어보고, 학교에서 무엇을 배웠는지, 친구들과의 관계는 어떤지 들어주세요.",
      text_2:
        "부모의 관여는 아이의 학교 생활과 학습에 긍정적인 영향을 미칠 수 있으며, 아이의 성장과 발전을 지원하는 데 중요한 역할을 합니다.",
      img: "rmdr1_52",
      title2: "아이에게 가장 좋은 선생님이 되어주세요.",
      text_3:
        "아이가 숙제나 학습에서 도움을 필요로 할 때, 부모는 학습 도우미 역할을 해주세요. 숙제나 공부에 어려움을 겪는 경우, 부모는 질문에 답하고 필요한 자료나 책을 찾아주는 등 학습에 지원을 제공하세요. 아이가 학습 과정에서 도움을 받을 때 더 자신감을 가질 수 있습니다.",
      text_4:
        "아이에게 학교 생활에 대한 자신감을 심어주세요. 부모의 조그마한 노력이 자신있는 아이를 만들게 됩니다.",
    },
  ],
  GivePhone: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_phne1_1",
      title1: "자기 전 핸드폰 사용이 아이에게 미치는 영향",
      text_1:
        "성장하는 아이들에게 숙면은 매우 중요합니다. 잠이 들기 전 핸드폰 사용은 어두운 곳에서 근거리에서 화면을 봄으로써 눈 깜빡임 수가 줄어들어 안구질환을 유발하고, 생체리듬을 깨뜨려 수면의 질을 떨어뜨리는 부정적인 효과를 가져옵니다.",
      text_2:
        "또한 핸드폰의 콘텐츠가 자극적인 성격을 띠는 경우가 많기 때문에 뇌가 잠에서 깨어 수면을 돕는 멜라토닌 등의 호르몬 분비를 지연시켜 수면의 질을 떨어뜨리게 되지요. 이는 다음 날 아침 기상에도 영향을 주기 때문에 잠자리에는 핸드폰을 가지고 들어가지 않는 것이 좋습니다.<br><br> 이런 습관 형성을 위해 부모님은 어떻게 해주면 좋을까요?",
      img: "phne1_11",
      title2: "잠이 들기 전에 핸드폰을 쥐고 있지 않게 해주세요.",
      text_3:
        "집에서 핸드폰을 사용하는 시간을 정해보세요. 늦은 밤까지 핸드폰을 하는 것은 아이의 성장에 좋지 않습니다.",
      text_4:
        "스마트폰 사용을 잠들기 몇 시간 전에 중단하면 어린이가 정기적이고 편안한 수면을 유지할 수 있습니다. 아이와 함께 이야기하여, 잠들기 전 스마트폰 사용을 지양해보세요.",
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_phne1_2",
      title1: "핸드폰 사용에 대한 규칙을 세워보세요.",
      text_1:
        "어린 뇌는 계속해서 발전하고 있으며, 스마트폰 화면을 오랫동안 바라보는 것은 뇌 발달에 부정적인 영향을 미칠 수 있습니다. 특히, 어린이의 뇌가 아직 성숙하지 않았을 때 이러한 영향이 더 큽니다.",
      text_2:
        "스마트폰 사용에 대한 규칙을 만들고, 사용 시간을 일정한 시간으로 제한하는 것을 고려하는게 좋습니다. 예를 들어, 하루에 몇 시간 동안 사용할 수 있는지 정해보세요.",
      img: "phne1_21",
      title2: "가족이 함께 핸드폰 사용 시간을 정하고 지켜보세요.",
      text_3:
        "아이들은 부모의 행동을 즐겁게 따라한답니다. 부모님과 아이가 집에서의 핸드폰 사용 시간과 규칙을 정해보세요. ",
      text_4:
        "가족 구성원 모두가 스마트폰 사용 시간을 함께 정해보면 어떨까요? 가족의 건강과 상호작용에도 도움을 줄 것 같아요. 모두가 함께 시간을 정하고 서로의 활동과 대화에 더 집중할 수 있게 해줄 거에요.",
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_phne1_3",
      title1:
        "핸드폰 때문에 어려움이 있다면, 자녀 보호 애플리케이션을 사용해보세요.",
      text_1:
        "많은 아이들이 스마트폰 사용으로 어려움을 겪습니다. 필요하다면, 시중에 출시되어 있는 자녀보호 애플리케이션을 사용해보세요. 스마트폰 사용 시간을 제한할 수 있습니다.",
      text_2:
        "자녀 보호 애플리케이션 사용 전에 꼭! 아이와 충분한 대화를 해보세요. 강제적인 제한은 아이에게 오히려 반감을 줄 수 있습니다. 아이와의 대화를 통해 사용 시간과 제한 기능을 정하시기를 바랍니다. ",
      img: "phne1_31",
      title2: "‘핸드폰 잠금 서랍’을 만들어 함께 실천해보세요.",
      text_3:
        "‘핸드폰 잠금 서랍’ 이란 일정 시간 내에 아이가 핸드폰을 사용하도록 허용하고, 허용한 시간이 끝나면 아이가 스스로 서랍에 핸드폰을 넣어 약속을 지키는 방법입니다. 핸드폰을 그저 금지 시키기보다, ‘핸드폰 잠금 서랍’을 함께 만들며 아이를 설득해보는 방향으로 교육해보세요.",
      text_4:
        "이때, 핸드폰을 사용하는 시간 등에 대해 아이의 의견을 최대한 듣고 반영해서 아이가 함께 규칙을 정한다는 느낌을 전달해주세요. 더불어 부모님은 행동하지 않고 아이에게만 핸드폰 사용 규칙을 강조한다면 아이의 반감이 더 커질 수 있습니다. 온 가족이 함께 실천해 보세요.",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_phne1_4",
      title1: "아이가 사용하는 애플리케이션에 주목해보세요.",
      text_1:
        "많은 부모들이 자녀가 스마트폰을 사용할 때 어떤 앱을 사용하고 있는지 궁금해합니다. 이는 자녀의 안전과 발달을 지원하고 불필요한 위험을 방지하기 위한 중요한 단계입니다.",
      text_2:
        "자녀의 스마트폰 앱 사용에 대해 이야기하면서, 어떤 애플리케이션을 사용하는지 물어보세요. 아이의 관심사와 활동을 이해하면, 더 의미 있는 대화와 활동을 공유할 수 있을 뿐 아니라, 스마트폰 사용에 따른 위험을 최소화할 수 있습니다.",
      img: "phne1_41",
      title2: "아이에게 권할 애플리케이션을 검토해보세요.",
      text_3:
        "스마트폰이 우리 일상에 더욱 통합되면서, 아이들도 디지털 기기를 많이 접하게 되었습니다. 이는, 교육적인 목적으로 활용할 수 있는 큰 기회입니다. 하지만 어떤 앱을 선택해야 할지 결정하는 것은 부모에게 중요한 책임입니다. ",
      text_4:
        "아이의 학습과 개발을 지원하면서 동시에 놀이와 즐거움을 제공할 수 있는 애플리케이션을 찾아보세요. 아이들에게 스마트폰을 통한 교육적인 여정을 흥미롭고 효과적으로 만들어주는 앱이 많이 있을 것입니다.",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_phne1_5",
      title1: "핸드폰 대신 부모님과의 시간으로 가득 채워주세요.",
      text_1:
        "잠자리에 들기 전은 아이의 수면 루틴이 이루어져야 하고, 특히나 부모님과의 정서적인 교류가 아주 필요한 시간입니다. 핸드폰을 사용하는 대신 부모님이 옆에서 그 시간을 채워보는 건 어떨까요?",
      text_2:
        "오늘 하루 가장 즐거운 일은 무엇이었는지, 오늘 하루 속상한 일이 있었는지, 하고 싶었던 말은 없는지 등 대화를 통해 정서적인 교류를 해보세요. 마사지, 스트레칭 등의 신체활동도 좋은 방법 입니다.<br><br> 부모님과의 교류를 통해 아이의 주의가 핸드폰에서 멀어질 수 있도록 노력해 주세요.",
      img: "phne1_51",
      title2: "무엇보다 가족과의 대화가 가장 중요한 때입니다.",
      text_3:
        "아이와의 대화는 그 어떤 교육적인 도구보다도 강력한 힘을 지니고 있습니다. 부모와 자녀 간의 소통은 가족의 건강하고 풍요로운 관계를 형성하고, 아이의 성장과 발달을 지원하는 데 필수적입니다.",
      text_4:
        "부모들은 자녀와의 대화를 존중하고 열린 마음으로 진행하며, 아이의 성장과 발달을 지원하는데 큰 역할을 할 수 있습니다. 아이와의 대화는 가족 관계를 더 깊이 풍요롭게 만들고, 미래의 성공을 위한 토대를 마련하는데 필수적입니다.",
    },
  ],
  WashFoot: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_washF_1",
      title1: "아이가 자신의 신체를 깨끗이 유지해야 하는 이유",
      text_1:
        "신체를 깨끗이 유지하는 것은 건강한 습관을 형성하는 첫 걸음입니다.아이가 자신의 신체에 관심을 가지고 정기적으로 관리함으로써, 건강한 생활 습관을 지속적으로 발전시킬 수 있습니다.  ",
      text_2:
        "또한, 신체를 깨끗이 유지하면 자신을 존중하고 사랑하는 마음을 키우는 데에 도움이 되며, 이는 결국 정신적인 안녕감과 긍정적인 자아 이미지 형성에 기여를 하게 됩니다. ",
      img: "washF_12",
      title2: "질병으로부터 자신을 보호할 수 있게 도와주세요.",
      text_3:
        '"손, 발 등 자신의 신체 부위를 주기적으로 씻으며 감염병 및 질병을 예방할 수 있다는 것을 알려주세요.',
      text_4:
        '"시각적 접근을 기반으로 한 위생교육을 통해 교육의 효과성을 극대화시켜보세요. \n' +
        "세균 로션, 파우더를 묻혀놓은 바닥 위를 걷게 한 후, 블랙라이트를 켜 발을 확인하면 \n" +
        '오염된 부분을 확인할 수 있습니다. 이를 통해 아이는 발 씻기를 실천해야 하는 이유에 대해 명확하게 인지하게 됩니다. "',
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_washF_2",
      title1: "발 씻기도 일상적인 습관이 되어야 해요.",
      text_1: "손 씻기 뿐만 아니라 발 씻기도 일상화되어야 합니다. ",
      text_2:
        "손 뿐만 아니라 발도 일상생활에서 다양한 먼지와 세균에 노출됩니다. 특히, 발바닥에는 땀샘이 많이 있어 적절한 관리가 필요합니다. ",
      img: "washF_22",
      title2: "올바른 발씻기 방법을 지도해주세요! ",
      text_3: "올바른 방법으로 발 씻기를 실천할 수 있게 도와주세요. ",
      text_4:
        '"첫 번째, 흐르는 물로 발을 충분히 적셔주세요. 이때, 뜨거운 물보다는 따듯한 물을 사용하는 것이 좋습니다.<br/>' +
        "두 번째, 발에 비누나 세정제를 적당량 발라주세요. 특히, 발바닥, 발끝, 발가락 사이, 발뒷꿈치를 중점적으로 씻어주세요.<br/>" +
        "세 번째, 손톱 솔로 발바닥과 발끝을 깨끗이 씻습니다. <br/>" +
        "네 번째, 손으로 발을 마사지하듯이 씻어주세요. 특히, 발뒷꿈치는 물과 세정제가 잘 쌓일 수 있으므로 마사지하여 깨끗이 씻어주는 것이 좋습니다. <br/>" +
        "다섯 번째, 물로 깨끗이 헹구고 타월로 수분을 제거해주세요.<br/>" +
        "마지막으로, 보습 크림이나 로션을 사용하여 피부를 촉촉하게 유지해주세요. <br/>" +
        '"',
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_washF_3",
      title1: "서로의 발을 씻어주세요. ",
      text_1: "가족과 함께 서로의 발을 씻어주는 경험을 해보는 건 어떨까요? ",
      text_2:
        "\"일주일에 한번 정도 '서로의 발을 씻어주는 날'로 정해서 실천해보세요.\n" +
        '함께 발을 씻는 과정은 자연스럽게 소통과 대화를 촉진할 수 있습니다. 가족 구성원들끼리 이야기를 나누며 서로의 일상을 공유하면서 소통의 기회를 마련할 수 있습니다."',
      img: "washF_32",
      title2: "가족과 함께하며 유대감을 형성할 수 있습니다. ",
      text_3:
        "발을 씻는 과정은 서로에 대한 배려와 돌봄의 표현으로 이어질 수 있습니다. 가족끼리 서로 도움을 주고 받는 경험은 가족 유대감을 강화시키는 데 도움이 됩니다.",
      text_4:
        "발을 씻는 것을 가족끼리 놀이와 즐거움의 일환으로 만들 수 있습니다. 특히 아이들에게는 색다른 활동으로서 즐거움과 호기심을 제공할 수 있습니다.",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_washF_4",
      title1: "습관 형성을 위해 매일 같은 시간에!",
      text_1:
        "습관을 일상화하기 위해서는 몇 가지 중요한 요소가 있습니다. 그 중 하나가 일관성 입니다.",
      text_2:
        "즉, 일관된 루틴을 만들어야 합니다. 예를 들어, 매일 같은 시간에 특정 습관을 수행하도록 노력하세요. 뽀미와 함께 정해진 시간에 발을 씻게 도와주세요.",
      img: "washF_42",
      title2: "뽀미와 같이 발을 씻어봐요! ",
      text_3:
        "언제 발을 씻어야 하는지 잊지 않도록 뽀미를 사용하세요. 뽀미의 목소리를 통해 수행해야 할 시간을 상기시킬 수 있습니다.",
      text_4:
        "습관을 일상화하는 것은 시간과 노력이 필요한 작업이지만, 이러한 요소들을 활용하면 성공할 확률을 크게 높일 수 있습니다.",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_washF_5",
      title1: "스스로 발을 씻고 왔을 때 충분히 칭찬해 주세요.",
      text_1:
        '"아이가 스스로 발을 씻고 왔다면 그것이 당연한 것이 아닌 아이의 자기 주도 능력이 향상되었다고 생각해 주세요.\n' +
        '아이의 입장에서는 당연하지 않은 일을 부모님의 말씀을 듣고 스스로 노력해 실천 한 것이나 다름이 없습니다."',
      text_2:
        '"아이의 이러한 성공 경험들은 지금은 비록 사소해 보이지만 아이가 건강하게 성장하는데 소중한 자양분이 된답니다. \n' +
        '아이의 노력을 충분히 인정해주고 칭찬해 주세요!"',
      img: "washF_52",
      title2: "부모의 칭찬은 긍정적 강화로 작용합니다.",
      text_3:
        "아이가 원하는 행동을 반복하도록 유도하고 강화하는 데 칭찬은 매우 큰 도움이 됩니다. 즉, 어떤 행동이 원하는 방향으로 나아가도록 사람들을 동기부여하고 강화하는 데 사용됩니다.",
      text_4:
        '"하지만 너무 과도한 칭찬은 효과가 반대로 나타날 수 있으므로, 아이의 노력을 정확하게 인식하고 구체적으로 칭찬해주는 것이 중요합니다.',
    },
  ],
  SleepBed: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_slbd_1",
      title1: "스스로 하기의 중요성 ",
      text_1:
        '"초등학교 초기 적응으로 인해 힘든 아이들, 왜 그런 걸까요?\n' +
        '유치원과 초등학교 모두 단체 생활이기는 하지만, 개별적인 지원 정도에 있어서는 차이가 있습니다. 유치원의 경우, 아이가 스스로 하기 힘든 경우 교사가 즉각적으로 도와주는 반면 초등학교는 교사의 도움 없이 스스로 해내야 하는 것들이 많습니다.  "',
      text_2:
        '"유아기에 부모 또는 교사의 지원 정도가 높다보면 초등학교에 입학하고 극심한 혼란을 느낄 수 있습니다. \n' +
        "'얼마 전까지 부모님, 선생님이 도와줬는데, 지금은 왜 안 도와주는 거지?'\n" +
        '또한, 스스로 못하는 자신을 다른 친구와 비교하게 되어 좌절감을 느끼고, 결국 자아존중감이 낮아질 수 있습니다.  "',
      img: "slbd_12",
      title2: "초등학교 준비를 위해 필요한 과정",
      text_3:
        "\"따라서 초등학교 입학를 위해 '스스로 하기'는 꼭 필요한 준비과정입니다.  \n" +
        '유아들에게 유치원과 초등학교의 공통점과 차이점에 대해 이야기해주시면서 스스로 해보는 것의 중요성을 느낄 수 있도록 해주세요. "',
      text_4:
        '"초등학교에 대한 두려움보다는 기대감을 느낄 수 있게 해주세요. 초등학생이 된다는 것에 대한 자부심을 느낄 수 있게 도와주는 건 어떨까요? \n' +
        '""네가 초등학생이 되면 스스로 할 수 있는 게 더 많아질 거야."""',
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_slbd_2",
      title1: "잠자리 준비과정이 필요한 이유",
      text_1:
        "잠자리를 적절하게 준비하는 과정은 편안하고 질 좋은 수면을 위해 중요합니다. ",
      text_2:
        "잠자리 준비과정을 통해 편안하고 안정적인 잠자리 분위기를 조성하고 건강하고 질 높은 수면을 유도할 수 있습니다.",
      img: "slbd_22",
      title2: "잠자리를 준비하는 과정의 주요 단계",
      text_3:
        '"아래는 잠자리를 준비하는 과정의 주요 단계입니다.  <br/>' +
        "1. 편안한 의류 착용하기: 편안하고 통기성이 좋은 의류를 착용하고 너무 따뜻하거나 추운 의류는 수면을 방해할 수 있습니다.  <br/>" +
        "2. 편안한 침구 선택하기 <br/>" +
        "3. 조용하고 안전한 환경 조성하기 <br/>" +
        '4. 어두운 조명 활용하기 "',
      text_4:
        '"잠자리를 준비하는 과정은 부모의 도움이 필요합니다. \n' +
        '따라서 부모님께서는 아이가 편안함을 느끼는지에 대해 주의 깊게 살피고, 질 좋은 수면을 위한 환경을 조성해줄 필요가 있습니다. "',
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_slbd_3",
      title1: "잠자리를 준비하는 모델링을 보여주세요! ",
      text_1:
        '"해도 해도 끝이 없는 집안일, 조금이라도 알아서 해주면 얼마나 좋을까? 부모님이시라면 한 번쯤은 이런 질문을 해보시지 않았을까 싶습니다.',
      text_2:
        '"잠자리를 준비할 것을 요구하기 전에 부모님께서 먼저 본보기가 되어 잠자리를 준비하는 모습을 보여주세요. \n' +
        '어느 순간 부모님을 따라 자신의 잠자리를 준비하는 우리 아이의 모습을 볼 수 있을 것입니다. "',
      img: "slbd_32",
      title2: "아이와 함께 저녁 루틴 만들기",
      text_3:
        '"가정 내에서 아이들에게 루틴을 만들어주는 것은 아이들의 건강한 사회성, 정서 발달에 도움이 됩니다. 아이들의 경우 관계 또는 마주하는 상황들이 예측 가능하였을 때 안정감을 느끼게 됩니다.\n' +
        '잠자리에 들기 전에 함께 책을 읽는 습관 혹은 숙면에 도움이 되는 스트레칭을 하는 것도 좋은 방법입니다."',
      text_4:
        '"저녁 루틴을 형성하게 된다면 아이들은 루틴을 하고 난 후에는 잠자리에 들 시간이라는 것을 스스로 학습할 수 있게 될 것입니다. <br/><br/>' +
        '루틴을 정할 때에는 아이들이 직접 원하는 루틴을 정할 수 있도록 충분한 대화를 통해 만들어주세요."',
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_slbd_4",
      title1: "수면 전 릴렉싱 활동을 해보세요. ",
      text_1:
        "릴렉싱 활동은 수면의 질을 향상시키는 데 기여합니다. 편안한 마음 상태와 긴장 해소는 깊고 휴식이 풍부한 수면을 유도할 수 있습니다. ",
      text_2:
        "또한, 불안과 우울 등과 같은 부정적인 감정을 완화시키는 데에도 도움이 됩니다. ",
      img: "slbd_42",
      title2: "수면 전 오늘 있었던 일에 대해 공유하는 시간을 가져보세요.",
      text_3:
        "수면 전 시간은 가족과 함께 일상적인 경험과 소식을 나눌 수 있는 좋은 기회입니다. ",
      text_4:
        "일상적인 이야기를 공유하고 소통함으로써 가족 구성원들은 서로의 삶에 대해 더 많이 알게 되고, 서로에 대한 관심도를 높일 수 있습니다. ",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_slbd_5",
      title1: "안정된 수면 환경 조성",
      text_1:
        "수면 전 가족과 함께하는 시간은 안정된 수면 환경을 조성하는 데 도움이 됩니다. ",
      text_2:
        "안정된 가정 분위기와 따뜻한 대화는 수면에 필요한 평온한 상태를 조성할 수 있습니다. ",
      img: "slbd_52",
      title2: "주말에도 일관되게 실천해보세요. ",
      text_3: "습관형성에 있어 가장 중요한 것은 일관성입니다. ",
      text_4:
        "평일 뿐만 아니라 주말에도 잠자리 준비하기를 실천할 수 있도록 도와주세요. ",
    },
  ],
  Shoes: [...shoes],
  WaterBottle: [...spoon],
  Breakfast: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_seat1_1",
      title1: "규칙적인 아침식사의 중요성",
      text_1:
        "아침식사는 하루를 시작할 에너지를 불어넣어 줍니다. 특히 성장하는 아이들에게 아침식사는 잠들었던 신체를 깨우고, 오전에 활동할 에너지를 공급해 줄 뿐만 아니라 아이의 학습능률을 향상시키는 역할을 하지요.<br><br> 만약 아침밥을 먹지 않으면 아이도 모르게 신경이 예민해지거나 피곤함을 느낄 수 있습니다. ",
      text_2:
        "또한 점심을 과식하거나 과도한 간식 섭취로 인해 규칙적인 식사가 어려워지는 악순환을 경험할 수도 있습니다.<br><br> 그렇다면 아이의 규칙적인 아침식사를 위해 부모님이 어떻게 도움을 줄 수 있을까요?",
      img: "seat1_12",
      title2: "부모님께서 아이와 함께 아침식사를 해 주세요.",
      text_3:
        "하루 중 오전이 가장 분주한 시간일 수 있지만 그럼에도 불구하고 아이와 함께하는 식사 시간을 마련해 주시는 것이 좋습니다.<br><br> 부모님은 다른 볼 일을 보면서 아이에게만 앉아서 밥을 먹으라고 한다면 아이가 부모님의 지시를 따르지 않을 확률이 더 높겠지요.",
      text_4:
        "함께 아침식사를 하며 “오늘 어떤 하루가 되면 좋겠어?”, “오늘은 가장 기대되는 일이 뭐야?” 등의 기분 좋은 대화로 아이의 하루를 함께 시작해 주시면 좋습니다.",
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_seat1_2",
      title1: "약속된 시간 동안만 밥을 먹을 수 있도록 해주세요.",
      text_1:
        "식사 시간을 미리 약속해두고 그 시간 동안만 식사가 가능하다는 것을 아이에게 알려주세요. 그리고 약속된 식사 시간이 지날 경우 아이가 아직 다 먹지 못했더라도 식탁을 치우는 것이 좋습니다.<br><br> 또한 약속시간 내에 식사를 하지 않으면 다음 식사 시간까지 간식을 먹을 수 없다는 것도 아이에게 인지시켜주는 것이 좋습니다.",
      text_2:
        "성장하는 아이를 생각하면 배고플 때마다 챙겨주고 싶다는 생각이 드실 수 있지만 규칙적인 식사습관이 아이의 자기조절 능력과 직결될 만큼 중요하다는 것 또한 기억해 주세요.",
      img: "seat1_22",
      title2: "식사 시간에 미디어 혹은 모바일 사용은 금물입니다.",
      text_3:
        "식사 시간의 미디어 사용은 아이가 식사의 집중하지 못할뿐더러 특히 아침의 생활리듬이 모두 깨지는 부정적인 영향을 가져옵니다.",
      text_4:
        "또한 아이가 식사에 집중하지 못하게 되어 배가 불러오는 느낌을 느끼기도 어렵게 되고 밥 먹는 재미를 느끼기 어려워질 수도 있습니다.<br><br> 식사 시간에는 부모님과 즐거운 이야기를 나누며 식사에 집중할 수 있도록 도와주세요.",
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_seat1_3",
      title1: "아이가 밥을 먹지 않으려고 해요. 어떻게 하죠?",
      text_1:
        "아이가 밥을 먹지 않는 상황은 부모들에게 익숙한 문제 중 하나입니다. 아이가 밥을 먹지 않을 때, 먼저 그 이유를 이해하려 노력하세요. 스트레스, 불량한 일상 습관, 식욕 감퇴 등 여러 이유가 있을 수 있습니다. 아이의 상태와 감정을 듣고 이해하는 것이 시작입니다.",
      text_2:
        "아이들에게 음식 선택의 기회를 주세요. 식사 메뉴를 고르거나 만들 때 아이들이 참여하면 음식에 대한 흥미를 높일 수 있습니다.",
      img: "seat1_32",
      title2: "다 같이 식사를 해보세요.",
      text_3:
        "부모는 아이들의 모범이 됩니다. 아침이라 바쁘겠지만, 가족들이 함께 식사에 참여하도록 합니다. 아이에게 좋은 자극이 될거예요. 건강한 식습관을 형성하기 위해, 가족 모두 함께 식사를 해보세요.",
      text_4:
        "그리고, 식사 시간을 일정하게 유지하세요. 규칙적인 식사 시간은 아이들에게 안전감을 주고, 식욕을 유지하는 데 도움이 됩니다.",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_seat1_4",
      title1: "아이가 편식을 해요. 어떻게 하죠?",
      text_1:
        "우리 아이들이 편식을 할 때, 부모로서 걱정이 될거예요. 우리 아이들의 식사 선호도는 다양합니다. 편식은 단순한 식성의 문제일 수도 있지만, 때로는 아이의 감정과 상태에 영향을 받기도 합니다. 그러므로 먼저 그 이유를 이해하려 노력하세요. 아이의 선호도와 편식 패턴을 관찰하고 이해하는 것이 시작입니다.",
      text_2:
        "식사 시간을 긍정적이고 안락한 경험으로 만드세요. 음식을 강요하지 말고, 아이가 자유롭게 시도하고 즐길 수 있도록 해주세요. 부정적인 압박은 편식을 악화시킬 수 있습니다.",
      img: "seat1_42",
      title2: "아이에게 음식을 선택하게 해주세요.",
      text_3:
        "아이들은 다양한 식성을 가지고 있을 수 있습니다. 어떤 음식을 좋아하고 어떤 음식을 싫어하는 것은 개인의 취향입니다. 이를 인정하고, 아이들이 자신의 식사 습관을 조절하도록 미치는 영향을 줄 수 있습니다.<br><br> 아이들에게 음식 선택의 기회를 주세요. 가게나 냉장고에서 음식을 고를 수 있게 하고, 아이들이 식사 메뉴를 일부 결정할 수 있도록 해주세요. 이는 아이들의 참여와 흥미를 높일 수 있습니다.",
      text_4:
        "편식을 극복하기 위해서는 꾸준한 시도가 필요합니다. 새로운 음식을 시도해보고, 다양한 요리법을 실험해보세요. 아이들이 음식을 습관적으로 거부할 수 있지만, 여러 번 노력하면 변화를 볼 수 있습니다.",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_seat1_5",
      title1: "중요한 것은 하루 세 번의 규칙적인 식사 습관입니다.",
      text_1:
        "아침식사를 포함하여 하루 세 번의 식사 시간 동안 같은 시간에 식사함으로써 아이가 식사시간이라는 것을 자연스럽게 인지할 수 있도록 해주세요.<br><br> 그리고 식사 시간에는 일상과 관련된 이야기를 나누고 “이것 좀 먹어봐”, “왜 이렇게 안 먹니?” 와 같은 잔소리는 최대한 하지 않으시는 것이 좋습니다. ",
      text_2:
        "아이가 너무 심하게 편식하는 경우 안내만 해주시고, 강요하는 대신 아이가 편식하지 않을 수 있도록 다양한 요리법에 조금 더 관심을 가져주시는 것도 방법입니다.",
      img: "seat1_52",
      title2: "부모님도 식사에 꼭 참여해주세요.",
      text_3:
        "부모는 자신이 건강한 식습관을 가지고 모범이 되어야 합니다. 아이들은 부모의 행동을 본떠 따르는 경향이 있으므로, 부모가 다양한 식품을 즐기고 올바른 식사 습관을 보이면 아이들도 그를 따를 가능성이 높습니다.",
      text_4:
        "건강한 식습관은 아이들의 성장과 발달에 중요한 역할을 합니다. 부모가 아이들에게 올바른 식사 습관을 가르치고 모범이 되는 데 기여하면, 아이들은 평생 건강한 식습관을 가질 가능성이 높아집니다.",
    },
  ],
  Brush: [...brush],
  BrushEvening: [...brush],
  Toy: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_toy_1",
      title1: "놀이의 마무리는 장난감 정리하기",
      text_1:
        '"놀이의 시작이 장난감을 선택하는 것이라면 놀이의 마무리는 무엇일까요? <br/>' +
        '놀이의 마무리는 아이가 사용한 장난감을 정리하는 것입니다. "',
      text_2:
        "장난감 정리하기는 자신이 한 것에 대한 책임을 질 수 있게 도와주는 중요한 과정입니다. 아이에게 놀이의 마무리는 자신이 사용한 장난감을 정리하는 것임을 명확하게 알려주세요.",
      img: "toy_12",
      title2: "정리를 해야 하는 이유에 대해 구체적으로 이야기해주세요. ",
      text_3:
        '"아이가 스스로 정리를 실천할 수 있게 돕기 위해서는 \n' +
        '장난감을 정리해야 하는 이유에 대해 알려주세요."',
      text_4:
        '"아이가 이해할 수 있는 언어로 설명하며 장난감 정리하기를 유도해주세요. \n' +
        '3세 유아라면 ""장난감도 우리처럼 집이 있대. 그래서 우리처럼 즐겁게 논 후에는 집으로 돌아가야 하는데, 네가 집에 가는 걸 도와줄 수 있겠어?""라고 말하며 장난감 정리하기를 유도해주세요. <br/>' +
        '4,5세 유아라면 먼저 ""놀이 후에는 왜 장난감들을 정리해야 할까?"", ""장난감을 정리하지 않으면 어떤 일이 벌어질까?""라고 질문하여 정리해야 하는 이유에 대해 생각해볼 수 있도록 하고, 이후 ""장난감을 정리해야 다음에 놀이할 때, 네가 가지고 놀고 싶은 장난감이 어디 있는지 알고 쉽게 찾을 수 있어.""라고 말하며 정리해야 하는 이유에 대해 구체적으로 설명해주세요. "',
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_toy_2",
      title1: "아이와 함께 장난감 분류기준을 정해보세요.",
      text_1:
        '"우리집에 있는 장난감을 어떻게 정리하면 좋을까요? <br/>' +
        "부모님께서 장난감 분류기준을 일방적으로 제시하기 보다는 아이와 함께\n" +
        '장난감 분류기준을 정해보세요."',
      text_2:
        '"수납장 또는 바구니 등에 어떻게 나누어 정리하면 좋을지, \n' +
        "왜 그렇게 나누고 싶은지에 대한 아이의 생각을 들어보세요.",
      img: "toy_22",
      title2: "장난감 정리를 실천하기 위한 준비를 해주세요. ",
      text_3:
        "장난감 정리를 실천하기 위한 준비과정이 필요합니다. 준비과정이 이루어졌을 때, 아이의 실천력을 높일 수 있습니다. ",
      text_4:
        '"아이와 함께 정한 분류기준을 토대로 하여 장난감을 정리할 수 있게 수납장 또는 바구니에 해당 장난감 사진 또는 그림을 붙여 라벨링을 해보세요. <br/>' +
        '이 과정도 아이와 함께하면 더 좋겠죠?"',
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_toy_3",
      title1: "아이가 정리하는 걸 싫어하고 회피하면 어떻게 해야 하나요?",
      text_1:
        "장난감을 정리하는 것은 아이에게 귀찮고 하기 싫은 일일 수 있습니다. 왜냐하면 정리 하는 시간 동안 본인이 원하는 다른 것을 하고 싶기 때문입니다.",
      text_2:
        '"이때, 부모님께서는 화를 내기도 하고 정리하라고 잔소리하며 아이를 컨트롤하려는 욕구가 생겨날 것입니다. "',
      img: "toy_32",
      title2: "정리하는 것을 놀이처럼 즐겁게 할 수 있게 도와주세요. ",
      text_3:
        '"아이가 놀이에는 적극적으로 참여하지만, 장난감 정리하기에는 적극적으로 참여하지 않는다면 <br/>놀이처럼 즐겁게 할 수 있게 도와주세요."',
      text_4:
        '"게임처럼 해보는 건 어떨까요? <br/>' +
        "장난감 종류별로 팀을 나누고 누가 먼저 장난감들의 집을 찾아주는지 게임을 하거나 정해진 시간 내에 장난감 정리하기 미션을 주는 등 아이가 즐겁게 정리할 수 있도록 도와주세요.  \n" +
        "정리 관련 노래를 틀어 즐거운 분위기를 조성하는 건 어떨까요?\n" +
        "정리할 때, 아이가 지루함을 느끼지 않도록 '모두 제자리'와 같은 노래를 틀어 즐거운 분위기 속에서 정리할 수 있게 도와주세요.\"",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_toy_4",
      title1: "장난감 정리하기가 습관화될 수 있게 도와주세요. ",
      text_1:
        '"장난감 정리하기가 습관화되려면 어떻게 해야 할까요? \n' +
        "정리해야 할 장난감의 수가 많은 경우, 아이가 정리하는 것을 힘들어할 수도 있어요. <br/>" +
        '이런 경험이 쌓이다 보면 정리하는 것이 일처럼 느껴져 더이상 하고 싶지 않을 수도 있습니다."',
      text_2:
        '"하나의 놀이를 하다가 다른 놀이를 하고 싶어 이동을 하거나 새로운 장난감을 꺼내게 되는 경우, <br/>' +
        "이전에 사용하던 장난감을 정리할 수 있도록 도와주세요. \n" +
        '만약 정리를 하지 않는다면 나중에 장난감을 정리하는 데에 더 많은 시간과 노력이 필요하게 된다는 것을 알려주세요. "',
      img: "toy_42",
      title2: "부모님의 도움이 필요할 때도 있어요. ",
      text_3:
        '"아이가 장난감을 정리하는 데에 있어 어려움을 겪고 있다면 \n' +
        '아이에게 ""혹시 우리의 도움이 필요하니?""라고 물어보며 부모의 \n' +
        "도움이 필요한 상황인지를 파악해주세요. 아이가 도움을 요청했을 때, \n" +
        "부모님께서는 협력자가 되어 함께 장난감을 정리해주세요.\n" +
        '"',
      text_4:
        '"부모님과 함께 정리함으로써 가족 구성원 간의 협력의 필요성과 가치를 느낄 수 있습니다. \n' +
        "또한, 함께 장난감을 정리하며 소통을 촉진하고, \n" +
        '가족 간의 유대감을 높일 수 있습니다."',
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_toy_5",
      title1: "장난감을 정리하며 분류하기 능력이 향상됩니다. ",
      text_1:
        "장난감을 정리하며 주변을 깨끗이 하는 습관이 형성될 뿐만 아니라 수학 내용 중 '분류하기'를 경험할 수 있습니다. ",
      text_2:
        "아이가 분류기준을 세우고, 한 가지 또는 두 가지 이상의 속성에 따라 장난감을 분류하는 경험을 통해 수학적 능력이 향상됩니다. ",
      img: "toy_52",
      title2: "본인 물건에 대한 책임감을 배우게 됩니다.",
      text_3:
        '"아이들이 장난감 정리에 참여하면 본인 물건에 대한 책임감을 키우고,\n' +
        ' 정돈된 환경을 유지하는 습관을 길러줄 수 있습니다."',
      text_4:
        '"만약 놀이 후에도 장난감을 정리하지 않는 경우가 반복된다면 <br/>' +
        "해당 상황을 가족 구성원 내에서 공론화하여 장난감을 정리하지 않음으로써 생겼던 불편함에 대해 이야기를 나누고, \n" +
        '이를 해결하기 위한 방안을 함께 모색해보세요. "',
    },
  ],
  Change: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_outfit_1",
      title1: "옷의 기능은 무엇일까요? ",
      text_1:
        "옷은 다양한 기능을 수행하며 사람들에게 다양한 혜택을 제공해줍니다. 그 중 가장 중요한 기능은 보호 기능이라고 할 수 있습니다.  ",
      text_2:
        "옷은 신체를 보호하는 동시에 청결을 유지하는 역할을 하고, 추위, 더위, 비, 바람 등 기상 조건으로부터 신체를 보호합니다.",
      img: "outfit_12",
      title2: "아이에게 옷을 갈아입는 이유에 대해 이야기해주세요. ",
      text_3:
        '"장소, 날씨, 계절에 따라 다른 옷을 착용함으로써 편안함과 보호를 유지할 수 있기 때문에 옷을 갈아입어야 한다는 것을 알려주세요. \n' +
        "오늘 입을 옷을 함께 골라보며 이야기하는 건 어떨까요? \n" +
        "<br/>" +
        '""오늘은 눈이 많이 와서 유치원에서 선생님, 친구들이랑 눈놀이를 할 수 있겠다. 이렇게 눈이 많이 오는 날에는 어떤 옷을 입고 가면 좋을까?"" \n' +
        '또는 계절별 옷차림이 담긴 퍼즐을 맞추면서 이야기 해보세요!  "',
      text_4:
        '"또한, 외부 환경에서 오는 먼지와 세균 등이 옷에 머물기 때문에 \n' +
        '옷을 정기적으로 교체하여 위생을 유지할 수 있음을 알려주세요. "',
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_outfit_2",
      title1: "스스로 옷을 갈아입으며 소근육을 발달시킬 수 있어요. ",
      text_1:
        '"옷에는 소근육 발달을 도모할 수 있는 요소들이 곳곳에 숨겨져 있습니다. \n' +
        '어떤 요소들이 숨겨져 있는지 찾아볼까요?"',
      text_2:
        "지퍼 올리고 내리기', '단추 잠그기', '벨크로 붙였다 떼기' 등은 소근육을 발달시킬 수 있는 아주 좋은 기회입니다.",
      img: "outfit_22",
      title2: "아이가 스스로 할 수 있는 기회를 제공해주세요.",
      text_3:
        "따라서 아이가 스스로 옷을 갈아입을 수 있는 기회를 제공해주는 건 어떨까요? ",
      text_4:
        "스스로 할 수 있는 기회를 제공하는 것이 아무 것도 아닌 것처럼 느껴져도 아이의 성장과 발달에 매우 중요한 요소임을 잊지 마세요!",
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_outfit_3",
      title1: "옷 갈아입기에도 단계가 있어요. ",
      text_1:
        '"옷 갈아입기에도 단계가 있다는 이야기 들어보셨나요? \n' +
        '신체 발달 능력에 따라 옷 갈아입기의 수행 수준이 결정됩니다. "',
      text_2:
        "옷 갈아입기를 수행하기 위해서는 정교한 소근육 조작능력과 소근육 힘이 필요합니다. 즉, 소근육 발달이 뒷받침되어야 스스로 옷 갈아입기를 수행할 수 있습니다. ",
      img: "outfit_32",
      title2: "단계적으로 수행할 수 있도록 도와주세요. ",
      text_3:
        '"처음부터 잘 수행해내기는 쉽지 않을 것입니다. 그렇기 때문에 옷 갈아입기를 단계적으로 수행할 수 있도록 도와주어야 합니다.<br/>' +
        "옷 갈아입기 수행 단계를 알아볼까요?  <br/>" +
        "첫 번째, 모델링 보여주기입니다. 어떻게 옷을 갈아입는지에 대한 설명과 함께 모델링을 보여주세요. <br/>" +
        "두 번째, 부모님과 역할 나누어 수행하기입니다. 부모님께서 일정 부분까지 도와주면 이후에는 아이가 스스로 할 수 있도록 도와주세요. <br/>" +
        "세 번째, 언어적으로 설명해주기입니다. 아이가 스스로 옷을 갈아입으며 어려움이 생기는 부분에서 어떻게 해야 하는지에 대해 언어적으로 설명해주세요 <br/>" +
        '네 번째, 혼자서 수행하기입니다. 위 단계를 모두 거치면 아이는 혼자서도 수행할 수 있게 됩니다. "',
      text_4:
        "이처럼 옷 갈아입기 수행 시, 점차적으로 지원 정도를 줄여나갈 필요가 있습니다. ",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_outfit_4",
      title1:
        "스스로 옷 갈아입기를 실천할 수 있는 충분한 시간을 제공해주세요. ",
      text_1:
        '"스스로 옷을 갈아입게 하다가도 시간이 부족하면 대신 해주게 되시죠? \n' +
        '그런 상황이 반복되다 보면 아이가 스스로 옷을 갈아입을 수 있는 기회, 즉 발달할 수 있는 기회가 점점 줄어드게 됩니다. "',
      text_2:
        "그렇기 때문에 외출 전에는 항상 충분한 시간을 가지고 준비를 할 수 있게 도와주세요. ",
      img: "outfit_42",
      title2:
        "가정에서 뿐만 아니라 유치원에서도 스스로 갈아입을 수 있도록 쉽게 입고 벗을 수 있는 옷을 보내주세요. ",
      text_3:
        "습관 형성을 위한 과업 수행은 가정에서부터 유치원까지 이어질 수 있게 해주세요. ",
      text_4:
        '"유치원에서도 스스로 옷 갈아입는 연습이 이루어질 수 있도록 입고 벗기 쉬운 옷을 보내주세요.\n' +
        '입고 벗기 쉬운 옷은 결국 교사의 도움이 뒤따르기 마련입니다. 내 아이의 소근육 발달수준을 파악하고, 혼자서도 수행이 가능한 수준의 옷으로 보내주시는 건 어떨까요?"',
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_outfit_5",
      title1: "옷 갈아입기를 통해 성취감을 느낄 수 있게 해주세요.",
      text_1:
        '"아이가 스스로 옷을 갈아입기를 도전했다면? <br/>' +
        '아이가 성취감을 느낄 수 있게 칭찬해주세요! "',
      text_2:
        '"아이는 자신이 스스로 해낸 것에 대한 긍정적인 피드백을 받으면 성취감, 만족감 등을 느끼게 됩니다. \n' +
        '이런 경험이 쌓이게 되면 자신에 대한 긍정적인 자아 인식과 자신감이 강화될 수 있습니다. "',
      img: "outfit_52",
      title2: "아이가 수행한 것에 대해 구체적으로 칭찬해주세요. ",
      text_3:
        '"그렇다면 어떻게 칭찬해주어야 할까요? \n' +
        '""전에는 지퍼를 끼우기 힘들어 했는데, 연습을 하다 보니 혼자서도 지퍼를 끼울 수 있게 되었네!"""',
      text_4:
        '"아이가 수행한 것에 대해 최대한 구체적으로 칭찬해주세요. <br/>' +
        '구체적인 칭찬은 어떤 행동이나 노력이 어떤 결과를 가져왔는지를 보여줌으로써 간접적인 가르침을 제공합니다. 아이는 성공과 실패의 원인과 결과를 분석하고 미래에 더 나은 방향으로 나아갈 수 있습니다."',
    },
  ],
  WakeBed: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_wkbd_1",
      title1: "스스로 하기의 중요성 ",
      text_1:
        '"초등학교 초기 적응으로 인해 힘든 아이들, 왜 그런 걸까요?\n' +
        '유치원과 초등학교 모두 단체 생활이기는 하지만, 개별적인 지원 정도에 있어서는 차이가 있습니다. 유치원의 경우, 아이가 스스로 하기 힘든 경우 교사가 즉각적으로 도와주는 반면 초등학교는 교사의 도움 없이 스스로 해내야 하는 것들이 많습니다.  "',
      text_2:
        '"유아기에 부모 또는 교사의 지원 정도가 높다보면 초등학교에 입학하고 극심한 혼란을 느낄 수 있습니다. \n' +
        "'얼마 전까지 부모님, 선생님이 도와줬는데, 지금은 왜 안 도와주는 거지?'\n" +
        '또한, 스스로 못하는 자신을 다른 친구와 비교하게 되어 좌절감을 느끼고, 결국 자아존중감이 낮아질 수 있습니다.  "',
      img: "wkbd_12",
      title2: "초등학교 준비를 위해 필요한 과정",
      text_3:
        "\"따라서 초등학교 입학를 위해 '스스로 하기'는 꼭 필요한 준비과정입니다.  \n" +
        '유아들에게 유치원과 초등학교의 공통점과 차이점에 대해 이야기해주시면서 스스로 해보는 것의 중요성을 느낄 수 있도록 해주세요. "',
      text_4:
        '"초등학교에 대한 두려움보다는 기대감을 느낄 수 있게 해주세요. 초등학생이 된다는 것에 대한 자부심을 느낄 수 있게 도와주는 건 어떨까요? \n' +
        '""네가 초등학생이 되면 스스로 할 수 있는 게 더 많아질 거야.""\n' +
        '입학하게 될 초등학교를 방문해보거나 초등학교에 대해 알 수 있는 동화책을 읽어주시는 것도 하나의 방법이 될 수 있습니다. "',
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_wkbd_2",
      title1: "이부자리를 정리해야 하는 이유 ",
      text_1:
        "이부자리는 먼지, 이물질 등이 쌓일 수 있는 공간이기 때문에 주기적인 정리는 위생을 유지하고 건강한 환경을 제공하는 데 도움이 됩니다. ",
      text_2:
        "또한, 깨끗한 이부자리는 편안하고 쾌적한 수면 환경을 조성합니다. 이부자리를 정리하면 잠을 자는 동안 편안함을 느끼고, 질 높은 수면을 유지할 수 있습니다. ",
      img: "wkbd_22",
      title2: "이부자리 정리하는 방법 ",
      text_3:
        "아이가 올바르게 이부자리를 정리할 수 있도록 부모님께서 정리방법을 알려주세요. 아이에게 직접 시범을 보여주시면서 설명해주시면 이해도를 높일 수 있습니다.",
      text_4:
        "다양한 이부자리 정리방법을 고안하여 실천해보세요. 부모님께서 알려준 방법대로만 하기 보다는 가끔 아이가 이불을 접는 새로운 방법을 생각해내어 정리할 수 있는 기회를 제공해주세요. ",
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_wkbd_3",
      title1: "이부자리를 정리하는 모델링을 보여주세요! ",
      text_1:
        "해도 해도 끝이 없는 집안일, 조금이라도 알아서 정리 정돈을 해주면 얼마나 좋을까? 부모님이시라면 한 번쯤은 이런 질문을 해보시지 않았을까 싶습니다.",
      text_2:
        '"정리 정돈을 하는 습관은 보통 “모델링(modelling)”을 통해 학습되고는 합니다. 예를 들어, 물건을 정리하는 부모님의 모습을 보고 아이들이 똑같이 물건 정리를 하는 것을 바로 “모델링 효과”라고 합니다. \n' +
        "이부자리를 정리할 것을 요구하기 전에 부모님께서 먼저 본보기가 되어 이부자리를 정리하는 모습을 보여주세요. \n" +
        '어느 순간 부모님을 따라 자신의 이부자리를 정리하는 우리 아이의 모습을 볼 수 있을 것입니다.  "',
      img: "wkbd_32",
      title2: "깨끗한 우리 가족의 공간 ",
      text_3:
        "아이가 자신의 물건 뿐만 아니라 공간에 대한 책임 의식을 가질 수 있도록 도와주세요. ",
      text_4:
        '"집안일은 부모님이 하는 것이 아닌 가족 구성원 모두가 함께 해야 하는 것임을 인식시켜주세요.\n' +
        ' 이를 통해 아이는 공간에 대한 책임감을 느끼고 집안일에 적극적으로 참여할 수 있게 됩니다. "',
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_wkbd_4",
      title1: "아침마다 전쟁! 전쟁을 멈추게 하려면? ",
      text_1:
        '"가장 먼저, 전쟁의 원인을 파악해보세요. \n' +
        "아침식사 때문인지, 양치질 때문인지, 이부자리 정리하기 때문인지, 정확한 원인을 파악하면 사전에 전쟁을 막을 수 있습니다. \n" +
        "그리고 아이가 아침마다 해당 과업을 수행하기 싫은 이유에 대해서도 물어보세요. \n" +
        '아이의 마음을 읽어주되, 하기 싫은 마음이 들어도 반드시 수행해야 하는 일이 있음을 알려주세요."',
      text_2:
        "가정 내에서 아이들에게 루틴을 만들어주는 것은 아이들의 건강한 사회성, 정서 발달에 도움이 됩니다. 아이들의 경우 관계 또는 마주하는 상황들이 예측 가능하였을 때 안정감을 느끼게 됩니다. 아침에 일어날 때, 스트레칭을 하거나 기분 좋은 인사로 깨우는 것은 좋은 방법입니다.",
      img: "wkbd_42",
      title2: "아이와 함께 아침 루틴을 만들어봐요. ",
      text_3:
        "가정 내에서 아이들에게 루틴을 만들어주는 것은 아이들의 건강한 사회성, 정서 발달에 도움이 됩니다. 아이들의 경우 관계 또는 마주하는 상황들이 예측 가능하였을 때 안정감을 느끼게 됩니다. 아침에 일어날 때, 스트레칭을 하거나 기분 좋은 인사로 깨우는 것은 좋은 방법입니다.",
      text_4:
        "아침 루틴을 형성하게 되면 아침에 일어나서 자신이 무엇을 수행해야 하는지에 대해 알고 스스로 실천할 수 있게 됩니다. 루틴을 정할 때에는 아이들이 직접 원하는 루틴을 정할 수 있도록 충분한 대화를 통해 만들어주세요.",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_wkbd_5",
      title1: "규칙적인 생활 패턴, 성공을 위한 지름길 ",
      text_1:
        "부와 성공에 대한 책들을 보면 '무언가를 지속해서 반복하는 것'이 중요하다고 말합니다. 세계에서 성공한 사람들의 이야기를 담은 책 '타이탄의 도구들' 에서는 '승리하는 아침을 만드는 5가지 습관'을 제시하고 있습니다.  ",
      text_2:
        '"그 다섯 가지 습관은 엄청난 것이 아닌 매우 단순한 것이었습니다. \n' +
        "첫 번째, 명상하기, 두 번째, 차 마시기, 세 번째, 몸을 깨우는 동작 반복하기, 네 번째, 일기 쓰기, 마지막은 바로 '잠자리 정리하기'였습니다.  \"",
      img: "wkbd_52",
      title2: "잘 못해도 비난은 금물!",
      text_3:
        '"완벽하게 해내는 것이 중요할까요?\n' +
        "완벽하게 해내는 것보다 더 중요한 것은 바로 인내심을 가지고 끝까지 해내는 것입니다. \n" +
        '따라서 아이가 완벽하게 해내지 못했다고 해서 비난하기 보다는 스스로의 힘으로 끝까지 해낼 수 있게 응원해주시고 격려해주세요. "',
      text_4:
        '"그러다보면 어떤 어려움에 부딪치더라도 포기하지 않고 계속해서 노력하며 \n' +
        '목표를 향해 나아가는 힘이 생길 수 있습니다. "',
    },
  ],
  WithBook: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_book1_1",
      title1: "꾸준한 독서가 아이에게 미치는 영향",
      text_1:
        '"책은 어휘력, 독해력, 집중력과 인내력, 학습 성과 향상과 더불어 다양한 지식과 지혜를 얻어갈 수 있는 유용한 도구입니다. <br/><br/>' +
        '특히 아이의 독서의 경우, 교과 학습에서 문제를 이해하고 분석하는 것에 바탕이 되는 중요한 역할을 합니다."',
      text_2:
        '"그리고 나아가 책은 양질의 내용을 통해 아이들이 다양한 지식과 지혜를 자연스럽게 습득할 수 있도록 도와줍니다. <br/><br/>' +
        '그렇다면 스스로 책 읽는 아이로 성장하기 위해서 부모님이 어떻게 도와주면 좋을까요? "',
      img: "book1_12",
      title2: "재밌고 쉬운 책으로 독서를 시작하도록 도와주세요.",
      text_3:
        '"초등학교 저학년의 아이에게는 무엇보다 책 읽는 것이 놀이처럼 느껴질 수 있도록 도와주어야 합니다.<br/><br/>' +
        '큰 서점 내 아동 서재의 아이가 좋아하는 분야 (예, 동물 등) 에 데려가서 좋아하는 책을 고르도록 해주세요. 처음에는 만화도 좋습니다."',
      text_4:
        '"무엇보다 아이들이 책에 재미를 붙이고 자연스럽게 독서 시간이 늘어나는 것이 중요합니다.<br/><br/>' +
        '부모님의 역할은 아이가 고른 책이 어휘, 내용 등의 난이도가 적합한지를 판단하는 정도로 충분합니다."',
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_book1_2",
      title1: "책의 내용을 바탕으로 아이와 대화를 나누세요.",
      text_1:
        '"책을 읽는 것이 익숙하지 않은 아이들은 내용을 제대로 이해하지 못하고 글자를 읽는 수준의 독서를 할 수도 있습니다.<br/><br/>' +
        '이 경우 아이가 책을 읽으며 줄거리의 내용을 이해할 수 있도록 부모가 질문을 통해 도움을 줄 수 있습니다."',
      text_2:
        '"예를 들어, 아이에게 “주인공이 어떤 행동을 했지?”, “주인공이 왜 그런 행동을 했지?” 등의 질문을 하고, 아이가 이에 답을 생각해보는 과정 자체가 도움이 될 수 있습니다. <br/><br/>' +
        '그리고 더 나아가 “~라면 어땠을까?”, “~라면 어떤 생각이 들었을까?” 등의 아이의 관점에서 더 확장해서 생각해볼 수 있는 질문도 도움이 됩니다."',
      img: "book1_22",
      title2: "책 이야기를 아이를 통해 들어보세요.",
      text_3:
        "아이가 책 내용을 부모에게 설명할 수 있는 기회를 주세요. 완전히 다른 이야기를 할 수도 있습니다. 하지만 이야기를 처음부터 끝까지 이야기해볼 수 있게 도와주세요. 아이 스스로 이야기를 구성해 볼 수 있는 기회가 됩니다.",
      text_4:
        '"어린 아이들을 위해서는 동화책과 그림책을 활용하세요. 아름다운 그림과 이야기가 아이들의 상상력을 자극할 것입니다.<br/><br/>' +
        '부모님은 아이들이 책을 읽고 상상력을 키울 수 있도록 도울 수 있습니다. 책은 아이들에게 지식을 넘어, 상상력과 창의력을 키우는 소중한 도구입니다."',
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_book1_3",
      title1: "부모님이 아이와 함께 책을 읽어주세요.",
      text_1:
        '"결국에는 책이 익숙한 아이들이 책을 더 많이 읽게 됩니다. 이를 위해 가장 좋은 방법은 부모님이 아이와 함께 책을 읽는 것입니다.<br/><br/>' +
        '부모님께서 꾸준히 정해진 시간에 아이를 데리고 책을 읽어주세요. 아이에게 책을 읽어주다가 일부는 아이 스스로 책을 읽도록 유도하는 것도 좋은 방법입니다."',
      text_2:
        '"책을 통해 부모님과 자연스럽게 소통하고, 함께 책을 읽음으로써 아이가 부모님의 온기를 느낄 수 있다면 아이의 정서발달에도 더할 나위 없이 좋을 것입니다.<br/><br/>' +
        '혹은 부모님이 먼저 책을 읽는 습관을 기르고 아이가 자연스럽게 보고 따라 할 수 있도록 하는 것도 좋은 방법입니다."',
      img: "book1_32",
      title2: "이야기에 대해 아이와 토론해보세요.",
      text_3:
        "아이들이 책을 읽을 때 그들의 생각과 감정을 공감하고 이해해주는 것이 중요합니다. 책에 대해 토론하고 함께 이야기를 나누는 것은 아이들의 이해와 상상력을 키우는 데 도움이 됩니다.",
      text_4:
        "책을 읽는 경험이 즐거운 기억이 될 수 있게 도와주세요. 많이 읽는 것도 중요하지만, 어떤 생각을 했는지도 중요한 문제입니다. 아이가 책을 읽고 어떤 생각을 하는지 꼭 물어봐주세요.",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_book1_4",
      title1: "아이 수준에 적합한 책을 골라주세요.",
      text_1:
        "책을 읽는 것은 언어 능력을 향상시키는데 큰 역할을 합니다. 어휘력, 문법, 읽기 이해력을 향상시켜주며, 이는 글쓰기 및 의사 표현 능력을 키우는데 도움이 됩니다.",
      text_2:
        "아이가 읽고 이해할 수 있는 표현의 책을 권해주세요. 너무 어려운 책은 아이에게 반감을 줄 수 있습니다.",
      img: "book1_42",
      title2: "아이가 좋아할만한 책으로 선택해주세요.",
      text_3:
        "자녀가 읽고 싶은 책을 선택하고, 자신의 관심사에 맞게 독서를 즐길 수 있도록 존중해주세요. 아이와 함께 서점에서 책을 골라보는 것은 좋은 경험이 될 거예요.",
      text_4:
        "너무 어려워서 아이가 거부할만한 책은 좋지 않습니다. 아이가 흥미를 느낄 수 있는 내용을 담는 책을 함께 골라보세요.",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_book1_5",
      title1: "독서 시간을 만들어주세요",
      text_1:
        "가정에서 정기적인 독서 시간을 만들어주세요. 특히 취침 전 독서 시간을 만들면, 자녀가 스트레스를 풀고 편안하게 책을 즐길 수 있습니다.",
      text_2:
        "독서는 즐거운 경험이어야 합니다. 자녀가 강제로 독서를 해야한다고 느끼지 않도록 주의해주세요.",
      img: "book1_52",
      title2: "함께 독서를 실천해보세요.",
      text_3:
        "부모님 스스로 독서 습관을 가지고, 자녀에게 모범이 되어주세요. 가정에서 부모님이 책을 읽고 있는 모습을 자주 보이면, 자녀도 자연스럽게 독서에 흥미를 느낄 수 있습니다.",
      text_4:
        "부모님도 독서를 즐기는 모습을 보여야, 아이도 '일'이나 '공부'로 받아들이지 않을 수 있습니다. 가족으로 독서 시간을 갖는 것도 좋습니다. ",
    },
  ],
  DrugMorning: [...drug],
  DrugEvening: [...drug],
  WakeUp: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_wake1_1",
      title1: "스스로 일어나기, 건강한 성장에 필요해요.",
      text_1:
        "아이들이 등교를 시작하면서부터는 특히나 스스로 기상하는 습관이 중요해집니다. 아이가 스스로 일어나지 않는다면 매일 아이와 겪는 갈등으로 아침마다 전쟁이 될 수 있지요.<br><br> 반복적인 갈등은 부모님을 지치게 하지만 또한, 아이의 자신감을 낮추고 소극적인 아이로 성장하게끔 합니다.",
      text_2:
        "이 과정을 잘 겪어나가기 위해 스스로 선택하고 행동하는 능력 즉, 자기 주도적으로 일어나는 것은 아이가 건강하게 성장하는데 큰 도움이 됩니다.<br><br> 이때 부모님은 어떻게 지원해주면 좋을까요?",
      img: "wake1_11",
      title2: "맛있는 아침 식사로 아이를 깨워주세요.",
      text_3:
        "아침 식사를 아이와 함께 즐겨주세요. 가족과 함께 식사하는 것은 가족 유대감을 높이고, 아이가 하루를 시작하는데 필요한 에너지를 공급합니다.",
      text_4:
        "아이를 깨울 때 간단한 음식이라도 아이가 좋아하는 음식으로 아이를 깨워보세요.아침에 아이가 좋아하는 음식의 냄새로 깨우면 아이가 더 쉽게 일어날 수 있을 것입니다.",
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_wake1_2",
      title1: "먼저, 아이들에게 적절한 수면시간을 보장해주세요.",
      text_1:
        "다 큰 성인이라도 수면시간이 부족하면 아침에 기상하는 것이 쉽지 않습니다. 보통 6~12세 아이는 총 9~10시간 정도를 잘 수 있도록 도와주어야 합니다.<br><br> 이를 위해서 취침 전에는 TV, 핸드폰 등 스마트기기의 사용을 자제하여 숙면을 위한 리듬을 만들어 주세요.",
      text_2:
        "또한 취침 시간이 되면 집안의 불빛을 최대한 차단하고 자연스럽게 잠들 수 있는 환경을 조성하는 것이 중요합니다.<br><br> 적절한 수면시간이 전제되어야만 자기 주도 기상이 가능해진다는 것을 기억해 지도에 참고해주세요.",
      img: "wake1_21",
      title2: "주말에도 일정한 시간에 일어나보세요.",
      text_3:
        "부모가 아이보다 일찍 일어나는 것이 가장 효과적인 방법 중 하나입니다. 부모가 이미 일어나 있으면 아이가 부모를 따라서 더 쉽게 일어날 수 있습니다.",
      text_4:
        "우리 가족은 규칙적인 생활을 만들기 위해 함께 노력할 거에요. 부모님이 솔선수범으로 예를 보이고, 함께 일정을 정하고 활동을 계획해보면 아이들도 규칙적인 일상을 좋아하게 될 거예요. ",
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_wake1_3",
      title1: "아이가 기상할 때 기분 좋은 소통을 해보세요.",
      text_1:
        "부모님이 아이를 깨울 때 주로 “빨리 일어나”, “지금 안 일어나면 지각이야!” 등의 명령어를 사용하거나 혹은 이불을 홱 치우는 방법을 사용하고 있지는 않은지 점검해보세요.",
      text_2:
        "명령어 대신에 아이에게 기분 좋은 말을 건네보세요. “오늘 날씨 요정이 왔네?”, “엄마 꿈에 OO가 나왔는데 뭐 하고 놀았을까?” 등의 말을 건넴으로써 아이가 기상하는 것이 혼나는 일이 아닌, 기분 좋은 하루의 시작이라는 것을 느끼게 도와주세요.",
      img: "wake1_31",
      title2: "일관성 있는 아침 루틴으로 안정감을 ",
      text_3:
        "아침에 이러한 긍정적인 소통과 루틴을 계속 유지하려고 노력하세요. 일관성 있는 아침 루틴은 아이에게 안정감을 줄 수 있습니다.",
      text_4:
        "일관성 있는 아침 루틴으로 우리 아이의 하루를 기분 좋게 만들어보세요. 뽀미도 함께 응원할게요!",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_wake1_4",
      title1: "아이의 감각에 자극을 주세요.",
      text_1:
        "아이를 깨울 때, 때로는 어떠한 방법을 사용해도 아이가 유독 일어나기 어려워할 때가 오기도 하죠. 그럴 땐, 아이의 몸이 자연스럽게 각성할 수 있도록 환경을 조절하는 것도 좋은 방법입니다.",
      text_2:
        "아침에 방 안의 조명을 서서히 밝혀주세요. 갑작스런 눈부심을 피하기 위해 커튼을 열어 창문으로 자연광을 들이는 것이 좋습니다.",
      img: "wake1_41",
      title2: "아이에게 관심과 지지를 보내주세요.",
      text_3:
        "이처럼 침대에 빛이 들어오도록 하거나 창문 살짝 열기, 좋아하는 음악 틀기, 좋아하는 음식 냄새 맡기 등 아이의 감각을 활용하여 잠에서 자연스럽게 깨어날 수 있도록 도와주세요.",
      text_4:
        "부모님의 따뜻한 관심과 지지가 아이에게 큰 도움이 될 것입니다. 함께 하루를 시작하는 즐거움을 누릴 수 있기를 기대합니다.",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_wake1_5",
      title1: "아이에게 따뜻한 말을 건네보아요.",
      text_1:
        "아이를 깨울 때 미소와 인사로 아이에게 긍정적인 에너지를 전달하세요. ",
      text_2:
        "부모의 따뜻한 표정과 말 한 마디가 아이에게 큰 힘이 됩니다. 미소와 인사로 하루를 시작하면, 아이 마음에 행복과 안정감이 느껴질거예요.",
      img: "wake1_51",
      title2: "긍정정인 마음가짐을 아이에게 전해보세요.",
      text_3: "아침에 긍정적인 마음가짐을 공유하세요. ",
      text_4:
        "아이를 부드럽게 깨우는 것은 긍정적인 아침 분위기를 조성하고 아이의 일상을 기분 좋게 시작하는 데 도움이 됩니다.",
    },
  ],
  Spoon: [...spoon],
  PrepBag: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_bag_1",
      title1: "스스로 하는 작은 습관, 큰 자립심의 시작",
      text_1:
        "아이가 스스로 가방을 챙기는 것은 단순한 준비 과정이 아닌, 자립심을 키우는 중요한 첫걸음입니다. 유치원에서 자신이 사용할 물건을 직접 확인하고 준비하면서 책임감을 느끼고, 스스로의 필요를 파악하는 능력이 향상됩니다.",
      text_2:
        "자신에게 무엇이 필요한지를 알고 미리 대비하는 습관은 자라면서 점차 더 큰 자립심을 기를 수 있는 기반이 됩니다. 자신의 가방을 챙기는 습관은 유치원에서의 하루를 준비하는 것뿐만 아니라, 생활 전반에서 자신감 있고 자립심 강한 태도를 만들어주는 중요한 연습이 됩니다.",
      img: "bag_12",
      title2: "부모님의 역할: 도와주는 대신 안내하는 것",
      text_3:
        "스스로 하는 습관을 기르기 위해서는 반드시 필요한 선행 과정이 있습니다. 바로, 부모님의 역할을 다시 설정하는 것입니다. 이제까지 아이가 어려워하는 것을 대신 해주셨다면, 앞으로는 아이가 스스로 할 수 있도록 '안내자'가 되어 옆에서 방법을 알려 주시면 어떨까요?",
      text_4:
        "아이가 실수를 하더라도 배움의 기회로 삼을 수 있도록 지지해주세요. 필요한 물건을 빼먹거나, 유치원에 물건을 두고 오는 경우에도 스스로 해결책을 생각해볼 수 있도록 도와주시면 훌륭한 학습 경험이 된답니다.",
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_bag_2",
      title1: "작은 성공 경험이 자기효능감을 느끼게 해요.",
      text_1:
        "'실패는 성공의 어머니'라고 하지만, 아이들에게는 때때로 작은 성공 경험이 필요합니다.",
      text_2:
        "특히, 몸과 마음이 성장하는 시기의 아이들은 이전보다 할 수 있는 것이 점점 더 많아지면서 여러가지 시도를 하게 되는데, 이 때 실패나 거절만을 반복적으로 경험한다면 '난 할 수 없을 거야'라는 생각, 즉 무력감을 느끼게 될 수 있습니다. 아이들에게 가방 챙기기라는 작은 성공 경험을 주어 '나는 해낼 수 있는 사람'이라는 자기효능감을 느끼게 해주면 어떨까요?",
      img: "bag_22",
      title2: "스스로 가방을 챙겼을 때 충분히 칭찬해주세요.",
      text_3:
        "아이가 스스로 가방을 챙겼다면 성취감을 느낄 수 있도록 칭찬해 주세요. 이 때, 행동의 결과보다는 과정에 대해 언급해주는 것이 좋습니다. \n" +
        '"매일 가방 챙기기를 연습했더니 이제 준비물을 꼼꼼히 챙길 수 있게 되었네.", "내일 필요한 것을 스스로 생각하고 준비하는 모습이 참 멋졌어."와 같이 아이가 한 행동을 칭찬해주세요.',
      text_4:
        '이렇게 칭찬하는 것은 아이가 스스로 자신의 수행 과정을 되짚어보고, 스스로 즐거워서 행동하는 \'내적인 동기\'를 갖게 합니다. 결과에 대한 칭찬("멋지다.", "잘 했네.")은 칭찬 받기 위해 행동하게 하지만, 내적인 동기를 유발하는 과정에 대한 칭찬은 아이가 자신의 성장을 뿌듯하게 느끼도록 만들어 칭찬이 없는 상황에서도 꾸준히 스스로 할 수 있도록 합니다.',
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_bag_3",
      title1: "등원 전쟁, 이젠 안녕!",
      text_1:
        "갑작스러운 준비물 이야기, 빼먹은 실내화, 새 양치도구.. 아침마다 아이와 전쟁하듯 등원 준비를 하고 계시지는 않나요?",
      text_2:
        "아침이 너무 바쁘다면, 매일 저녁 아이와 대화를 나누며 다음 날 필요한 것들을 챙겨보세요. 아이가 직접 오늘 하루를 돌아보며, 필요했지만 없었던 물건이 있었는지, 선생님께서 가져오라고 말씀하신 물건이 있었는지, 내일 필요할 것 같은 물건이 있었는지 생각해보게 하세요. 그리고 직접 자신에게 필요한 물건을 챙겨보도록 안내해주세요. 바쁜 아침 시간이 조금은 여유로워질 거예요.",
      img: "bag_32",
      title2: "약속한 시간에 약속한 할 일을 하게 해주세요.",
      text_3:
        "약속을 지키는 것은 아이들에게 어떤 영향을 미칠까요? 아이들은 약속을 지키는 경험을 통해 '내가 하는 행동이 중요한 의미를 가진다'는 것을 깨닫게 됩니다. 그리고 꾸준히 약속을 지키다보면 그 약속은 어느새 습관이 됩니다. 뽀미는 아이와 약속을 지키는 과정을 함께해, 더 즐겁고 효과적으로 습관을 만들 수 있도록 도와줍니다.",
      text_4:
        '정해진 시간이 되면 아이에게 "이제 내일 유치원에 갈 준비를 해보자."라고 시작을 알려주세요. 즐거운 분위기에서 가방 챙기기 활동을 진행하면, 아이들은 가방을 챙기는 시간을 엄마아빠와 함께하는 즐거운 시간으로 여길 수 있게 됩니다. 아이들이 약속을 지키고 싶어하지 않는 경우, "스스로 한 약속이니 열심히 지켜 보자."와 같이 격려하는 말을 건네 주세요.',
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_bag_4",
      title1: "가방을 챙기며 내일 하루를 계획해요.",
      text_1:
        "가방을 챙기는 것은 단순히 물건을 집어넣는다는 의미가 아니에요. 짐을 싸기 위해서는 계획을 세워야 합니다.",
      text_2:
        '내일 하루의 일정을 생각하고, 그 일정에 해당하는 준비물을 챙겨야 해요. 그렇기 때문에 아이들은 가방을 직접 챙기며 계획성을 기를 수 있습니다. 만약 아이들이 이 과정을 어려워한다면, 부모님께서 힌트를 주시는 것도 좋아요. "내일은 태권도에 가는 날이지? 태권도에 갈 때 필요한 것이 뭐였지?", "내일 유치원에서 물놀이를 한다고 했지? 물놀이를 즐겁게 하려면 무엇을 챙겨야 할까?"와 같이 내일의 일정을 안내하고 아이들이 필요한 것을 직접 생각해보도록 지도해주세요.',
      img: "bag_42",
      title2: "놀이로 시작해 보세요.",
      text_3:
        "스스로 가방을 챙기는 것을 어색해 하거나, 하기 싫어하는 경우 놀이로 시작해 보세요. 아이와 함께 준비물을 찾는 '탐정'이 되어 보는 것은 어떨까요? \n" +
        "\n" +
        "준비물 탐정 놀이\n" +
        "1. 내일 필요한 물건의 특징을 힌트로 제공합니다.\n" +
        '예) "내일은 네모나고 하얀 것이 필요하다고 하네.", "\'그것\'에는 그림을 그릴 수 있대."\n' +
        "2. 아이가 정답을 맞히면 물건을 직접 가져오도록 유도합니다.\n" +
        '예) "그게 어디에 있더라? 준비물 탐정은 어디에 있는지 알 것 같은데."\n' +
        "3. 물건을 가방에 넣도록 하고, 다른 빠진 준비물이 없는지 확인하도록 합니다.\n" +
        '예) "빠져 있는 다른 준비물은 없을까?", "실내화가 빠져 있었네. 정말 꼼꼼히 살펴봤구나!"',
      text_4:
        "역할놀이에서 가장 중요한 것은 바로 '몰입'! 과장된 반응을 보이며 아이들과 함께 놀이에 몰입해 보세요. 즐겁게 놀이하며 가방을 챙기다보면 아이들은 어느새 스스로 준비물을 확인하고 내일을 준비하는 것에 익숙해져 있을 거예요.",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_bag_5",
      title1: "내 물건을 사랑하게 해주세요.",
      text_1:
        "나의 물건을 아끼고 귀하게 여기는 마음은 스스로를 소중하게 생각하는 자기 존중의 시작이 됩니다.",
      text_2:
        "물건을 소중히 하는 아이는 자신의 공간과 환경을 더 잘 관리할 수 있으며, 이는 건강한 자아 형성으로 이어집니다. '내 물건은 내가 아끼고 돌본다'는 생각은 책임감과 자립심을 자연스럽게 길러줍니다.",
      img: "bag_52",
      title2: "초등학교 적응을 위한 첫 걸음",
      text_3:
        "초등학교에 입학하면 아이는 더 많은 책임을 지고 스스로 해결해야 할 일이 늘어납니다. 그렇기 때문에 유치원에서부터 내 물건을 스스로 챙기는 습관을 길러두면 초등학교 적응이 훨씬 수월해집니다.",
      text_4:
        "초등학교에서는 매일의 준비물과 시간표를 스스로 확인해야 하고, 공부나 숙제를 할 때에도 스스로 계획하여 챙기는 것이 중요합니다. 아이가 초등학교에 가서도 잘 적응할 수 있도록 작은 것을 챙기는 습관부터 차근차근 길러 주세요.",
    },
  ],
  Ball: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_ball_1",
      title1: "규칙적인 운동의 중요성",
      text_1:
        "아이들에게 매일매일 규칙적으로 운동하는 것은 굉장히 중요한 일입니다. 규칙적인 운동은 스트레스 해소, 근력과 유연성 증진, 면역력 강화에 도움을 준답니다. 그렇기 때문에 만 3~5세를 위한 누리과정에서도 하루 일정 시간 이상 필수적으로 바깥놀이를 하게끔 하고 있죠. ",
      text_2:
        "하루 20~30분 정도라도 아이와 함께 운동을 해보면 어떨까요? 가벼운 공놀이부터 시작해 우리 아이가 몸도 마음도 건강한 아이로 자라도록 도와주세요.",
      img: "ball_12",
      title2: "어떤 공놀이를 해볼까요?",
      text_3:
        "축구, 농구, 테니스, 피구, 볼링…. 공으로 할 수 있는 놀이에는 여러가지 종류가 있지요. 오늘은 어떤 공놀이를 해보면 좋을까요?",
      text_4:
        "오늘 하고 싶은 공놀이가 없다면 아이와 함께 새로운 공놀이를 만들어보아요. 놀이를 만들어가는 과정에서 아이의 상상력과 창의력, 자기표현력이 강해진답니다.",
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_ball_2",
      title1: "공놀이의 효과",
      text_1:
        "내가 의도한 대로 공을 움직이는 것은 생각보다 많은 기술이 필요한 일입니다. 공놀이를 통해 아이는 신체와 뇌의 통합적인 발달을 경험합니다. 공을 잡고 던지는 동작, 공을 차는 동작은 손/발과 눈의 협응력을 향상시킵니다.  또, 다양한 공놀이를 하며 역동적으로 몸을 움직이는 과정은 신체의 대소근육을 조화롭게 발달시킵니다.",
      text_2:
        "공놀이는 내적인 발달에도 도움을 줍니다. 특히 목표물을 겨냥하거나, 이동 경로를 계산하는 과정을 통해 문제 해결 능력과 공간지각능력을 키울 수 있지요.",
      img: "ball_22",
      title2: "목표가 있는 놀이",
      text_3:
        "아이가 몸을 움직이는 놀이에 계속 관심을 갖게끔 하려면, '조금만 더 노력하면 달성 가능한 수준'의 목표를 정하는 것이 도움이 됩니다.",
      text_4:
        "예를 들어, 아이와 함께 축구를 할 경우 골대에 어제보다 한번더 공을 넣는 것을 오늘의 목표로 설정해보세요. 목표를 달성하는 과정에서 수많은 실패와 성공, 좌절과 기쁨이 있을 거예요. 실패와 좌절에는 '넌 할 수 있어!', '정말 아쉽다. 다시 한 번 도전해보자!'와 같은 응원과 지지를, 성공과 기쁨에는 함께 기뻐하는 공감을 보여주세요.",
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_ball_3",
      title1: "운동 전/후 스트레칭은 선택 아닌 필수",
      text_1:
        "어떤 운동이든 운동을 시작하기 전에 몸을 데우고 운동을 끝낸 후에 몸을 식히는 과정이 반드시 필요하다는 것, 알고 계셨나요? 스트레칭을 통해 부상을 예방해 보아요.",
      text_2:
        "공놀이 전, 후에 목과 어깨, 팔, 손목, 허리, 무릎, 발목 등을 쭉쭉 늘리고 돌려가며 스트레칭 해주세요. 이렇게 스트레칭 하면 근육이 놀라는 것을 예방할 수 있습니다.",
      img: "ball_32",
      title2: "안전한 공놀이를 위해 필요한 것",
      text_3:
        "안전하게 공놀이를 즐기기 위해서는 다음과 같은 준비가 필요해요. \n" +
        "딱딱하고 무거운 공보다는 말랑하고 가벼운 공을 사용하는 것이 좋아요. 또, 주변에 깨지기 쉬운 물건이나 날카로운 물건이 없는지 확인하여야 합니다.  ",
      text_4:
        "다른 사람과 함께 놀이할 경우, 안전을 위한 규칙을 정할 필요가 있습니다. 공을 얼굴로 던지지 않기, 다른 사람의 몸을 소중하게 여기기, 밀치지 않기와 같은 약속을 정하면 서로 조심할 수 있어요.",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_ball_4",
      title1: "함께하는 공놀이",
      text_1:
        "대부분의 공놀이는 혼자서 이루어지지 않아요. 짝을 이루거나 여럿이서 함께 하는 놀이가 주를 이룹니다. 따라서 아이들은 다른 사람들과 함께 공놀이를 즐기며 사회성을 기를 수 있어요.",
      text_2:
        "친구들과 공을 주고받거나 팀으로 게임을 하는 과정에서 아이는 협력과 양보를 배우게 됩니다. 공놀이를 통해 자연스럽게 서로 소통하고, 규칙을 지키는 법을 익히게 되는 것이죠. 또, 공놀이 중에는 때때로 다툼이나 갈등이 발생할 수 있습니다. 이러한 상황은 아이가 갈등을 해결하는 능력을 배울 수 있는 좋은 기회가 됩니다. 부모님이 놀이에 참여하며 중재하거나 문제 해결 방법을 보여준다면, 아이는 자연스럽게 사회적 기술을 익히게 됩니다.",
      img: "ball_42",
      title2: "경쟁은 나쁜 것일까요?",
      text_3:
        "지나친 경쟁은 결과에만 초점을 맞추게 되어 아이가 자신의 노력을 가치 없는 것으로 여기게 되는 문제점을 가지고 있습니다. 하지만 건강한 경쟁은 아이들이 도전과 협력의 가치를 이해하고, 건강하고 자신감 있는 사회 구성원으로 성장할 수 있도록 돕습니다.",
      text_4:
        "그렇다면 건강한 경쟁은 어떻게 이루어질 수 있을까요? 건강한 경쟁을 위해서는 결과보다 과정을 중시하는 태도가 필요합니다. 이러한 태도는 부모님께서 승패 보다는 아이가 경쟁 과정에서 노력하고 성장한 부분에 대해 칭찬해주는 방법으로 길러질 수 있습니다. 또, 적정 수준의 도전을 제공하고 상호 존중을 강조하면서 경쟁 상대를 존중하고 배려하는 태도를 가르칠 수 있습니다. 이 때, 경쟁 외에도 협력과 놀이의 중요성을 함께 알려주면 더욱 좋겠지요!",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_ball_5",
      title1: "쉬운 공놀이는 질렸다면",
      text_1:
        "아이가 공만으로 하는 놀이에 질렸다면, 장애물 코스를 만들어 공놀이를 해보아요. ",
      text_2:
        "어떤 장애물을 놓으면 좋을까요? 무엇을 장애물로 활용하면 좋을까요? 장애물 코스는 어떻게 계획하면 좋을까요? 어떤 규칙대로 움직여야 할까요? 이 모든 것을 아이들과 함께 고민하고 결정하면 놀이 시간이 더 의미 있고 밀도 높아집니다.",
      img: "ball_52",
      title2: "역할놀이로 즐기는 공놀이",
      text_3:
        "아이들은 역할놀이로 더 즐거운 놀이 시간을 보낼 수 있습니다. 평범했던 놀이도 상상력을 더하면 더욱 재미있고 환상적인 놀이가 되기도 하지요. 늘 해왔던 축구 놀이도 '축구 선수가 되어 경기를 한다'라는 상황이 부여되면 아이들에게는 특별한 놀이처럼 느껴지게 됩니다. 또, 택배 기사가 되어 2초에 한 번씩 통통 튀는 택배를 배달한다는 상상을 해보면 어떻게 될까요? 아마 공을 정신 없이 튕기며 놀이하겠지요! ",
      text_4:
        "이렇게 역할놀이를 다른 놀이와 결합하여 놀이하는 것은 아이들이 상상의 나래를 펼칠 수 있도록 도와준답니다. 익숙해져버린 놀이를 새롭게 느낄 수 있도록 해주는 역할놀이, 오늘은 아이들과 함께 역할을 정해 공놀이를 해보는 것은 어떨까요?",
    },
  ],
  Block: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_blck_1",
      title1: "블록놀이로 키우는 창의적 사고",
      text_1:
        "블록놀이는 아이의 상상력을 자극하는 대표적인 활동입니다. 다양한 크기와 모양의 블록을 사용해 집, 동물, 자동차 등 자신만의 창의적인 작품을 만들어볼 수 있습니다.",
      text_2:
        "또한, 블록놀이를 통해 아이는 단순히 물건을 쌓는 것을 넘어 구조와 디자인의 원리를 배웁니다. 이러한 경험은 아이가 문제를 창의적으로 해결하고, 자신만의 독특한 아이디어를 구체화하는 데 도움을 줍니다.",
      img: "blck_1",
      title2: "블록놀이로 배우는 공간지각능력",
      text_3:
        "블록놀이는 공간 지각 능력을 키우는 데 매우 효과적입니다. 블록을 조립하거나 배치하는 과정에서 아이는 공간적 관계와 균형을 이해하게 됩니다. 이 과정은 수학적 사고와 기하학적 감각을 키우는 데도 도움이 됩니다.",
      text_4:
        "블록놀이에서는 높이 쌓아 올린 구조물이 무너지지 않도록 균형과 안정성을 고려해야 합니다. 아이는 이러한 과정을 통해 자연스럽게 물리적 원리를 배우며, 논리적 사고를 경험하게 됩니다.",
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_blck_2",
      title1: "놀이에도 계획이 필요해요",
      text_1:
        "가벼운 놀이를 하더라도 '무엇을', '어떻게' 할 것인지에 대한 설명은 가능해야 합니다. 특히, 특정한 형태를 만들어가는 블록놀이의 경우 무엇을 만들 것인지에 대한 계획이 없다면 쉽게 흥미를 잃게 됩니다.",
      text_2:
        "놀이를 시작할 때, 아이가 '생각하며' 놀이할 수 있도록 해주세요. \"오늘은 무엇을 만들 거야?\"라는 간단한 질문 한 마디면 충분하답니다. 아이에게 목적이 생기고, 계획이 생길 거예요.",
      img: "blck_2",
      title2: "놀이 확장을 위한 상호작용",
      text_3:
        "아이가 자신이 만든 것에 대해 이야기해 볼 수 있도록 관심을 가져주세요. ",
      text_4:
        '아이들의 구성물에는 세세한 부분에 대한 아이 나름의 의도가 숨어 있는 경우가 많습니다. 여러 부분들을 살펴보며 적극적으로 질문해주세요. 예를 들어, "이 부분은 왜 필요한 거야?", "여기는 무엇을 만든 거야?", "이건 누가 살고 있는 집이야?"와 같은 질문을 건넬 수 있습니다. 이 때 아이는 자신이 구성한 것을 말로 설명하며 표현력을 기를 수 있으며, 스토리텔링이 더해져 놀이가 자연스럽게 확장됩니다.',
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_blck_3",
      title1: "아이의 수준에 맞게 골라주세요",
      text_1:
        "우리 아이가 사용하기에 적당한 블록은 어떤 기준으로 선택해야 할까요? 대부분의 놀잇감을 선택할 때에 비슷한 기준이 적용됩니다. 바로 연령과 발달 수준이지요.",
      text_2:
        "일반적으로 연령이 어릴 수록 크고, 둥근 모서리를 가진 기본 도형 형태의 블록을 제공합니다. 블록을 삼킬 경우 질식의 위험이 있고, 아직 소근육이 충분히 발달하지 않았을 경우 작은 블록은 끼우고 빼기 어려울 수 있으므로 연령에 맞는 블록을 선택하는 것이 좋습니다. 반대로 연령이 높을 수록 작고, 여러 모양을 가진 블록을 제공합니다. 블록을 활용해 자신이 상상한 것을 실현할 수 있도록 다양한 소품이 포함되어 있는 경우가 많습니다. 우리 아이의 발달 수준을 파악하고 적절한 블록을 제공해주세요.",
      img: "blck_3",
      title2: "코딩과 블록놀이",
      text_3:
        "최근 코딩 교육에 대한 관심도가 올라가면서 블록도 똑똑해지고 있어요. '스마트 블록'에 대해 들어보신 적 있으신가요? ",
      text_4:
        "스마트 블록은 일반 블록과 달리 빛 센서, 모터와 같이 다양한 기능을 가진 블록을 말해요. 여러가지 블록을 조합해 기존 블록 놀이의 한계를 넘어 다양한 놀이를 즐길 수 있어요. 예를 들어, 모터와 바퀴, 방향 블록을 활용해 내가 계획한대로 방향을 조절할 수 있는 자동차를 만들 수 있어요. 이렇게 스마트 블록을 활용해 컴퓨터 없이 코딩을 경험해 볼 수 있답니다. ",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_blck_4",
      title1: "블록놀이와 상징성 발달",
      text_1: "블록놀이는 아이의 상징적 사고를 키우는 데 중요한 역할을 합니다.",
      text_2:
        "아이는 블록을 단순한 물체로 보는 것이 아니라, 이를 자신만의 상징으로 변환합니다. 예를 들어, 블록 몇 개를 연결해 '자동차'라고 부르거나, 쌓아 올린 구조물을 '성'으로 상상합니다. 이러한 활동은 아이가 추상적인 개념을 이해하고 이를 구체적으로 표현하는 능력을 키우는 데 도움을 줍니다. 아이가 자신의 상상력을 뽐낼 수 있도록 적극적으로 지원해주세요.",
      img: "blck_4",
      title2: "함께 쌓는 블록, 함께 나누는 즐거움",
      text_3:
        "한정된 개수의 블록으로 누군가와 함께 놀이하다보면 블록을 나누어 사용해야 하는 경우가 생깁니다. 내가 쓰려고 했던 블록을 다른 사람이 필요로 하거나, 다른 사람이 가지고 있는 블록이 필요해질 수도 있죠. 바로 이 때, 아이들에게 나눔의 가치를 알려줄 수 있습니다.",
      text_4:
        '놀이 상황에서 놀잇감은 함께 사용하는 것임을 아이들에게 알려 주세요. 다른 사람에게 놀잇감을 양보하였을 때, 나도 누군가에게 양보 받을 수 있음을 알려 주세요. 다른 친구에게 놀잇감을 빌리고 싶을 때 어떻게 해야 하는지 알려주세요. 예를 들어, 말 없이 블록을 가져가는 것이 아니라, "나 저 빨간 블록이 필요한데, 빌려줄 수 있을까?"와 같이 말 할 수 있습니다.',
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_blck_5",
      title1: "블록놀이엔 블록만 써야 할까?",
      text_1:
        "블록놀이엔 블록만 써야 할까요? 사실, 아이들의 입장에서 놀이는 '블록놀이', '역할놀이'라는 말로 딱딱 나눠지지 않아요. 놀이 시간 동안 수많은 놀이 방식이 결합되고, 해체되며 가변적으로 놀이가 흘러 갑니다. 그렇기 때문에, 블록놀이라고 해서 블록만 사용할 필요는 없습니다.",
      text_2:
        "그렇다면 아이들의 놀이가 더 풍성해지기 위해 어떤 지원을 해주면 좋을까요? 여러가지 재료를 사용해 놀이하도록 다양한 재료를 제공해주세요. 예를 들어, 블록에 클레이로 만든 음식이나 색종이, 직접 그린 그림 등을 추가해 놀이하도록 시범을 보여준다면 더 재미있게 놀이하는 아이가 될 수 있답니다.",
      img: "blck_5",
      title2: "블록놀이, 이렇게 마무리 해요",
      text_3:
        "블록놀이를 끝내야 할 시간이 되었다면 어떻게 놀이를 마무리하는 것이 좋을까요? 놀이를 하다보면 잘 시간이 되어서, 식사 시간이 되어서 등등 여러가지 이유로 놀이가 중단되어야 할 상황이 생깁니다. 이 때 아이와 갈등을 빚지 않고 긍정적으로 놀이를 중단하기 위해서는 협의가 필요합니다. ",
      text_4:
        "아이가 만든 구성물을 존중해주는 것이 협의의 첫번째 단계입니다. 놀이 시간 동안 아이가 블록으로 하나의 '작품'을 만들었다고 생각해주세요. 아이의 입장에서는 열심히 만든 작품을 부수고 싶지 않은 것이 당연합니다. 그러니 이 블록 작품을 어떻게 할 것인가에 대한 이야기를 나누어 주세요. '블록을 보관할 것인가', '부수어 정리할 것인가'에 대해 말이죠. 오늘 만든 블록 구성물을 다음에 또 가지고 놀 계획이 있다면 적당한 자리를 블록 보관소로 정해 보세요. 계획 없이 보관하는 것을 막기 위해서는 보관할 수 있는 블록 구성물의 최대 개수를 설정해두는 것이 좋습니다. 다시 가지고 놀지 않을 것이라면 평소 블록을 정리하는 방식대로 아이 스스로 정리해보도록 해주세요.",
    },
  ],
  Puzzle: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_pzzl_1",
      title1: "퍼즐을 맞추는 데에 필요한 능력",
      text_1:
        "퍼즐을 맞추는 동안 우리 아이의 머릿속에서는 어떤 일들이 일어날까요? 아마, 수없이 많은 생각들이 스쳐 지나갈 것입니다. '이 퍼즐 모양이 저 빈칸과 비슷한 것 같은데.', '옆으로 한 번 돌려볼까?', '이 퍼즐 그림이 저거랑 이어지겠는데?'와 같은 생각들이 말이죠.",
      text_2:
        "퍼즐을 맞추는 동안 아이의 뇌는 패턴을 인식하고 기억하며, 전체와 부분의 관계를 파악합니다. 완성된 퍼즐의 형태(전체)를 상상하며 각 퍼즐 조각(부분)의 적절한 위치를 찾아 가는 것이죠. 이러한 활동은 문제해결능력은 물론, 수학적 사고력과 공간지각능력, 추론 능력을 향상시키는 데도 도움이 됩니다.",
      img: "pzzl_12",
      title2: "퍼즐놀이로 소근육을 발달시켜요",
      text_3:
        "연필로 그림을 그리거나, 숟가락으로 밥을 떠서 먹는 등 소근육 사용에 어려움을 느끼는 아이들에게 퍼즐놀이는 특히 좋은 놀이입니다.",
      text_4:
        "작은 퍼즐 조각을 손으로 잡고, 방향에 맞게 돌리고, 모양에 맞게 끼워 넣는 동작들은 모두 소근육을 사용하는 동작입니다. 아이들은 퍼즐놀이를 통해 섬세하게 신체를 조절하는 방법을 연습할 수 있습니다.",
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_pzzl_2",
      title1: "퍼즐을 맞추며 관찰해요",
      text_1:
        "아이들이 사용하는 퍼즐의 경우 글자, 숫자, 동물, 공룡, 식물 등 다양한 형태와 그림을 포함하고 있습니다. 이러한 퍼즐을 맞추기 위해서는 반드시 필요한 과정이 있어요. 바로 '관찰'입니다. ",
      text_2:
        "퍼즐을 맞추기 위해 형태와 그림을 살피다 보면, 자연스럽게 퍼즐 주제에 관심을 가지고 특징을 발견해내게 됩니다. 예를 들어, 토끼를 주제로 한 퍼즐을 맞추고 있다면 토끼의 긴 귀, 귀여운 꼬리, 깡충깡충 점프하기 좋은 발 등을 발견하고 힌트를 바탕으로 퍼즐의 주제가 토끼임을 추론해내게 되지요. 아이가 관심을 갖고 있는 주제의 퍼즐을 제공하면 더욱 몰입하여 관찰하며 퍼즐을 맞출 수 있답니다.",
      img: "pzzl_22",
      title2: "좋은 상호작용이란?",
      text_3:
        "퍼즐을 맞추는 동안 아이들과 이런 대화를 나눠본다면 보다 풍성한 놀이가 가능하답니다. \n" +
        "첫번째, 아이가 퍼즐을 맞추기 어려워하는 경우 부모님께서 '은근슬쩍' 힌트를 주세요. \"여기 이 조각이랑 그 부분이랑 색이 좀 비슷한 것 같지 않아?\"\n" +
        '두번째, 아이가 생각하며 퍼즐을 맞추도록 도와주세요. "이 퍼즐, 완성하면 어떤 그림이 될까? 혹시 OO이는 알 것 같아?"\n' +
        '세번째, 아이와 함께 퍼즐을 맞추기 위한 전략을 세워보세요. "어떻게 해야 퍼즐을 쉽게 맞출 수 있을까? 비슷한 색깔끼리 미리 같이 놓아두면 어떨까?"',
      text_4:
        "아이와 함께 즐겁게 놀이하는 공동 놀이자의 역할에서 한 발자국 나아가 놀이를 확장시키고 도움을 주는 것도 때때로 필요합니다. 아이가 더 높은 수준의 놀이를 해볼 수 있도록 오늘은 아이의 놀이를 관찰하며 고민하는 시간을 가져 보아요.",
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_pzzl_3",
      title1: "아이의 수준에 맞게 골라주세요",
      text_1:
        "세상에는 참 다양한 퍼즐이 있습니다. 일반적으로 '퍼즐'하면 떠오르는 평면 종이 퍼즐부터 시작해 두꺼운 나무 퍼즐, 3D 입체 퍼즐 등 여러 종류의 퍼즐이 있지요. 그렇다면, 이 퍼즐 중 우리 아이에게 발달 상 적합한 퍼즐은 무엇일까요?",
      text_2:
        "일반적으로 어린 연령일 수록 조각이 크고 두꺼워 쥐기 쉬운 평면 퍼즐을 제공하는 것이 좋습니다. 퍼즐의 형태나 그려진 그림 또한 단순한 것으로 선택하여 점차 난이도를 높여나가는 것을 추천합니다. 연령이 높을 수록 조각이 작고 많으며, 그려진 그림 또한 복잡한 것이 아이들의 도전욕을 자극하기에 좋습니다. 연령이 높을 경우 지나치게 쉬운 퍼즐이나, 지나치게 어려운 퍼즐에는 쉽게 흥미를 잃을 수 있으니 아이의 발달 수준에 맞게 퍼즐의 난이도를 조절하여 제공할 필요가 있습니다.",
      img: "pzzl_32",
      title2: "퍼즐로 할 수 있는 놀이",
      text_3:
        "아이가 이미 퍼즐에 익숙한가요? 그렇다면 퍼즐로 할 수 있는 새로운 놀이 두 가지를 추천 해드릴게요.\n" +
        "첫 번째 놀이는, '나만의 퍼즐 만들기'입니다.\n" +
        "무지 종이 퍼즐에 그림을 그려 직접 나만의 퍼즐을 만들어 볼 수 있습니다. 이 때 색칠도구는 색연필, 네임펜, 매직 등 나중에 손에 묻어나지 않는 것을 사용하는게 좋습니다. 어린 연령의 아이들은 조각마다 색을 칠하며 놀이할 수 있어요. 이 놀이는 아이들의 창의력과 상상력, 예술성을 길러줄 수 있어요. 다른 사람에게 자신이 직접 만든 퍼즐을 소개하며 자신감도 향상할 수 있답니다.",
      text_4:
        "여러 번 맞춰 본 퍼즐의 경우 아이들이 패턴을 외워서 재미 없어 하는 경우가 많습니다. 이럴 때, 퍼즐을 버리기 보다는 이렇게 놀이해보면 어떨까요?\n" +
        "두 번째 놀이는, '마음대로 빈칸 꾸미기'입니다.\n" +
        "퍼즐 조각을 하나 빼둔 후에 퍼즐을 맞추게 합니다. 빈 공간에 해당하는 퍼즐 그림을 상상하여 종이에 그리고 모양에 맞게 잘라 퍼즐을 완성합니다. 원래의 퍼즐과 똑같은 그림을 그릴 필요는 없답니다. 익살스러운 그림도, 무시무시한 그림도 모두 좋아요! 아이들이 상상의 나래를 펼칠 수 있도록 지원해주세요.",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_pzzl_4",
      title1: "퍼즐을 통해 배우는 감정 조절",
      text_1:
        "퍼즐을 맞추는 과정은 실패와 성공이 반복되는 경험입니다. 이 과정에서 아이는 좌절을 경험하고, 이를 극복하는 법을 배우게 됩니다. 퍼즐을 완성하기 위해 인내하고, 실패에도 불구하고 다시 도전하는 과정은 아이의 감정 조절 능력을 키우는 데 도움을 줍니다.",
      text_2:
        "또, 퍼즐놀이는 아이가 집중력을 발휘하면서도 긴장을 풀 수 있는 힐링 활동입니다. 반복적으로 조각을 맞추는 동작은 아이에게 안정감을 주고, 스스로 조용히 몰입할 수 있는 시간을 제공합니다. 이러한 경험은 아이의 정서적 안정을 돕고 스트레스를 해소하는 데 효과적입니다.",
      img: "pzzl_42",
      title2: "루틴에 맞게 놀이를 선택해요",
      text_3:
        "잠자기 직전에 활동적인 놀이를 하면 어떤 일이 벌어질까요? 보통 진이 빠져 잠들거나, 진이 빠질 때까지 잠자기를 거부하거나 둘 중 하나의 상황을 맞이하게 되지요. 아이들이 편안한 하루를 보내기 위해서는 하루 루틴에 맞게 놀이를 선택하는 것이 필요하답니다. ",
      text_4:
        "아침에 일어났을 때, 밥을 먹은 후, 잠 자기 전에는 정적인 놀이를 하는 것을 추천합니다. 예를 들면, 앉아서 할 수 있는 그림책 읽기, 퍼즐 놀이, 작은 블록 놀이 등이 정적인 놀이에 속해요. 반대로 밥을 먹기 전이나 오후 시간 대에는 마음껏 몸을 움직이며 에너지를 발산할 수 있는 활동적인 놀이를 하는 것이 좋습니다.",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_pzzl_5",
      title1: "놀이 기록 남기기",
      text_1:
        "아이가 퍼즐을 다 맞췄나요? 퍼즐을 완성했다면, 그것을 기록으로 남겨보면 어떨까요? 완성한 퍼즐과 함께 사진으로 기록을 남겨보세요. 퍼즐을 다 맞추었을 때의 뿌듯함을 오래도록 간직할 수 있습니다.",
      text_2:
        "아이가 퍼즐을 금방 맞추기 시작했다면, 이제는 퍼즐을 맞추는 데 걸리는 시간을 재어 볼까요? 어제 퍼즐을 맞추는 데에 걸린 시간과 비교해보세요. 어제보다 더 빠른가요? 아이가 최고기록을 경신하며 성취감을 느껴볼 수 있도록 도와주세요.",
      img: "pzzl_52",
      title2: "퍼즐놀이, 이렇게 마무리 해요",
      text_3:
        "즐거웠던 퍼즐놀이 시간, 어떻게 마무리하면 좋을까요? 모든 놀이의 끝은 바로 '정리'랍니다. 즐겁게 놀이했다면 이제는 책임감을 보일 때죠!",
      text_4:
        "놀이한 후에 자신이 사용한 놀잇감을 정리하는 습관을 들이는 것은 아이가 책임감을 배우기 위해 중요합니다. 퍼즐놀이를 끝낸 후 조각을 판에 맞추어진 채로 보관할지, 보관함을 따로 만들어 보관할지 아이와 정해보세요. 이렇게 조각을 정리하고 보관하는 과정이 아이에게 질서와 책임감을 가르치는 기회가 될 수 있습니다. 조각을 잃어버리면 이후에 퍼즐놀이를 할 때 불편할 수 있음을 이야기한 후, 아이 스스로 퍼즐 조각을 정리할 수 있도록 해주세요.",
    },
  ],
  AnyPlay: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_play_1",
      title1: "우리 아이가 좋아하는 놀이는 무엇인가요?",
      text_1:
        "'좋아하는 놀이하기'라는 약속을 고를 때, 우리 아이는 어떤 놀이를 떠올렸을까요? 아이가 가장 좋아하는 놀이가 무엇인지 알고 계신가요?",
      text_2:
        "매일 저녁, 오늘 하루 가장 재미있었던 놀이는 무엇인지 묻는 시간을 가져 보세요. 또, 아쉬웠던 놀이는 무엇이었는지, 어떻게 하면 더 재미있었을지 생각해보는 시간을 가져 보세요. 놀이를 계획하는 습관을 가질 수 있답니다!",
      img: "play_12",
      title2: "아이가 놀이를 못 고를 때",
      text_3:
        "아이가 놀이를 고르지 못 하는 이유은 다양합니다. 하고 싶은 것이 너무 많아서일 수도 있고, 반대로 하고 싶은 것이 없어서일 수도 있지요. ",
      text_4:
        '만약 아이가 하고 싶은 놀이가 너무 많아 고민하고 있다면 놀이의 순서를 정하는 일을 도와주세요. "어제 인형놀이를 많이 했으니까, 오늘은 그림 그리기를 먼저 할까?"와 같은 상호작용으로 아이의 결정을 도와줄 수 있어요. \n' +
        "아이가 하고 싶은 놀이가 없어 고민하는 시간이 길어지고 있다면 부모님께서 먼저 놀이를 제안해보세요. 아이가 평소 좋아하는 놀이에 새로운 요소를 더해 볼까요? 색연필로 그림 그리기를 즐겨했다면, 오늘은 물감을 찍어 그림을 그려보는 놀이를 해보면 어떨까요? ",
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_play_2",
      title1: "놀이 중 부모님의 역할",
      text_1:
        "놀이를 하는 동안 부모님은 관찰자로서 아이의 행동을 주의 깊게 살펴볼 수 있습니다. 아이가 놀잇감을 다루는 방식, 놀이를 하며 사용하는 언어 표현, 또는 문제를 해결하는 태도는 아이의 발달 수준을 이해하는 데 귀중한 단서를 제공합니다. 이때, 과도하게 간섭하기보다는 아이가 스스로 탐구할 수 있는 시간을 주고 아이가 도움을 필요로 할 때 적당한 타이밍에 개입하는 것이 좋습니다.",
      text_2:
        "또한 부모님은 아이의 놀이에 참여해 동등한 관계의 놀이 친구가 되어 즐거운 시간을 보낼 수 있습니다. 이 과정에서 아이는 부모님과의 상호작용을 통해 유대감을 느끼고, 안정감을 느낄 수 있게 됩니다.",
      img: "play_22",
      title2: "놀이의 틀 이해하기",
      text_3:
        '아이의 놀이에 함께하고 싶은데, "아빠도 같이 해도 될까?"라고 물었을 때 거절 당한 경험이 있으신가요? 잠시 아이의 놀이를 관찰한 후 놀이 틀을 파악해 적절하게 대처하면 보다 쉽게 놀이에 함께할 수 있으실 거예요. 가게 놀이에 자연스럽게 손님으로 참여하거나, 공주님을 위한 성을 쌓는 놀이에 일꾼으로 참여하는 것처럼 말이에요!',
      text_4:
        "우리 아이가 하고 있는 놀이를 이해하려면, 먼저 아이의 놀이 틀을 이해해야 합니다. '놀이 틀(play frame)'이란 놀이 과정 중에 생성되는 가상의 영역을 의미합니다. 쉽게 말하자면, 놀이에 참여하는 아이가 설정한 놀이의 상황을 뜻하는 것이지요. \n" +
        "부모님과 아이가 같은 공간에 함께 있더라도, 아이는 자신이 설정한 놀이 틀 안에서 그에 맞는 행동을 수행하고 있을 수 있습니다. 예를 들어, 아이스크림 가게 놀이를 시작하며 가게 주인 역할을 맡기로 했다면 방금 전까지는 부모님의 자녀로 행동하고 있던 아이는 이제 마치 자신이 실제 아이스크림 가게 주인이 된 것처럼 행동하고 말합니다. 자신이 속한 놀이 틀에 적절한 행동을 하고 있는 것이죠. 아이들의 놀이 틀을 존중하고 이해해주세요!",
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_play_3",
      title1: "놀이의 중요성",
      text_1:
        "'우리 아이는 하루종일 놀기만 하는 것 같아.'하는 생각이 들 때가 있지요.\n" +
        "놀이는 왜 필요할까요? 왜 놀이중심 교육과정을 운영하는 것일까요?",
      text_2:
        "아이들의 전인적 발달은 신체, 정서, 사회성, 인지 등 다양한 측면에서 균형 있게 이루어지는 것을 의미합니다. 놀이가 전인적 발달의 중요한 열쇠라는 사실은 이전부터 익히 알려져 왔습니다. 놀이를 통해 아이들이 단순히 즐거움만을 느끼는 것이 아니라, 친구와의 소통 방법부터 자연에 대한 이해까지 삶의 다양한 기술을 자연스럽게 배우게 된다는 사실은 더이상 놀라운 일이 아닙니다. 이에 따라, 아이들의 놀이를 세심하게 관찰하고 배움의 순간을 포착해 교육적으로 지원하는 것이 시간이 흐를 수록 점점 강조되었죠. 이러한 흐름은 기존의 교사가 주도하는 교육 방식에서 벗어나, 아이들의 놀이를 따라가는 놀이 중심 교육과정으로 전환되는 계기가 되었습니다.",
      img: "play_32",
      title2: "놀이와 학습",
      text_3:
        "아이에게 알파벳 송을 따라 부르도록 했어요. 아이는 딱히 즐기지는 않지만 노래를 따라 불러요. 이것은 놀이일까요, 학습일까요? ",
      text_4:
        "학자들에게도 놀이와 학습(일)을 완벽하게 구분해내기는 어렵다고 합니다. 놀이 속에서 학습이 이루어지고, 학습에 놀이적 요소가 포함되기도 하지요. 이렇게 놀이와 학습은 연속적인 관계로 이루어져 있어요. 아이의 내적 동기의 정도, 현실성의 정도, 외적 통제의 정도에 따라 놀이에 가까운지, 학습에 가까운지가 결정됩니다. '부모님의 지시로' 아이가 '즐기지는 않지만' 노래를 따라 부르는 상황은 내적 동기와 현실성의 정도는 낮고 외적 통제의 정도는 높으니 놀이보다는 학습에 가깝다고 볼 수 있는 것이죠. \n" +
        "오늘 우리 아이의 '놀이'는 놀이와 학습, 어느 쪽에 더 가까웠나요?",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_play_4",
      title1: "놀이 중 아이의 감정에 귀 기울이기",
      text_1:
        "놀이를 하며 아이들을 다양한 감정을 느끼게 됩니다. 무언가를 완성했을 때 느끼는 뿌듯함, 예상하지못 한 상황에서 느끼는 당황스러움과 짜증, 재미있는 상황에서 오는 즐거움 등 긍정적인 감정과 부정적인 감정이 소용돌이 치듯 나타납니다. 이러한 감정은 때로는 직접적으로, 때로는 간접적으로 표현되는데, 아이들은 자신의 감정을 정의하고 올바르게 표현하는 데에 서툴기 때문에 이를 놓치지 않고 읽어주는 것이 좋습니다. ",
      text_2:
        "예를 들어, 아이가 그림을 그리며 놀이하던 도중 종이가 찢어져 얼굴을 찌푸리면, \"우리 OO이가 재미있게 그림을 그리고 있었는데 종이가 찢어져서 짜증이 났구나? 숨을 한 번 크게 내쉬고 진정해보자.\"와 같이 감정을 읽어주고 해결 방법을 알려주는 것은 아이의 정서발달에 도움이 됩니다. 또, 오늘 '좋아하는 놀이 하기' 약속을 지키는 동안 우리 아이가 어떤 감정을 느꼈다고 답했는지 뽀미를 통해 확인해보세요. 아이의 마음을 확인하는 데에 도움이 된답니다.",
      img: "play_42",
      title2: "놀이 규칙 정하기",
      text_3:
        "놀이의 특징은 '자유로움'이지만 스스로와 타인의 안전을 위협하거나 타인을 불편하게 하는 행위는 조절될 필요가 있습니다. 놀이 시작 전에 아이와 함께 놀이 규칙을 정해보면 어떨까요?",
      text_4:
        "규칙이 필요한 이유를 아이가 스스로 받아들일 수 있도록 충분히 대화를 나누며 놀이 규칙을 정해주세요. '놀잇감 던지지 않기', '물감놀이는 정해진 공간에서 하기'와 같은 약속을 정해볼 수 있어요. 함께 종이에 규칙을 적어 놀이 규칙판을 만들어도 좋아요. 규칙을 지키지 않을 경우 놀이를 중단해야 함을 안내해주세요. 함께 정한 규칙이니 더 잘 지킬 수 있겠죠? ",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_play_5",
      title1: "실내 놀이와 실외 놀이",
      text_1:
        "실내놀이와 실외놀이는 각각 고유의 장점을 가지고 있으며, 아이의 균형 잡힌 발달을 위해 두 가지를 적절히 제공하는 것이 중요합니다.",
      text_2:
        "실내놀이는 아이의 정적인 집중력과 창의성을 키우는 데 도움을 주고, 실외놀이는 신체 활동과 사회적 상호작용을 통해 활력을 제공한답니다. 오늘 하루 실내놀이를 많이 했다면, 이번에는 실외놀이를 추천해보면 어떨까요?",
      img: "play_52",
      title2: "어떤 놀잇감이 좋은 놀잇감일까?",
      text_3:
        "놀잇감은 놀이를 하고 싶은 동기를 유발시키고, 놀이의 도구가 되는 매개체를 말합니다. 우리 아이를 위한 놀잇감, 어떤 기준으로 선택하고 계신가요?",
      text_4:
        "교육학자들은 놀잇감의 교육적 조건으로 아래와 같은 내용을 제시하고 있어요.\n" +
        "- 다양한 놀이 활동을 할 수 있는 기회를 제공함\n" +
        "- 연령과 발달 수준에 적합함\n" +
        "- 성인의 도움 없이 혼자서도 조작이 가능함\n" +
        "- 안전하고 견고하며, 내구성이 높음",
    },
  ],
  Jumprope: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_jprp_1",
      title1: "줄넘기의 효과",
      text_1:
        "줄넘기는 간단한 운동처럼 보이지만, 아이의 성장과 발달에 매우 유익한 활동입니다. 줄넘기를 통해 아이는 심폐지구력과 근지구력, 민첩성을 기를 수 있으며, 전반적인 신체 조정 능력을 높일 수 있습니다. 또한, 지속적으로 줄넘기를 하면 건강한 체중을 유지하고, 스트레스를 해소하는 데도 큰 도움이 됩니다.",
      text_2:
        "더욱이 줄넘기는 단순히 몸을 움직이는 것 이상으로, 두뇌 발달에도 긍정적인 영향을 줍니다. 타이밍을 맞춰 줄을 넘는 동작은 협응력을 높여 주며, 집중력을 향상시키는 데 큰 도움이 된답니다.",
      img: "jprp_12",
      title2: "안전한 줄넘기를 위해 필요한 것",
      text_3:
        "아이가 다치지 않고 안전하게 줄넘기를 하기 위해서는 다음과 같은 준비가 필요해요. \n" +
        "관절 보호를 위해 딱딱하지 않은 바닥에서 충격 흡수력이 좋은 신발을 신고 운동하는 것이 좋아요. 또, 줄넘기는 땀이 많이 나는 유산소 운동이기 때문에 통기성 좋은 옷차림을 선택하는 것이 좋아요.",
      text_4:
        "부모님께서 함께하며 아이의 체력에 맞는 강도로 적절한 시간 동안 운동하도록 지도 해주시고, 예상치 못 한 부상에 대비해 지켜봐 주세요.",
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_jprp_2",
      title1: "운동 전/후 스트레칭은 선택 아닌 필수",
      text_1:
        "어떤 운동이든 운동을 시작하기 전에 몸을 데우고 운동을 끝낸 후에 몸을 식히는 과정이 반드시 필요하다는 것, 알고 계셨나요? 스트레칭을 통해 부상을 예방해 보아요.",
      text_2:
        "줄넘기와 같은 간단한 운동을 하더라도 스트레칭은 반드시 필요해요. 목과 어깨, 팔, 손목, 허리, 무릎, 발목 등을 쭉쭉 늘리고 돌려가며 스트레칭 해주세요. 이렇게 스트레칭 하면 근육이 놀라는 것을 예방할 수 있습니다.",
      img: "jprp_22",
      title2: "안전한 줄넘기를 위해 필요한 것",
      text_3:
        "아이가 다치지 않고 안전하게 줄넘기를 하기 위해서는 다음과 같은 준비가 필요해요. \n" +
        "관절 보호를 위해 딱딱하지 않은 바닥에서 충격 흡수력이 좋은 신발을 신고 운동하는 것이 좋아요. 또, 줄넘기는 땀이 많이 나는 유산소 운동이기 때문에 통기성 좋은 옷차림을 선택하는 것이 좋아요.",
      text_4:
        "부모님께서 함께하며 아이의 체력에 맞는 강도로 적절한 시간 동안 운동하도록 지도 해주시고, 예상치 못 한 부상에 대비해 지켜봐 주세요.",
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_jprp_3",
      title1: "아이에게 맞는 줄을 골라주세요",
      text_1:
        "우리 주변에서는 많은 종류의 줄넘기 줄을 볼 수 있습니다. 구슬이 꿰여 있는 줄, 얇은 줄, 두꺼운 줄, 무거운 줄, 가벼운 줄 등 다양한 줄이 있습니다. 이 중에서 우리 아이에게 맞는 줄은 어떤 줄일까요?",
      text_2:
        "일반적으로 줄넘기를 처음 시작하는 아이에게는 너무 가벼운 줄보다는 어느정도 무게감 있는 줄을 추천한다고 합니다. 또한 아이가 쥐기에 적당한 크기의 손잡이가 달린 줄을 선택하는 것이 좋습니다. 줄의 길이는 아이가 양발로 줄을 밟았을 때 손잡이가 가슴 높이에 올 정도가 적당합니다. 아이가 좋아하는 디자인이라면 더 좋겠지요!",
      img: "jprp_32",
      title2: "올바른 줄넘기 자세",
      text_3:
        "올바른 줄넘기 자세는 다음과 같습니다.\n" +
        "첫번째, 발을 어깨너비로 벌리고 발뒤꿈치를 살짝 들어주세요.\n" +
        "두번째, 팔꿈치는 옆구리에 붙이고 손목을 이용해 줄을 돌려주세요.\n" +
        "세번째, 상체는 곧게 세우고 배에 힘을 주세요.",
      text_4:
        "모든 운동이 그렇듯, 줄넘기도 올바른 자세로 하는 것이 중요해요. 줄넘기를 할 때 발목에 순간적으로 약 4배의 하중이 실린다고 해요. 자세가 올바르지 않은 상태라면 부상을 입기 쉽겠죠? 바른 자세에서 바른 운동 효과가 온다는 점을 명심해 주세요!",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_jprp_4",
      title1: "가족과 함께하면 더 즐거워요",
      text_1:
        "운동을 할 때에 혼자보다는 여럿이 함께할 때 즐거웠던 경험이 있으실 거예요. 아이들도 마찬가지랍니다. 특히 부모님과 함께 할 때 아이들은 더 신나하지요.",
      text_2:
        "아이가 줄넘기를 할 때 함께 줄넘기를 해보면 어떨까요? 또는 부모님께서 대신 줄을 넘겨주시고, 아이가 넘도록 해보세요. 줄넘기 하는 시간이 더 즐거워질 거예요!",
      img: "jprp_42",
      title2: "꾸준한 운동을 위한 부모님의 역할",
      text_3:
        "아이가 꾸준히 운동을 즐기기 위해서는 아이의 흥미 만큼이나 부모님의 관심과 지원도 중요해요.",
      text_4:
        "아이가 성공했을 때에 칭찬을 아끼지 마세요. 아이가 좌절하거나 속상해할 때 충분히 응원하고 지지해 주세요.",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_jprp_5",
      title1: "줄넘기로 즐기는 다양한 놀이",
      text_1:
        "아이가 줄넘기를 시작하기 어려워하거나 지루함을 느끼나요? 줄넘기의 줄을 이용해 단순히 줄을 넘는 운동 뿐만 아니라 다양한 놀이를 할 수 있습니다.",
      text_2:
        "아이와 함께 양쪽에서 줄을 잡고 줄 밑으로 지나가기, 줄 피해서 점프하기와 같은 창의적인 활동을 시도해 보세요. 이러한 놀이를 통해 아이는 신체 활동의 즐거움을 느끼고, 상상력을 발휘할 기회를 얻게 됩니다. 또한, 친구들과 함께 '줄넘기 팀 릴레이'를 하거나, 누가 더 오래 넘을 수 있는지 경쟁하는 게임을 통해 협동심과 사회성을 기를 수도 있습니다. 간단한 놀이로 먼저 줄과 친해지도록 해주세요!",
      img: "jprp_52",
      title2: "음악과 함께 즐겨보아요",
      text_3:
        "줄넘기에 익숙해졌다면, 음악과 함께 줄넘기를 즐겨보는 것은 어떨까요?",
      text_4:
        "아이와 함께 음악을 고른 후, 음악의 리듬에 맞춰 줄을 넘어 보아요. 처음부터 템포가 빠른 음악을 고르기보다는 느린 음악부터 시작하는 것이 좋습니다. 이러한 놀이는 아이들이 줄넘기에 대한 흥미를 꾸준히 유지하고, 신체적·예술적 발달을 이룰 수 있도록 돕습니다.",
    },
  ],
  Walk: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_walk_1",
      title1: "산책이 주는 심리적 효과",
      text_1:
        "산책은 단순히 걷는 활동을 넘어, 아이의 심리적, 신체적 발달을 이끌어낼 수 있는 특별한 시간입니다.",
      text_2:
        "아이들은 부모와 손을 잡고 천천히 걸으며 자신만의 속도로 세상을 탐구할 수 있습니다. 이런 과정은 스트레스를 줄이고 정서적 안정감을 키워주는 데 도움을 줍니다. 특히 자연 속에서 이루어지는 산책은 아이의 창의력과 상상력을 자극하는 데 탁월합니다.",
      img: "walk_12",
      title2: "산책은 몸에도 좋아요",
      text_3:
        "산책은 아이의 신체적 발달에도 중요한 역할을 합니다. 걷고, 달리고, 점프하기도 하며 아이의 균형감각과 운동 능력이 향상될 수 있어요.",
      text_4:
        "또, 산책은 비만 예방과 면역력 강화에 도움을 주어 건강한 생활습관의 기초를 마련해 줍니다. 이러한 효과는 부모님과 함께할 때 훨씬 커진답니다.",
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_walk_2",
      title1: "산책하며 아이와 더 친해져요",
      text_1:
        "어른이 되어서도 잊지 못 할 부모님과의 추억이 하나쯤은 있으실 거예요. 산책은 부모님와 아이가 자연스럽게 대화를 나눌 수 있는 소중한 시간입니다.",
      text_2:
        "산책을 하며 서로의 하루를 이야기하고, 아이의 생각과 감정을 들어주며 아이와 조금 더 친밀하고 안정적인 관계를 형성할 수 있어요. 이렇게 함께 웃고 이야기를 나누며 쌓이는 기억들은 아이에게 있어 평생의 자산이 될 수 있습니다.",
      img: "walk_22",
      title2: "산책을 즐겁게 만드는 방법",
      text_3:
        "만약 아이가 산책하는 것을 싫어한다면 어떤 방법을 써볼 수 있을까요?",
      text_4:
        '역시, 아이들에게 정답은 놀이겠지요? 아이와 함께 목표를 정하거나 작은 놀이 요소를 추가해 보세요. 예를 들어, "오늘은 몇 종류의 꽃을 찾아볼까?"와 같은 질문을 던지며 탐구심을 자극하거나, 산책 중 들은 소리를 흉내 내는 게임을 할 수 있습니다. 이런 활동은 산책을 단순한 걷기가 아닌 모험으로 만들며, 아이가 산책을 좋아할 수 있도록 도와줍니다.',
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_walk_3",
      title1: "산책으로 과학을 배워요",
      text_1:
        "자연 속에서의 산책은 과학적인 지식을 습득할 수 있는 좋은 기회라는 사실, 알고 계셨나요?",
      text_2:
        "아이와 함께 계절에 따라 변화하는 자연을 자유롭게 관찰하며 식물, 동물, 날씨, 곤충 등을 탐색할 수 있답니다.\n" +
        "매일매일 산책을 하다보면 어제는 보이지 않던 새로운 것이 보이기도 하지요. 이러한 발견과 관찰이 아이들을 작은 과학자로 만듭니다.",
      img: "walk_32",
      title2: "관찰과 질문으로 성장하기",
      text_3:
        "산책을 하다보면 아이들의 눈과 입은 쉴 새 없이 움직여요. 눈으로는 세상을 관찰하고, 입으로는 끊임없이 질문을 하지요.\n" +
        '"이 나뭇잎은 왜 초록색이 아니야?", "다람쥐는 왜 겨울에는 안 보여?"와 같은 질문을 한다면 아이에게 어떻게 답하는 것이 좋을까요?',
      text_4:
        "아이가 이해할 수 있는 수준에 맞게 답 해주세요. 그보다 한 단계 어려운 설명도 좋습니다. 부모님의 도움이 있으면 이해할 수 있는 수준이 적당해요.\n" +
        '예를 들어, "다람쥐는 왜 겨울에는 안 보여?"라는 질문에 대하여, 여태 "다람쥐들은 추워서 코오 잔대."라고 답해주었다면 "다람쥐들은 지금 겨울잠을 자고 있어서 그래. 겨울잠은 동물들이 잠을 자면서 추운 겨울을 버티는 것을 말해."라고 말해주면 어떨까요? 산책 중 주고받는 문답을 통해 아이가 알고 있는 세상에 한 층 깊이를 더해줄 수 있답니다.',
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_walk_4",
      title1: "일관된 습관의 중요성",
      text_1:
        "유아교육기관에서는 큰 일과에 맞추어 하루를 보내요. 이는 규칙적인 일과가 아이에게 예측 가능성을 제공해 안정감을 주기 때문입니다. 가정 내에서는 어떤 일과에 따라 하루를 보내고 있나요?",
      text_2:
        "아이는 반복되는 활동을 통해 삶의 리듬을 배우고, 하루를 계획하는 법을 자연스럽게 익힙니다. 이런 경험은 아이가 성장하면서 시간을 관리하고 사회적인 규율을 지키는 데 큰 도움이 됩니다. 우리 가족의 정해진 루틴이 없다면 이번 기회에 정해보는 것은 어떨까요?",
      img: "walk_42",
      title2: "우리 가족의 약속 : 매일 산책하기",
      text_3:
        "예를 들어, 가족이 매일 저녁 산책하는 것을 우리 가족의 하루 약속으로 삼아보세요. 정해진 시간에 함께 산책하는 것은 가족 모두에게 소속감을 갖게 하며, 서로의 소중함을 다시 확인하는 계기가 될 수 있습니다.",
      text_4:
        "산책 외에는 또 어떤 루틴을 만들어볼까요? 오늘 저녁 온 가족이 둘러 앉아 가족 약속을 정하는 시간을 가져 보아요.",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_walk_5",
      title1: "건강한 부모, 건강한 아이",
      text_1:
        "부모님과 함께 산책하는 시간은 아이가 건강한 생활습관을 배우는 밑거름이 됩니다.",
      text_2:
        "'아이는 부모의 거울'이라는 말이 있지요. 저명한 교육심리학자 알버트 반두라는 아이들이 새로운 행동을 관찰하고 '모방'하면서 학습한다고 이야기합니다. 즉, 아이가 건강한 생활습관을 갖기를 바란다면 부모님이 먼저 바람직한 생활습관의 모범이 되어야 한다는 것입니다.",
      img: "walk_52",
      title2: "아이의 일상이 되는 산책",
      text_3:
        "산책을 단순히 건강을 위한 활동으로 끝내지 않고, 우리 가족만의 특별한 추억으로 남길 수 있다면 더 좋겠지요.",
      text_4:
        "산책 중 사진을 찍거나, 아이와 함께한 산책을 그림일기로 작성하는 것도 좋은 방법입니다. 이런 작은 노력들이 모여 산책을 아이의 삶에 뿌리 내리게 만듭니다. 그리고 이는 아이가 건강하고 행복한 어른으로 자라나는 데 중요한 토대가 됩니다.",
    },
  ],
  Childbook: [
    {
      index: 1,
      isRead: false,
      thumbnail: "thum_pbok1_1",
      title1: "꾸준한 독서가 아이에게 미치는 영향",
      text_1:
        "책은 어휘력, 독해력, 집중력과 인내력, 학습 성과 향상과 더불어 다양한 지식과 지혜를 얻어갈 수 있는 유용한 도구입니다. \n" +
        "\n" +
        "특히 아이의 독서의 경우, 간접 체험의 경험과 더불어 교과 학습에서 문제를 이해하고 분석하는 것에 바탕이 되는 중요한 역할을 합니다.",
      text_2:
        "그리고 나아가 책은 양질의 내용을 통해 아이들이 다양한 지식과 지혜를 자연스럽게 습득할 수 있도록 도와줍니다. \n" +
        "\n" +
        "그렇다면 스스로 책 읽는 아이로 성장하기 위해서 부모님이 어떻게 도와주면 좋을까요? ",
      img: "pbok_12",
      title2: "재밌고 쉬운 책으로 독서를 시작하도록 도와주세요.",
      text_3:
        "아이들에게는 무엇보다 책 읽는 것이 공부가 아닌 놀이처럼 느껴질 수 있도록 도와주어야 합니다.\n" +
        "\n" +
        "큰 서점 내 아동 서적 코너의 아이가 좋아하는 분야 (예, 동물 등) 에 데려가서 좋아하는 책을 직접 고르도록 해주세요. 어떤 책이든 좋아요.",
      text_4:
        "무엇보다 아이들이 책에 재미를 붙이고 자연스럽게 독서 시간이 늘어나는 것이 중요합니다.\n" +
        "\n" +
        "부모님의 역할은 아이가 고른 책의 어휘, 내용 등의 난이도가 적합한지를 판단하는 정도로 충분합니다.",
    },
    {
      index: 2,
      isRead: false,
      thumbnail: "thum_pbok1_2",
      title1: "책의 내용을 바탕으로 아이와 대화를 나누세요.",
      text_1:
        "책을 읽는 것이 익숙하지 않은 아이들은 내용을 제대로 이해하지 못하고 글자를 읽는 수준의 독서를 할 수도 있습니다. 또는 그림으로 내용을 유추하는 정도일 수도 있지요.\n" +
        "\n" +
        "이 경우 아이가 책을 읽으며 줄거리의 내용을 이해할 수 있도록 부모님께서 질문을 통해 도움을 줄 수 있습니다.",
      text_2:
        "예를 들어, 아이에게 “주인공이 어떤 행동을 했지?”, “주인공이 왜 그런 행동을 했지?” 등의 질문을 하고, 아이가 이에 답을 생각해보는 과정 자체가 도움이 될 수 있습니다. \n" +
        "\n" +
        "그리고 더 나아가 “~라면 어땠을까?”, “~라면 어떤 생각이 들었을까?” 등의 아이의 관점에서 더 확장해서 생각해볼 수 있는 질문도 도움이 됩니다.",
      img: "pbok_22",
      title2: "책 이야기를 아이를 통해 들어보세요.",
      text_3:
        "아이가 책 내용을 부모에게 설명할 수 있는 기회를 주세요. 완전히 다른 이야기를 할 수도 있습니다. 하지만 이야기를 처음부터 끝까지 이야기해볼 수 있게 도와주세요. 아이 스스로 이야기를 구성해 볼 수 있는 기회가 됩니다.",
      text_4:
        "어린 아이들을 위해서는 동화책과 그림책을 활용하세요. 아름다운 그림과 이야기가 아이들의 상상력을 자극할 것입니다.\n" +
        "\n" +
        "부모님은 아이들이 책을 읽고 상상력을 키울 수 있도록 도울 수 있습니다. 책은 아이들에게 지식을 넘어, 상상력과 창의력을 키우는 소중한 도구입니다.",
    },
    {
      index: 3,
      isRead: false,
      thumbnail: "thum_pbok1_3",
      title1: "부모님이 아이와 함께 책을 읽어주세요.",
      text_1:
        "결국에는 책이 익숙한 아이들이 책을 더 많이 읽게 됩니다. 이를 위해 가장 좋은 방법은 부모님이 아이와 함께 책을 읽는 것입니다.\n" +
        "\n" +
        "부모님께서 꾸준히 정해진 시간에 아이를 데리고 책을 읽어주세요. 만약 아이가 한글을 읽을 수 있다면, 아이에게 책을 읽어주다가 일부는 아이 스스로 책을 읽도록 유도하는 것도 좋은 방법입니다.",
      text_2:
        "책을 통해 부모님과 자연스럽게 소통하고, 함께 책을 읽음으로써 아이가 부모님의 온기를 느낄 수 있다면 아이의 정서발달에도 더할 나위 없이 좋을 것입니다.\n" +
        "\n" +
        "혹은 부모님이 먼저 책을 읽는 습관을 기르고 아이가 자연스럽게 보고 따라 할 수 있도록 하는 것도 좋은 방법입니다.",
      img: "pbok_32",
      title2: "이야기에 대해 아이와 토론해보세요.",
      text_3:
        "아이들이 책을 읽을 때 그들의 생각과 감정을 공감하고 이해해주는 것이 중요합니다. 책에 대해 토론하고 함께 이야기를 나누는 것은 아이들의 이해와 상상력을 키우는 데 도움이 됩니다.",
      text_4:
        "책을 읽는 경험이 즐거운 기억이 될 수 있게 도와주세요. 많이 읽는 것도 중요하지만, 어떤 생각을 했는지도 중요한 문제입니다. 아이가 책을 읽고 어떤 생각을 하는지 꼭 물어봐주세요.",
    },
    {
      index: 4,
      isRead: false,
      thumbnail: "thum_pbok1_4",
      title1: "아이 수준에 적합한 책을 골라주세요.",
      text_1:
        "책을 읽는 것은 언어 능력을 향상시키는데 큰 역할을 합니다. 어휘력, 문법, 읽기 이해력을 향상시켜주며, 이는 글쓰기 및 의사 표현 능력을 키우는데 도움이 됩니다.",
      text_2:
        "아이가 읽고 이해할 수 있는 표현의 책을 권해주세요. 너무 어려운 책은 아이에게 반감이나 좌절감을 줄 수 있습니다.",
      img: "pbok_42",
      title2: "아이가 좋아할만한 책으로 선택해주세요.",
      text_3:
        "자녀가 읽고 싶은 책을 선택하고, 자신의 관심사에 맞게 독서를 즐길 수 있도록 존중해주세요. 아이와 함께 서점에서 책을 골라보는 것은 좋은 경험이 될 거예요.",
      text_4:
        "너무 어려워서 아이가 거부할만한 책은 좋지 않습니다. 아이가 흥미를 느낄 수 있는 내용을 담는 책을 함께 골라보세요.",
    },
    {
      index: 5,
      isRead: false,
      thumbnail: "thum_pbok1_5",
      title1: "독서 시간을 만들어주세요",
      text_1:
        "가정에서 정기적인 독서 시간을 만들어주세요. 특히 취침 전 독서 시간을 만들면, 자녀가 스트레스를 풀고 편안하게 책을 즐길 수 있습니다.",
      text_2:
        "독서는 즐거운 경험이어야 합니다. 자녀가 강제로 독서를 해야한다고 느끼지 않도록 주의해주세요.",
      img: "pbok_52",
      title2: "함께 독서를 실천해보세요.",
      text_3:
        "부모님 스스로 독서 습관을 가지고, 자녀에게 모범이 되어주세요. 가정에서 부모님이 책을 읽고 있는 모습을 자주 보이면, 자녀도 자연스럽게 독서에 흥미를 느낄 수 있습니다.",
      text_4:
        "부모님도 독서를 즐기는 모습을 보여야, 아이도 책 읽기를 '일'이나 '공부'로 받아들이지 않을 수 있습니다. 오늘 저녁, 온 가족이 모여 즐거운 독서 시간을 가져보면 어떨까요?",
    },
  ],
};

export type StateContentType = {
  index: number;
  isRead: boolean;
  title1: string;
  content: string;
  text_1: string;
  text_2: string;
  text_3: string;
  text_4: string;
  thumbnail: string;
  img: string;
  readDt?: string;
};

export type StateContentsType = {
  [val: string]: StateContentType[];
};
export const initStateContents: StateContentsType = {
  selfControl: [
    {
      index: 1,
      isRead: false,
      title1: "자기통제란 무엇인가? (1)",
      content: "- 일반적인 자기통제(성인) 예시- 자기통제의 특징: ego-depletion",
      text_1:
        "자기통제는 무엇일까요? 전문가들은 자기통제 능력에 대해 &#39;목표를 달성하기 위해 행동을 조절하는 능력&#39;, &#39;만족을 지연하는 능력&#39;, &#39;유혹에 저항하는 능력&#39;이라고 설명해요. 즉, 목표를 달성하기 위해 순간의 충동적인 욕구나 행동을 억제할 수 있는 능력을 말해요. 본능적인 반응을 상황에 맞게 조절하는 것이지요.",
      text_2:
        "자기통제 능력은 일상에서 어떻게 나타날까요? 자기통제를 발휘하면 일하는 동안 일의 능률을 올리기 위해 SNS를 들여다보지 않을 수 있어요. 예산에 맞춰 생활하기 위해 충동구매하지 않을 수 있고요. 건강관리를 위해 규칙적으로 운동하거나 과자나 음료수를 마시지 않을 수 있습니다. 조금 더 놀고 싶지만 충분한 수면 시간을 확보하기 위해 일찍 잠자리에 들 수 있는 것도 자기통제의 역할이에요.",
      text_3:
        "자기통제 능력은 아주 중요한 특징이 있어요. 바로 사람마다 쓸 수 있는 양이 한정되어 있다는 것입니다. 각자 크게가 다른 자기통제 바구니에 오늘 쓸 수 있는 양이 담겨있는 것이에요. 그렇기 때문에 하나의 과제에 모든 의지를 다 써버린 경우 다음의 과제를 수행하는 데 필요한 에너지가 없을 수 있어요.",
      text_4:
        "예를 들어, 새로운 회사에 입사해 일을 시작한 지 얼마 되지 않았을 때에는 그 회사에 적응하느라 자기통제 능력을 다 써버릴 수 있어요. 그 상태에서 동시에 다이어트를 시도하는 것은 실패할 확률이 높습니다. 하지만 회사에 적응이 끝난 후에는 어떨까요?　더 이상 내 바구니에 있는 자기통제 능력을 사용하지 않고도 회사생활을 할 수 있기 때문에, 남은 에너지를 다이어트에 쓸 수 있게 됩니다. 그러니 자기통제력을 발휘해야 하는 과제는 한 번에 한 가지씩 정하는 것이 성공 확률을 높일 수 있습니다.",
      thumbnail: "selfControl_thumbnail",
      img: "selfControl1_img",
      readDt: "",
    },
    {
      index: 2,
      isRead: false,
      title1: "자기통제란 무엇인가? (2)",
      content: "- 자기통제의 발달- 아동의 자기통제와 예시",
      text_1:
        "저번 시간에 자기통제 능력이 무엇인지 자세히 알아보았어요. 그렇다면 우리 아이의 자기통제 능력은 언제부터 발달할까요? 자기통제 능력은 학교 들어가기 전, 유아기(만 2세)부터 발달하기 시작하고, 학교에 입학하는 시기인 아동기(만 6세) 때 급격하게 증가해요.",
      text_2:
        "아동기때 이 능력이 눈부시하게 발달하는 이유는 바로 인지적으로 성숙해지기 때문이에요. 자신의 생각과 행동을 조절할 수 있는 효율적인 전략을 사용할 수 있게 되고, 자기통제가 왜 필요하고 중요한지에 대해 이해할 수 있게 되거든요. 그렇기 때문에 대부분의 나라에서 비슷한 시기에 학교생활을 시작하는 것입니다.",
      text_3:
        "우리 아이의 자기통제 능력은 학교에서 어떻게 발휘될까요? 수업시간에 옆 친구와 이야기 하고 싶지만, 수업시간이기 때문에 꾹 참을 수 있습니다. 친구가 말할 때 내가 하고 싶은 말이 생각나 말을 끊고 싶지만, 친구의 말이 끝날 때까지 기다릴 수 있어요. 선생님이 말씀하실 때 자꾸 떠오르는 다른 생각들을 잠시 멈추고 선생님 말씀을 잘 듣고 따를 수 있어요. 숙제를 하다가 갑자기 재밌는 생각이 나도 다시 숙제에 집중하여 끝마칠 수 있어요. ",
      text_4:
        "우리 아이의 원만하고 즐거운 학교생활을 위해 필요한 한 가지를 꼭 고르라면, 자기통제 능력을 뽑을 수 있겠네요! 우리 아이의 즐거운 학교생활을 위해 자기통제 능력을 길러주세요.",
      thumbnail: "selfControl_thumbnail",
      img: "selfControl2_img",
      readDt: "",
    },
    {
      index: 3,
      isRead: false,
      title1: "‘자기통제’의 이점 - 자기통제와 관련된 변인들",
      content: "- 높은 자기효능감- 높은 학업성취도- 종단연구 ",
      text_1:
        "자기통제 능력이 높으면 어떤 점이 좋을까요? 자기통제 능력이 높은 아이들은 사회적 규칙을 잘 지키고 친구들, 선생님과 원만하게 지낼 수 있어요. 그렇기 때문에 주변에서 대체로 좋은 피드백을 받고 자라며, 자신이 무엇이든 잘 할 수 있다고 믿는 자기 효능감이 높은 아이로 자라게 됩니다. ",
      text_2:
        "특히, 자기통제 능력은 학업적 성취와 관련이 높아요. 자신의 욕구와 행동을 상황에 맞게 잘 조절하는 아이들은 시험에서 더 높은 점수를 받고 등수 역시 높았다고 해요. 더욱 놀라운 사실은 학업 성취도를 예측함에 있어 우리가 흔히 IQ라고 말하는 지능 지수보다 자기통제 능력이 더 중요한 영향을 미쳤다는 것이에요. ",
      text_3:
        "전문가들은 자기통제 능력이 높은 아이들이 커서 어떤 어른이 되는지 관찰하고 연구했어요. 목표 달성을 위해 욕구와 행동을 잘 조절하는 아이들은 커서도 더 행복한 삶을 살았으며 오랫동안 그러한 결과가 유지되었다고 해요. 어릴 때 높은 수준의 자기통제 능력을 가진 아이들이 더 신체적으로 건강하고 경제적으로 안정되었으며 자신의 분야에서 인정받는 어른이 되었다고 합니다. ",
      text_4:
        "욕구와 행동을 잘 조절하는 능력이 우리아이의 현재 학교생활과 미래의 건강, 직업적 성취에도 좋은 영향을 미칠 수 있다니, 정말 놀랍지 않으신가요? 멋지게 성장 할 우리아이의 모습을 떠올리며 오늘도 ‘나를 조절해가는 연습’에 함께 참여해주세요!",
      thumbnail: "selfControl_thumbnail",
      img: "selfControl3_img",
      readDt: "",
    },
    {
      index: 4,
      isRead: false,
      title1: "자기통제 능력 키우기 (1)",
      content: "- 자기통제 능력이 향상되는 원리",
      text_1:
        "우리 아이의 자기통제 능력을 쑥쑥 키우기 위해서는 엄마, 아빠의 도움이 필요합니다. 어릴 때는 거의 대부분 엄마, 아빠의 감독에 의해 행동을 조절해요. 엄마, 아빠가 대신 아이의 행동을 조절해 주는 셈이지요. ",
      text_2:
        "아이가 커가면서 엄마, 아빠의 규준을 배우고, 규준을 따르게 해 주는 자기통제 기술을 배우게 됩니다. 이를 통해 자기통제 능력을 점차 자신의 것으로 만들어 스스로 조절할 수 있게 되는 것이지요. 즉, 스스로 조절할 수 있을 때까지 엄마, 아빠와 함께 조절해보는 연습이 필요합니다.",
      text_3:
        "매일 조금씩이라도 자기통제가 필요한 활동에 참여하여 연습해보는 것이 중요해요. 행동을 조절하는 연습을 반복할수록 자기통제 능력이 향상된다고 합니다. 우리 아이의 바구니 크기가 커져서 한 번에 발휘할 수 있는 자기통제 양이 늘어나는 것이지요.",
      text_4:
        "우리 아이와 연습해볼 활동들에는 무엇이 있을까요? 식사 후 양치하기, 하교 후 숙제하기, 엄마, 아빠 말을 끝까지 듣기와 같은 것들이 될 수 있어요. 오늘은 아이와 함께 활동 목록을 만들어 보세요. 다음 시간에는 좀 더 효과적으로 연습할 수 있는 팁을 알려드릴게요. ",
      thumbnail: "selfControl_thumbnail",
      img: "selfControl4_img",
      readDt: "",
    },
    {
      index: 5,
      isRead: false,
      title1: "자기통제 능력 키우기 (2)",
      content: "- 한 번에 한 가지 목표에만 집중하기- 유혹 피하기 연습",
      text_1:
        "자기통제 바구니를 키워주기 위해 구체적으로 어떻게 해볼 수 있을까요? 첫 번째, ‘한 번에 한 가지 목표에만 집중하기’입니다. 저번 시간에 자기통제 바구니 안에 들어 있는 에너지를 한 곳에 다 써버리면 다른 곳에 쓸 수 없다고 했던 것, 기억하시나요? 우리 아이도 똑같아요. 아이가 꼭 필요한 순간에 최대치의 통제력을 발휘하기 위해서는 다른 곳에서 아껴 써야합니다. 그렇기 때문에 한 번에 많은 목표를 설정하는 것은 상당히 비효율적이에요. 하나의 구체적인 목표를 선택하여 그 목표에 에너지를 집중하는 것이 가장 좋습니다. 목표 달성을 위해 필요한 행동을 한 번 습관화 시키면 더 이상 그 행동을 유지하기 위해 이전만큼의 노력을 기울일 필요가 없어요. 그 후에는 또 다른 목표를 이루는 데 통제력을 쓸 수 있게 됩니다. ",
      text_2:
        "예를 들어, 우리 아이가 새 학기 목표로 ‘일찍 일어나기’, ‘시간에 맞춰 등교 준비하기’, ‘하교 후 숙제하기’ 이렇게 세 가지를 정했다고 생각해 볼까요? 세 가지를 한꺼번에 달성하려면 바구니 속 통제력을 조금씩 나눠 써야 해서 결국 세 가지 다 이루지 못할 수 있어요. 세 개 중 가장 중요한 것부터 우선순위를 정하여 습관화 시킨 후 다음 목표로 넘어간다면 성공 확률이 더 높아집니다.",
      text_3:
        "두 번째, ‘유혹 피하기 연습’입니다. 자기통제 바구니 안에 들어 있는 의지력은 꼭 필요한 순간에 써야하기 때문에, 작은 유혹들을 조절하는 데 쓰지 않도록 잘 관리해줘야 해요. 예를 들어, 아이가 숙제를 해야 하는 데 통제력을 사용해야 한다면, 게임시간을 조절하는 데에는 사용하지 않도록 하는 것이 좋겠지요.",
      text_4:
        "그렇다면 소소한 유혹들을 피하는 효과적인 방법은 무엇이 있을까요? 바로 빠르게 주의를 전환할 만한 ‘건강한 활동’을 미리 정해놓는 것입니다. 게임을 하고 싶은 순간에 엄마와 함께 쓰레기를 버리고 온다던지, 함께 빨래를 개거나 물을 한 잔 따라 마시는 등, 그 순간 유혹하는 것으로부터 생각을 돌릴 수 있도록 하는 어떤 활동이든 해볼 수 있습니다. ",
      thumbnail: "selfControl_thumbnail",
      img: "selfControl5_img",
      readDt: "",
    },
  ],
  Attention: [
    {
      index: 1,
      isRead: false,
      title1: "주의력이 부족한 아동의 특징",
      content: "- DSM-5 ADHD 주의력 결핍 우세형 진단기준",
      text_1:
        "주의력은 한 가지에만 의도적으로 의식을 집중시키는 능력을 말해요. 주의력이 부족한 아이들은 자기통제 능력을 발휘하는 것이 더 어려울 수 있습니다. 그렇다면 주의력이 부족한 경우, 구체적으로 어떤 모습으로 나타날까요?",
      text_2:
        "주의력이 부족하면 세부적인 것에 주의를 기울이지 못 하거나 부주의한 실수를 많이 합니다. 알림장에서 몇 가지 내용을 빠뜨리고 읽어 미리 챙기지 못 한다거나 문제를 풀 때 중요한 정보를 빼고 읽어 제대로 풀지 못 하는 일이 종종 발생하죠. 또한 과제나 다른 놀이를 할 때에도 지속적으로 집중하는 것이 어려워 보입니다. 잠깐 흥미를 가졌다가 금세 자세가 흐트러지고 다른 곳에 주의를 돌리는 것이에요. ",
      text_3:
        "뿐만 아니라 과제나 활동할 때, 하루를 보낼 때 과제의 내용과 시간을 체계화하는 데 어려움이 있어요. 어떤 순서로 과제를 처리해야 하는지 알지 못하고, 자신의 물건을 찾기 쉽게 정리하지 못 하며, 시간 관리를 잘 못 해 아무 일도 하지 못한 채 하루가 흘러가버리곤 합니다. ",
      text_4:
        "다른 사람과의 관계에서는 어떨까요? 주의력이 부족한 아이들은 가끔 다른 사람이 말할 때 경청하지 않는 것처럼 보여요. 눈을 맞추기보다 계속 다른 곳을 멍하니 응시하거나 다른 것에 흥미를 느끼죠. 유사한 맥락으로 엄마, 아빠나 선생님의 지시를 따르기 어려워합니다. 듣고 있는 내용에 주의를 기울여 기억하는 능력인 청각적 주의력이 떨어지기 때문이죠. ",
      thumbnail: "Attention_thumbnail",
      img: "Attention1_img",
      readDt: "",
    },
    {
      index: 2,
      isRead: false,
      title1: "주의력이 부족한 아이를 위한 팁 (1)",
      content: "- 일상 루틴 만들기",
      text_1:
        "저번 시간에 주의력이 부족한 아이들의 몇 가지 특징들에 대해 살펴보았어요. 오늘부터는 이 아이들에게 도움이 될 수 있는 팁들을 배워보려고 해요. 먼저 금방 산만해져서 과제를 잘 끝마치지 못 하고 시간, 물건, 과제 등을 잘 정돈하지 못 하는 아이들에게 도움이 될 만한 방법에 대해 이야기해 봐요.",
      text_2:
        "일상이 늘 정신없고 꼭 하나씩 빠뜨리는 아이. 힘들게 숙제를 시작하더라도 금방 다른 것에 주의를 돌리는 아이. 이런 아이들에게는 일상의 구조를 만들어 주는 것이 중요합니다. 그리고 그 구조 안에서 생활할 수 있도록 도와주셔야 해요. 한 연구에서 주의력이 부족한 아이들은 예측 가능한 루틴과 장소에서 과제를 수행할 때, 그렇지 않은 환경일 때보다 끝까지 과제를 완수할 확률이 높았다고 밝혔어요. 그러니 엄마, 아빠는 집에서 공간적, 시간적인 루틴을 만들어 구조화시키고, 그 루틴에 익숙해지도록 연습하는 과정을 함께 해주셔야 합니다.",
      text_3:
        "루틴을 만드는 것은 어떤 활동의 시간과 장소를 정해 그대로 유지하는 것이에요. 매일매일 똑같이 반복되면 아이들은 내일도 루틴이 반복될 것이라고 기대할 것이고 그 기대대로 이루어지는 것을 경험하겠죠. 그럼 아이들은 안정감을 느낄 수 있고, 그 루틴 자체가 체계화에 대한 모델이 되며, 일상을 정리하는 데에 따로 주의를 기울이지 않아도 되니 다른 곳에 더 집중할 수 있게 됩니다. ",
      text_4:
        "예를 들어 볼게요. 학교에 다녀온 뒤 가방 정리하는 루틴을 만들어 볼 수 있어요. ‘집에 들어와 화장실 앞에 가방을 벗는다, 손을 씻는다, 가방을 챙겨 방으로 간다, (미리 정한)가방 바구니에 가방을 넣고 자크를 연다, 안에 있는 알림장, 노트 등을 꺼낸다.’와 같이요. ‘학교 다녀온 직후’가 미리 정한 시간이 되고요, ‘방, 책상 앞, 가방 바구니’가 장소가 될 수 있겠죠. 자기 전 학교 갈 준비를 하는 루틴을 만들 수도 있어요. ‘양치를 한다, 방에 가서 내일 입을 고른다, 옷 바구니에 옷을 넣어둔다’ 이런 식으로요. ",
      thumbnail: "Attention_thumbnail",
      img: "Attention2_img",
      readDt: "",
    },
    {
      index: 3,
      isRead: false,
      title1: "주의력이 부족한 아이를 위한 팁 (2)",
      content:
        "- 이름 부르고 눈 맞추기- 명확하고 간결하게 이야기하기- 이해한 내용 확인하기",
      text_1:
        "오늘은 주의력이 부족해 대화할 때 경청하지 않고 지시를 따르지 못 하는 아이들에게 도움이 되는 내용을 준비했어요. 이런 아이들에게 무언가를 지시할 때 좀 더 집중할 수 있도록 돕는 팁이 있습니다.",
      text_2:
        "먼저 대화를 시작할 때 아이의 이름을 명확히 부르고 눈을 맞춰야 합니다. 보통 엄마, 아빠가 말을 시작하는 상황을 떠올려보면, 엄마, 아빠도 요리나 스마트폰 같이 무언가를 하면서 말하거나, 아이도 다른 무언가를 하고 있는 상황일 경우가 많습니다. 이런 상태에서 말을 시작하면 주의력이 부족한 아이는 잘 듣지 못 해요. 중요한 이야기를 해야 한다면 아이의 이름을 부르고, 눈을 맞추었는지, 들을 준비가 되었는지 확인하고 말을 시작하는 게 좋아요. 아이가 다른 데 너무 빠져있다면 가까이 가서 어깨를 툭툭 치거나 손을 잡고 이야기해도 됩니다. ",
      text_3:
        "들을 준비가 되었다면, 명확하고 간결하게 전달해야 합니다. 길게 말하면 집중력이 흐트러져 단 한 개의 내용도 기억하지 못 하기 때문이에요. ‘명확하고 간결하게’ 이야기를 하는 것이 간단해 보이지만, 시도해 보시면 생각보다 어렵다고 느끼실 수 있어요. 많은 정보를 담고 싶다보면 더 길고 장황해질 수도 있고요. 그렇기 때문에 처음에는 엄마, 아빠도 연습이 필요합니다. 어떤 내용이 꼭 필요하고 가장 중요한지 정하고, 그 내용을 최대한 짧고 명확하게 전달하는 방법을 고민해보세요. ",
      text_4:
        "마지막으로 이야기를 마친 후에 아이에게 이해한 내용을 확인해봅니다. “엄마, 아빠가 한 이야기 잘 들었니?”, “네가 이해한 걸 다시 얘기해 볼래?”라고 말이에요. 기억하지 못 한다면 다시 설명해주세요. 아이가 들은 것을 다시 이야기하기 위해서는 많은 주의력이 요구됩니다. 그리고 자기가 이해한 대로 재진술 해보는 경험이 반복되면 다른 사람의 이야기를 들을 때 좀 더 집중하여 들을 수 있게 돼요.",
      thumbnail: "Attention_thumbnail",
      img: "Attention3_img",
      readDt: "",
    },
    {
      index: 4,
      isRead: false,
      title1: "유아기 아동의 주의력 향상을 돕는 놀이",
      content: "- 컵섞기 게임- 메모리 게임- 다른 그림 찾기",
      text_1:
        "아이들은 즐거움과 흥미를 느끼는 활동에 좀 더 집중력을 발휘할 수 있습니다. 그러니 놀이를 활용하면 주의력을 향상시키는 데 더 도움이 될 수 있어요. 오늘은 주의력 향상에 도움이 되는 간단한 놀이들을 소개해 드릴 건데요. 아직 어린이집이나 유치원에 다니는 유아나 초등학교 저학년 아이들이 해보기에 좋을 거예요. ",
      text_2:
        "먼저 ‘종이컵 섞기 게임’입니다. 종이컵 2-3개를 뒤집어 놓고, 컵 한 개에 작은 물건을 숨깁니다. 컵을 빠르게 섞어 어떤 컵에 물건이 들어 있는지 아이가 맞춰보는 게임이에요. 컵을 섞는 동안 순간적으로 집중하여 눈으로 따라가야 맞출 수 있어요. 관찰력과 집중력을 키워주는 데 큰 도움이 됩니다.",
      text_3:
        "두 번째는 ‘메모리 게임’이에요. 같은 그림이 두 개씩 있는 카드 여러 장을 뒤집어 놓고, 같은 그림 카드 두 장을 찾는 게임이에요. 카드 두 장을 동시에 뒤집어서 같은 그림이 나오면 점수를 얻고, 다른 그림이 나오면 다시 뒤집어 놓습니다. 어디에 어떤 그림이 있었는지 확실히 알고 기억해야 하기 때문에, 집중력과 기억력 발달에 좋은 게임이에요.",
      text_4:
        "세 번째는 ‘다른 그림 찾기’입니다. 예전에 ‘틀린 그림 찾기’라고도 불렀던 게임인데요. 비슷해 보이는 두 개의 그림에서 서로 다른 부분을 찾는 거예요. 세부적인 것들까지 면밀히 살피는 연습을 할 수 있어서 부주의함을 개선하고 관찰력을 기르는 데 많은 도움이 됩니다.",
      thumbnail: "Attention_thumbnail",
      img: "Attention4_img",
      readDt: "",
    },
  ],
  Responsibility: [
    {
      index: 1,
      isRead: false,
      title1: "주의력이 부족한 아이를 위한 팁 (1)",
      content: "- 일상 루틴 만들기",
      text_1:
        "저번 시간에 주의력이 부족한 아이들의 몇 가지 특징들에 대해 살펴보았어요. 오늘부터는 이 아이들에게 도움이 될 수 있는 팁들을 배워보려고 해요. 먼저 금방 산만해져서 과제를 잘 끝마치지 못 하고 시간, 물건, 과제 등을 잘 정돈하지 못 하는 아이들에게 도움이 될 만한 방법에 대해 이야기해 봐요.",
      text_2:
        "일상이 늘 정신없고 꼭 하나씩 빠뜨리는 아이. 힘들게 숙제를 시작하더라도 금방 다른 것에 주의를 돌리는 아이. 이런 아이들에게는 일상의 구조를 만들어 주는 것이 중요합니다. 그리고 그 구조 안에서 생활할 수 있도록 도와주셔야 해요. 한 연구에서 주의력이 부족한 아이들은 예측 가능한 루틴과 장소에서 과제를 수행할 때, 그렇지 않은 환경일 때보다 끝까지 과제를 완수할 확률이 높았다고 밝혔어요. 그러니 엄마, 아빠는 집에서 공간적, 시간적인 루틴을 만들어 구조화시키고, 그 루틴에 익숙해지도록 연습하는 과정을 함께 해주셔야 합니다.",
      text_3:
        "루틴을 만드는 것은 어떤 활동의 시간과 장소를 정해 그대로 유지하는 것이에요. 매일매일 똑같이 반복되면 아이들은 내일도 루틴이 반복될 것이라고 기대할 것이고 그 기대대로 이루어지는 것을 경험하겠죠. 그럼 아이들은 안정감을 느낄 수 있고, 그 루틴 자체가 체계화에 대한 모델이 되며, 일상을 정리하는 데에 따로 주의를 기울이지 않아도 되니 다른 곳에 더 집중할 수 있게 됩니다. ",
      text_4:
        "예를 들어 볼게요. 학교에 다녀온 뒤 가방 정리하는 루틴을 만들어 볼 수 있어요. ‘집에 들어와 화장실 앞에 가방을 벗는다, 손을 씻는다, 가방을 챙겨 방으로 간다, (미리 정한)가방 바구니에 가방을 넣고 자크를 연다, 안에 있는 알림장, 노트 등을 꺼낸다.’와 같이요. ‘학교 다녀온 직후’가 미리 정한 시간이 되고요, ‘방, 책상 앞, 가방 바구니’가 장소가 될 수 있겠죠. 자기 전 학교 갈 준비를 하는 루틴을 만들 수도 있어요. ‘양치를 한다, 방에 가서 내일 입을 고른다, 옷 바구니에 옷을 넣어둔다’ 이런 식으로요. ",
      thumbnail: "Responsibility_thumbnail",
      img: "Responsibility1_img",
      readDt: "",
    },
    {
      index: 2,
      isRead: false,
      title1: "주의력이 부족한 아이를 위한 팁 (2)",
      content:
        "- 이름 부르고 눈 맞추기- 명확하고 간결하게 이야기하기- 이해한 내용 확인하기",
      text_1:
        "오늘은 주의력이 부족해 대화할 때 경청하지 않고 지시를 따르지 못 하는 아이들에게 도움이 되는 내용을 준비했어요. 이런 아이들에게 무언가를 지시할 때 좀 더 집중할 수 있도록 돕는 팁이 있습니다.",
      text_2:
        "먼저 대화를 시작할 때 아이의 이름을 명확히 부르고 눈을 맞춰야 합니다. 보통 엄마, 아빠가 말을 시작하는 상황을 떠올려보면, 엄마, 아빠도 요리나 스마트폰 같이 무언가를 하면서 말하거나, 아이도 다른 무언가를 하고 있는 상황일 경우가 많습니다. 이런 상태에서 말을 시작하면 주의력이 부족한 아이는 잘 듣지 못 해요. 중요한 이야기를 해야 한다면 아이의 이름을 부르고, 눈을 맞추었는지, 들을 준비가 되었는지 확인하고 말을 시작하는 게 좋아요. 아이가 다른 데 너무 빠져있다면 가까이 가서 어깨를 툭툭 치거나 손을 잡고 이야기해도 됩니다. ",
      text_3:
        "들을 준비가 되었다면, 명확하고 간결하게 전달해야 합니다. 길게 말하면 집중력이 흐트러져 단 한 개의 내용도 기억하지 못 하기 때문이에요. ‘명확하고 간결하게’ 이야기를 하는 것이 간단해 보이지만, 시도해 보시면 생각보다 어렵다고 느끼실 수 있어요. 많은 정보를 담고 싶다보면 더 길고 장황해질 수도 있고요. 그렇기 때문에 처음에는 엄마, 아빠도 연습이 필요합니다. 어떤 내용이 꼭 필요하고 가장 중요한지 정하고, 그 내용을 최대한 짧고 명확하게 전달하는 방법을 고민해보세요. ",
      text_4:
        "마지막으로 이야기를 마친 후에 아이에게 이해한 내용을 확인해봅니다. “엄마, 아빠가 한 이야기 잘 들었니?”, “네가 이해한 걸 다시 얘기해 볼래?”라고 말이에요. 기억하지 못 한다면 다시 설명해주세요. 아이가 들은 것을 다시 이야기하기 위해서는 많은 주의력이 요구됩니다. 그리고 자기가 이해한 대로 재진술 해보는 경험이 반복되면 다른 사람의 이야기를 들을 때 좀 더 집중하여 들을 수 있게 돼요.",
      thumbnail: "Responsibility_thumbnail",
      img: "Responsibility2_img",
      readDt: "",
    },
    {
      index: 3,
      isRead: false,
      title1: "유아기 아동의 주의력 향상을 돕는 놀이",
      content: "- 컵섞기 게임- 메모리 게임- 다른 그림 찾기",
      text_1:
        "아이들은 즐거움과 흥미를 느끼는 활동에 좀 더 집중력을 발휘할 수 있습니다. 그러니 놀이를 활용하면 주의력을 향상시키는 데 더 도움이 될 수 있어요. 오늘은 주의력 향상에 도움이 되는 간단한 놀이들을 소개해 드릴 건데요. 아직 어린이집이나 유치원에 다니는 유아나 초등학교 저학년 아이들이 해보기에 좋을 거예요. ",
      text_2:
        "먼저 ‘종이컵 섞기 게임’입니다. 종이컵 2-3개를 뒤집어 놓고, 컵 한 개에 작은 물건을 숨깁니다. 컵을 빠르게 섞어 어떤 컵에 물건이 들어 있는지 아이가 맞춰보는 게임이에요. 컵을 섞는 동안 순간적으로 집중하여 눈으로 따라가야 맞출 수 있어요. 관찰력과 집중력을 키워주는 데 큰 도움이 됩니다.",
      text_3:
        "두 번째는 ‘메모리 게임’이에요. 같은 그림이 두 개씩 있는 카드 여러 장을 뒤집어 놓고, 같은 그림 카드 두 장을 찾는 게임이에요. 카드 두 장을 동시에 뒤집어서 같은 그림이 나오면 점수를 얻고, 다른 그림이 나오면 다시 뒤집어 놓습니다. 어디에 어떤 그림이 있었는지 확실히 알고 기억해야 하기 때문에, 집중력과 기억력 발달에 좋은 게임이에요.",
      text_4:
        "세 번째는 ‘다른 그림 찾기’입니다. 예전에 ‘틀린 그림 찾기’라고도 불렀던 게임인데요. 비슷해 보이는 두 개의 그림에서 서로 다른 부분을 찾는 거예요. 세부적인 것들까지 면밀히 살피는 연습을 할 수 있어서 부주의함을 개선하고 관찰력을 기르는 데 많은 도움이 됩니다.",
      thumbnail: "Responsibility_thumbnail",
      img: "Responsibility3_img",
      readDt: "",
    },
    {
      index: 4,
      isRead: false,
      title1: "단체생활이 어려운 아동의 특징 (1)",
      content: "- 충동조절의 어려움",
      text_1:
        "아이와 도서관에 갔는데 자꾸 뛰어다니고 큰 소리로 이야기해서 곤란했던 적이 있으신가요? 학교에서 계속 규칙을 어기고 문제행동이 잘 고쳐지지 않는다는 피드백을 받으신 적이 있으신가요? 우리 아이가 집단에서의 책임감이 부족하다고 느껴지실 거예요. ",
      text_2:
        "이런 모습을 보이는 아이들은 특히 충동 조절과 행동 조절이 어려워 그럴 수 있습니다. 자기통제 능력 안에는 여러 통제 영역이 있어요. 그 중 ‘충동통제 능력’과 ‘행동통제 능력’이 부족한 아이들이 단체 생활에서 규칙 지키기를 어려워합니다. 오늘은 충동통제 능력이 부족한 아이들의 특징에 대해 알아볼게요.",
      text_3:
        "충동통제가 어려운 경우, 자신의 차례를 잘 기다리지 못 합니다. 보드게임을 할 때 자신의 차례가 올 때까지 기다리지 못 하고 자꾸 끼어들거나, 먼저 카드를 뒤집어보는 등의 모습을 보입니다. 대화할 때 자신의 차례를 기다리는 것 역시 힘들어해요. 그래서 다른 사람의 말이 끝나기 전에 성급하게 대답하거나 말을 끊고 자신의 이야기를 하기도 하죠. 또한 자신이 만지고 싶거나 궁금한 것이 있으면 바로 만져요. ‘지금 만질 수 있는 것인가?’, ‘누구의 것인가?’와 같은 생각을 하지 않고 그냥 가져가 버립니다.",
      text_4:
        "이런 특징들이 모두 순간의 충동을 조절하기 어려워 나타나는 모습들이에요. 자신의 행동이 어떤 결과로 이어질지 생각하지 않고 행동이 먼저 나가는 것입니다. 충동 조절이 어려워 그렇게 행동하는 것인데, 다른 사람들이 보면 예의 없고 제 멋대로 한다고 생각할 수 있어요. 그러니 규칙을 잘 지켜 다른 사람들과 잘 어울릴 수 있으려면 충동을 잘 조절하는 것이 선행되어야 합니다.",
      thumbnail: "Responsibility_thumbnail",
      img: "Responsibility4_img",
      readDt: "",
    },
  ],
  Achievement: [
    {
      index: 1,
      isRead: false,
      title1: "만족지연 능력이란 무엇인가? (1)",
      content: "- 만족지연능력 정의/예시- 마시멜로우 실험",
      text_1:
        "어떤 일을 성취하기 위해 만족을 지연시키는 능력, 혹은 내가 원하는 것을 얻기 위해 기다리는 능력은 자기통제를 위해 꼭 필요한 부분입니다. 순간적인 욕구에 대한 만족을 지연시키면서 행동을 조절하는 것이에요. ",
      text_2:
        "예를 들어, 좋아하는 가수의 콘서트 티켓을 사기 위해 한 달 동안 쇼핑을 줄이며 돈을 모으는 상황을 가정해볼게요. 쇼핑을 하며 얻는 즐거움과 만족감이 있지만, 콘서트에 가는 것이 훨씬 큰 만족감을 줄 것이라고 생각하여 만족을 지연시키고 돈을 모을 수 있는 것이지요. 장기적인 보상을 위해 순간의 욕구를 잠시 미뤄두는 것이에요.",
      text_3:
        "만족지연 능력의 중요성을 알려준 유명한 실험이 있어요. 바로 마시멜로우 실험이에요. 이 실험에서 아이들은 두 가지의 선택권이 주어져요. 마시멜로우 한 개를 지금 바로 먹을 수도 있고, 잠깐 기다렸다가 두 개를 먹을 수도 있어요. 마시멜로우 한 개를 탁자 위에 올려놓은 뒤 아이들의 반응을 관찰했어요. 결과는 어땠을까요?",
      text_4:
        "많은 아이들이 방에 혼자 남겨지자 마시멜로우를 바로 먹었어요. 하지만 일부 아이들은 두 개를 먹기 위해 참고 기다릴 수 있었습니다. 후속 연구에서는 더 큰 보상을 얻기 위해 만족을 지연시킨 아이들이 즉각 먹은 아이들에 비해 학업 수행능력이 더 좋다는 것을 발견했습니다. 우리 아이가 더 큰 성취를 위해 순간의 만족을 잠시 미뤄둘 수 있다면, 보다 더 큰 만족감을 느끼며 살아갈 수 있을 거예요. ",
      thumbnail: "Achievement_thumbnail",
      img: "Achievement1_img",
      readDt: "",
    },
    {
      index: 2,
      isRead: false,
      title1: "만족지연 능력이란 무엇인가? (2)",
      content: "- Hot and Cool System",
      text_1:
        "아이는 어떤 과정을 통해 만족을 지연시킬 수 있는 것일까요? 마시멜로우 실험을 한 학자는 뇌의 ‘Hot and Cool System’이라는 용어를 통해 만족지연 능력을 설명했어요. ‘본능과 이성 체계’로 해석해볼 수 있습니다.",
      text_2:
        "Hot System&#39; 즉, 본능체계는 정서적이고 충동적이며 욕구에 따라 행동하도록 하는 뇌의 영역이에요. 의사결정을 할 때 나의 즉각적인 욕구만을 고려하여 빠른 결정을 내립니다. 반면 ‘Cool System’, 이성체계는 의사결정을 내릴 때 자신의 행동으로 인해 나타날 결과에 대해 이성적으로 고려해보도록 합니다. 기다렸을 때 장기적인 이득이 있다면 지금 당장 욕구를 충족시킬 수 없어도 기다리기로 결정하는 것이지요. ",
      text_3:
        "예를 들어, 정말 갖고 싶은 물건이 있다고 가정해 볼게요. 가방이나 게임기, 차 등 뭐든 내가 원하는 것을 대입하여 생각해봅시다. 지금은 내 재정상황에 비해 너무 비싼데 몇 달 후에는 세일하여 좀 더 저렴한 가격에 구입할 수 있습니다. 그런 경우 어떤 결정을 내리시겠어요? 원하는 물건을 즉시 갖고 싶은 마음만을 고려하여 비싼 가격에 구입한 사람은 의사결정 시 주로 ‘Hot System’에 의지를 많이 하는 경향이 있었고요. 자신의 재정상황을 이성적으로 고려하여 조금 기다렸다가 저렴한 가격에 구입한 사람은 ‘Cool System’에 기대는 경향이 있었어요.",
      text_4:
        "마시멜로우 실험을 한 학자는 실험에 참여한 아이들 역시 뇌의 어느 체계를 더 많이 사용하느냐에 따라 의사결정이 달라졌다고 설명했습니다. 더 큰 보상인 2개의 마시멜로우를 위해 15분 동안 먹지 않고 기다린 아이들이 평소 다른 영역에서도 ‘Cool System’에 의지하여 결정을 내렸다는 것이에요. 그리고 ‘Cool System’을 많이 활용하는 아이들이 미래를 위한 계획을 잘 세우고 스트레스를 좀 더 효과적으로 다룰 수 있었다고 합니다. ",
      thumbnail: "Achievement_thumbnail",
      img: "Achievement2_img",
      readDt: "",
    },
    {
      index: 3,
      isRead: false,
      title1: "일상에서 만족지연 훈련하기 (1)",
      content: "- 자연스러운 훈련 상황",
      text_1:
        "아이는 일상에서 순간의 만족을 지연시키고 기다려야 하는 순간들을 계속 마주합니다. 밥 먹은 후에 간식을 더 맛있게 먹을 수 있는데 밥 먹기 전에 허기를 달래고 싶은 순간, 한정된 용돈으로 좋아하는 장난감을 사려고 모으는 중에 간식을 사먹고 싶은 순간, 동물원에 가기로 했는데 당장 집에서 노는 게 더 즐거운 순간. 모두 만족지연 능력이 필요한 순간들이죠.",
      text_2:
        "그런 순간이 우리 아이의 ‘이성체계’가 잘 활성화될 수 있도록 훈련하는 기회입니다. 늘 원하는 것을 바로 들어주는 것이 좋은 것은 아니에요. 원하는 것을 바로 했을 때 예상되는 결과는 무엇인지, 참고 기다리면 어떤 점이 좋은지에 대한 대화를 많이 나눠주세요. 그리고 아이가 욕구를 참고 기다렸을 때 얻은 것들, 물질적인 보상이나 성취감 같은 심리적 보상에 대해 언급해주는 것도 좋습니다.",
      text_3:
        "이 외에도 만족지연을 연습해볼 수 있는 상황을 직접 만들어 줄 수도 있어요. 예를 들어, 밥 먹기 직전에 아이스크림을 먹고 싶어 하는 아이에게, 지금은 밥을 맛있게 먹기 위해 참고 이후에 더 좋아하는 간식을 먹자고 제시할 수 있겠죠. 또는 장난감을 바로 사고 싶어 하는 아이에게, 오늘 이 장난감을 사지 않는 대신 그 돈을 모아서 더 비싼 장난감을 사보는 것에 대해 제안해볼 수 있어요.",
      text_4:
        "여기서 주의할 점은 엄마, 아빠가 그 약속을 반드시 지켜야 한다는 것입니다. 아이가 만족지연을 위해 노력했는데 돌아오는 것이 없으면 아이는 ‘원하는 것은 그 때 바로 해야 한다’고 생각하고, 즉각적으로 욕구를 충족시키려 할 거에요. 아이가 만족을 지연시키고 기다렸을 때 꼭 약속을 지켜주세요. 그럼 우리 아이는 스스로 해낸 것에 대해 큰 기쁨과 성취감을 느끼고, 그 과정에서 기다림을 배우게 됩니다.",
      thumbnail: "Achievement_thumbnail",
      img: "Achievement3_img",
      readDt: "",
    },
    {
      index: 4,
      isRead: false,
      title1: "일상에서 만족지연 훈련하기 (2)",
      content:
        "- 만족지연 훈련 활동: 요리하기- 만족지연 훈련 활동: 혼자노는 시간 갖기",
      text_1:
        "저번 시간에 이어서 일상생활에서 만족지연 능력을 훈련해볼 수 있는 팁 두 가지를 소개해드릴게요. 첫 번째는 아이와 함께 베이킹 혹은 요리를 해보는 것이에요. 함께 요리하는 것은 기다림, 인내, 성취감, 만족감과 같은 다양한 가치를 배울 수 있고, 레시피 대로 계량하고 굽고 익히는 과정을 통해 수‧과학능력도 함양시킬 수 있어요. 엄마, 아빠와 친해지는 것은 기본이고요.",
      text_2:
        "만족지연 능력의 관점에서는, 배가 고프다고 바로 식사를 할 수 있는 것이 아니고, 식사를 포함해 자신이 원하는 많은 것을 이루기 위해서는 시간이 걸릴 수 있다는 사실을 배울 수 있습니다. 더불어 요리를 하는 시간동안 배고픔을 잊을 수 있어요. 주의를 다른 곳에 전환시키며 만족을 지연하는 것이지요. 이런 훈련은 욕구를 참아야 하는 다른 상황에서도 주의전환 기술을 발휘할 수 있도록 도와줍니다.  ",
      text_3:
        "두 번째는 아이에게 혼자만의 시간을 주는 것입니다. 아이 발달에 있어 엄마, 아빠와 함께하는 시간이 중요하다는 이야기는 많이 들어보셨을 거예요. 하지만 혼자 노는 시간도 필요합니다. 이 시간동안 아이는 지루함을 느끼고, 그 지루함을 견딜 만한 방법을 찾으려고 창의력을 발휘하게 돼요. ",
      text_4:
        "그렇기 때문에 규칙적으로 혼자 노는 시간을 만들어도 좋아요. 그리고 그 시간 뒤에 즐거운 활동을 계획해 둡니다. 지루함을 견디고 나면 엄마, 아빠와 시간을 보내거나 친구들을 만나는 등 더 즐거운 활동을 할 수 있다는 기대감이 생기게 말이에요. 혼자서 그 시간을 보내본 아이들은 놀이공원 갔을 때 긴 줄을 서서 기다릴 수 있고, 학교에서 지루한 활동에도 기꺼이 참여할 수 있습니다. ",
      thumbnail: "Achievement_thumbnail",
      img: "Achievement4_img",
      readDt: "",
    },
  ],
  mood: [
    {
      index: 1,
      isRead: false,
      title1: "정서의 기능",
      content: "- 정서의 기능",
      text_1:
        "우리는 살아가면서 수많은 감정들을 느낍니다. 기쁨, 슬픔, 공포, 분노, 사랑, 질투, 걱정, 죄책감 등 다양한 감정을 느끼죠. 학자들은 정서(emotion)를 자극에 대한 반응이라고 정의했어요. 어떤 사건, 즉 자극 때문에 행복하고, 화가 나고, 두려움을 느낀다는 것이에요.",
      text_2:
        "감정은 꼭 필요해요. 감정은 본능적으로 많은 상황에서 효과적인 행동을 할 수 있도록 이끌어주거든요. 위험한 상황에서 공포를 느끼면 빠르게 도망갈 수 있고, 부당한 일에 분노를 느끼면 부당함에 맞서 싸우게 할 수 있어요. 우리가 부모로서 아이를 지키고 보호하는 것도 사랑이라는 감정을 느꼈기 때문이겠죠. ",
      text_3:
        "이렇듯 감정은 우리의 생명을 지켜줄 수도 있고 관계를 맺게 도와주기도 하며 행동에 대한 동기를 부여해줍니다. 이런 본능적인 정서 반응은 뇌의 자율신경계의 한 부분인 교감신경계에 의해 발생하는 것이에요. 단 몇 초 만에 일어나는 아주 자동적인 반응이죠. 우리에게 꼭 필요하니까요. ",
      text_4:
        "앞으로 우리는 감정에 대해 많은 이야기를 나눌 거예요. 감정을 조절한다는 것은 무엇인지, 왜 조절해야 하는지, 우리 아이는 감정 조절을 잘 하고 있는지, 어떻게 도와줄 수 있는지와 같은 주제들에 대해서요. 지피지기면 백전백승! 감정에 대해 자세히 알면 알수록 다루기도 쉬워진답니다. 나와 우리 아이의 감정이 제 역할을 충분히 할 수 있도록 우리 함께 공부해 봐요! ",
      thumbnail: "mood_thumbnail",
      img: "mood1_img",
      readDt: "",
    },
    {
      index: 2,
      isRead: false,
      title1: "기분조절이란 무엇인가? (1)",
      content: "- 정서조절의 정의",
      text_1:
        "저번시간, 감정이 무엇이고 왜 우리에게 필요한지 배웠지요. 하지만 우리는 가끔 감정을 느끼는 것이 힘들 때가 있어요. 화를 내고 싶지 않은 순간에 버럭 소리 질러 난처해지기도 하고, 상대방에게 상처를 주고 후회하기도 해요. 우울감을 느껴 몸이 축 쳐지면 할 일을 잘 하지 못 해 우울감이 원망스럽기도 하고요. 잘 놀라는 사람은 사소한 것에 계속 놀라는 것이 지칠 때가 있죠. 결국 감정은 우리에게 꼭 필요하지만 우리에게 이를 적절히 다룰 수 있는 주도권이 있어야 합니다. ",
      text_2:
        "정서조절은 자신의 기분을 통제하여 기분에 휘둘려 행동하지 않도록 하는 능력이에요. 우리의 정서는 우리의 행동과 긴밀히 연결되어 있어요. 느끼는 대로 행동하게 됩니다. 다시 말하면, 정서조절은 우리가 느끼는 감정을 조절하는 것뿐만 아니라, 감정 조절을 통해 이후 우리가 보일 행동과 말을 수정하고 통제하는 능력도 포함합니다. 감정을 조절해 다른 사람 또는 스스로를 다치게 할 수 있는 말이나 행동을 멈추도록 하는 것이지요.",
      text_3:
        "우리는 살면서 수많은 감정들을 느낍니다. 그 감정을 일으키는 수많은 사건들도 마주하지요. 대부분의 사건들은 우리의 통제를 벗어난 경우가 많아요. 즉, 상황 자체를 없애거나 통제할 수는 없다는 뜻이지요.",
      text_4:
        "그리고 그 상황에서 경험하는 감정을 없앨 수도 없어요. ‘정서조절’은 화, 슬픔, 실망과 같은 감정들을 없애는 것이 아닙니다. 대신 그러한 감정들을 다룰 수 있는 틀을 만들어주는 것이에요. 그 틀은 통제할 수 없는 상황을 만날 때 충동적으로 반응하지 않도록 도와줘요. 감정은 그대로 느끼고, 그 감정에 대한 우리의 반응을 바꾸는 것이지요.  ",
      thumbnail: "mood_thumbnail",
      img: "mood2_img",
      readDt: "",
    },
    {
      index: 3,
      isRead: false,
      title1: "기분조절이란 무엇인가? (2)",
      content: "- 뇌발달과 정서조절",
      text_1:
        "정서조절은 뇌 발달, 특히 전전두엽의 발달과 밀접한 연관이 있습니다. 이는 만 3세부터 발달하기 시작하고, 청소년기 동안 활발하게 발달하며 대략 21~25세 경에 완전히 성숙됩니다. 따라서 어린 아이들은 정서조절 능력을 발휘하기 시작하더라도 숙달되기 위해서는 아주 오랜 기간 노력을 기울여야 합니다.",
      text_2:
        "다른 사람 앞에서 부정적 정서표현을 자제하는 능력은 만 3세경부터 나타납니다. 이런 조절능력은 학령기로 갈수록 좀 더 향상되어요. 자신이 원하지 않는 선물을 받아 실망했을 때 학령기 아이들은 선물해준 사람을 생각하여 부정적 정서표현을 덜 하는 경향이 있었어요. 게다가 왜 실망감을 숨겼는지에 대한 이유도 설명할 수 있었습니다. ",
      text_3:
        "좌절을 견디는 능력도 정서조절 능력이 발달하며 생기는 능력이에요. 이 능력은 만 2세경에 나타나기 시작해서 유아기 즉, 학교 들어가기 전에 크게 증가해요. 그렇기 때문에 엄마, 아빠에게 떼쓰거나 반항하는 행동이 만 2~5세 사이에 급격히 줄어들어요. 엄마, 아빠가 하기 싫은 일을 요구했을 때 참고 할 수 있게 되고, 혹은 협상을 통해 해결책을 찾아내기 시작합니다.",
      text_4:
        "정서조절을 도와주는 전전두엽이 성인이 다 되어서야 완전히 성숙하는 것에 반해, 비교적 어린 나이 때부터 위와 같은 조절을 해나갈 수 있다니, 놀랍지요. 어른이 된 우리들도 가끔 우리 마음을 알아차리고 조절하는 것이 어려운데 말이에요. 그러니 지금 우리 아이가 정서조절이 조금 미숙하더라도 너그러운 마음으로 바라봐 주세요. 정서조절은 뇌가 발달함에 따라 반드시 함께 성숙합니다. ",
      thumbnail: "mood_thumbnail",
      img: "mood3_img",
      readDt: "",
    },
    {
      index: 4,
      isRead: false,
      title1: "정서조절 관련 변인 (1)",
      content:
        "- 정서를 잘 조절하는 아동의 모습- 정서조절의 이점: 사회성/ 학습능력",
      text_1:
        "정서조절이 중요한 이유 중 하나는 감정이 행동을 이끌기 때문입니다. 즉, 행동조절을 위해 반드시 정서를 관리해줘야 한다고 볼 수 있죠. 우리 아이가 행동을 조절하여 다른 사람의 말을 듣고, 공감하고, 지시를 따르려면 먼저 정서부터 조절할 수 있어야 합니다. ",
      text_2:
        "정서를 잘 조절하는 아이들은 어떤 모습일까요? 화가 났을 때 그 상태를 스스로 인식하고 그 감정을 다룰 수 있어요. 그리고 사회적으로 적절한 방식으로 표현할 수 있지요. 소리 지르거나 물건을 던지는 등의 미숙한 표현이 아니라, 말이나 그림 그리기와 같은 방법으로요. 화가 나고 좌절스러운 상황에서 감정을 조절한 후에 스스로 회복할 수 있습니다. ",
      text_3:
        "이런 아이들은 또 어떤 특징이 있을까요? 또래 관계가 좋습니다. 많은 연구들은 정서조절이 공감능력과 깊은 연관이 있음을 발견했습니다. 스스로의 감정을 잘 조절하면 다른 사람의 마음을 잘 들어주고 생각해 줄 여유가 생긴다는 것이에요. 다른 친구의 말을 잘 들어주고 공감해주면 친구들과 잘 어울릴 수 있게 됩니다. 즉, 사회적으로 유능한 아이가 되는 것이지요.",
      text_4:
        "무엇보다 정서조절 능력은 아이의 학습에 있어 아주 중요한 역할을 합니다. 많은 학자들은 아이가 정서를 제대로 관리하지 못 하면 학습할 수 없다고 이야기했습니다. 아이가 학습을 잘 할 수 있기 위해서는 학업 기술만큼이나 정서조절 능력이 중요하다고 덧붙였어요. 그 이유는 정서가 행동을 이끌기 때문이에요. 정서 조절을 잘 하면 충동을 통제하여 자리에 앉아있을 수 있고, 수업이나 과제에 집중을 유지할 수 있으니 학습에 도움이 되는 것이랍니다.",
      thumbnail: "mood_thumbnail",
      img: "mood4_img",
      readDt: "",
    },
    {
      index: 5,
      isRead: false,
      title1: "정서조절 관련 변인 (2)",
      content: "- 정서조절이 어려운 아이: 기질/ 양육태도",
      text_1:
        "이전 시간에 정서조절 능력은 뇌가 발달하며 점점 성숙해지고, 따라서 우리 아이의 미숙함은 자연스러운 모습일 수 있음을 배웠습니다. 하지만 가끔 우리 아이가 유독 또래에 비해 떼를 많이 쓰거나 화, 슬픔 같은 감정을 자주, 강하게 표현하는 것 같다고 느껴질 때도 있을 거예요. 그런 차이는 아이의 기질과 아이를 둘러싼 환경의 영향으로 나타납니다. 기질과 환경에 따라 더 크게 어려움을 겪을 수도 있고 좀 더 능숙하게 조절해 갈수도 있어요. ",
      text_2:
        "기질과 정서조절의 연관성에 대한 연구들을 살펴볼게요. 기질적으로 부정적 정서에 더 주의를 기울이는 경향성인 ‘부정적 정서성’이 높은 아이들이 정서조절에 더 어려움을 겪게 된다고 해요. 또한 의도적으로 주의를 조절하는 능력인 ‘의도적 통제’가 높은 아이들이 효과적인 정서조절 전략을 더 잘 사용할 수 있다고 밝혀졌습니다.",
      text_3:
        "아이의 정서조절 능력에 영향을 미치는 환경에는 무엇이 있을까요? 가장 큰 부분은 엄마, 아빠의 양육태도에요. 아이의 정서적 반응에 대한 부모의 대응 방식이 아이가 기분을 관리하기 위해 사용하는 행동들을 결정합니다. ",
      text_4:
        "예를 들어, 아이가 놀이터에서 집에 가기로 약속한 시간이 되어서 생떼를 부리는 상황을 가정해볼게요. 이 때 부모가 항복하고 10분 더 놀기로 했다면, 그 아이는 이후 행동 제한을 받거나 좌절 상황에서 소리를 지르고 떼쓰는 행동을 반복할 확률이 더 높아집니다. 반면, 부모가 아이의 감정은 공감해주되 미리 정한 한계선은 그대로 지킨다면, 그 상황은 정서조절을 배우는 기회가 되며 떼를 부리지 않고 좌절을 다루는 방법을 알게 될 수 있어요.",
      thumbnail: "mood_thumbnail",
      img: "mood5_img",
      readDt: "",
    },
  ],
  Resilience: [
    {
      index: 1,
      isRead: false,
      title1: "정서탄력성이란 무엇인가?",
      content: "- 정서탄력성(Emotional-Resilience)의 정의",
      text_1:
        "일상에서 마음이 요동칠 때가 있으신가요? 걱정이나 불안, 화 같은 감정에 휩싸여 내 마음 속이 복잡할 때 말이에요. 불안정한 마음상태는 우리 삶의 여러 부분에 영향을 미쳐요. 직장생활, 육아, 부부관계, 아이와의 관계 등 다양한 곳에서 어려움을 겪게 됩니다. ",
      text_2:
        "정서탄력성이란 우리가 스트레스 상황, 도전적인 상황에 잘 대처하고 적응하는 능력이에요. 어려운 경험들을 어떻게 다뤄나가는 지에 대한 모든 것입니다. 많은 연구에서 감정을 잘 다루는 사람이 변화와 도전적 상황에 잘 대처했다고 밝혔어요. 나의 마음을 잘 관리해주면 도전을 마주했을 때 흔들리는 마음도 잘 조절할 수 있고요. 그렇기 때문에 해결책도 더 잘 찾아갈 수 있겠죠. 정서탄력성이 높은 사람은 결국 감정조절을 잘 할 수 있는 사람이에요. ",
      text_3:
        "정서탄력성이 높은 사람들은 도전적인 상황에서 좀 더 긍정적으로 대처하는 경향이 있었다고 합니다. 일반적으로 어떤 사건을 마주했을 때 “물이 반 밖에 없네.”가 아닌, “물이 반이나 남았네.”와 같은 긍정적인 시각으로 바라보았다고 해요.",
      text_4:
        "또한 ‘변화’와 ‘도전’을 인생의 한 부분으로 받아드리는 경향이 높았습니다. 인생에서 큰 변화가 있을 때, 도전적인 사건이 있을 때 세상이 끝난 것처럼 무너지는 것이 아니라, 인생을 살면서 겪어야 하는 당연한 부분으로 생각했다는 것이지요. 그런 관점의 차이가 새로운 일에 기꺼이 도전하도록 돕고 성공적인 문제해결을 이끕니다. ",
      thumbnail: "Resilience_thumbnail",
      img: "Resilience1_img",
      readDt: "",
    },
    {
      index: 2,
      isRead: false,
      title1: "정서탄력성 높이기 (1)",
      content: "- 정서조절 전략 (1): 신체욕구 충족시키기",
      text_1:
        "저번시간에 정서탄력성이 무엇인지, 왜 중요한지에 대해 알아보았어요. 정서탄력성은 우리들에게도 꼭 필요하지만 우리 아이에게도 반드시 필요한 심리적 자원입니다. 우리 아이의 학교생활은 변화와 도전의 연속이기 때문이죠. 오늘부터 세 번에 걸쳐 정서탄력성을 높이는 방법에 대해 알아보려고 해요. 간단한 방법부터 조금은 어려운 것까지 있으니 잘 따라와 주세요! ",
      text_2:
        "마음 관리를 통해 정서탄력성을 높이는 가장 기본적인 방법은 잘 먹고, 잘 자고 것입니다. 이게 정서조절의 가장 중요한 첫 번째 단계에요. 너무 평범해서 놀라셨나요? 생각보다 우리의 감정은 식욕, 수면욕과 같은 기본적인 욕구에 큰 영향을 받습니다.",
      text_3:
        "전전두엽이 다 발달한 우리들도 잠을 못 자서 지친 상태에서는 더 버럭 화내기 쉬워요. 그리고 배고픈 상태에서도 비슷하죠. 영어 단어 중 ‘배고픈’을 뜻하는 ‘hungry&#39;와 ’화난‘을 뜻하는 ’angry&#39;의 합성어인 ‘hangry&#39;라는 말이 있어요. 바로 배고파서 화가 나는 상황을 가리키는 말이지요. 우리 아이도 똑같아요. 평소에 어느 정도 감정 컨트롤을 잘 하는 아이인데, 유독 짜증을 많이 내는 날이 있지 않나요? 밥 먹을 시간이 되었거나, 잠을 충분히 못 자서 피곤한 상태일 확률이 높습니다. ",
      text_4:
        "그럴 땐 아이에게 “배고파서 더 짜증이 나는 거야? 피곤해서 그래? 배고프면 더 힘들고 짜증날 수 있어.”하고 반응해주세요. 아이가 자신의 감정이 무엇인지와 그 원인을 연결시켜볼 수 있어요. 이후 비슷한 상황에서 ‘아, 지금 배가 고파서 더 화가 나나봐.’하고 생각할 수 있게 됩니다. 그렇게 감정과 원인을 스스로 인지하는 것만으로도 어느 정도 불편감이 해소될 수 있어요.",
      thumbnail: "Resilience_thumbnail",
      img: "Resilience2_img",
      readDt: "",
    },
    {
      index: 3,
      isRead: false,
      title1: "정서탄력성 높이기 (2)",
      content: "- 정서조절 전략 (2): quality time",
      text_1:
        "우리 아이의 정서탄력성을 높여주기 위한 두 번째 팁은 ‘엄마, 아빠와 질 높은 시간 보내기’입니다. 질 높은 시간, 영어로는 ‘quality time&#39;이라고 하는데요. 스마트폰, TV와 같이 주의를 빼앗는 것들은 다 꺼두고 오로지 우리 아이에게만 집중하는 시간을 말해요. ’데이트‘라고 할 수도 있겠네요.",
      text_2:
        "글을 읽는 지금이 저녁이면 오늘 하루를, 아침이면 어제를 돌이켜볼까요? 아이와 아침에 일어나서 밥 먹고, 학교 갈 준비 하고, 하교한 뒤 저녁 먹고 잘 준비를 했겠지요. 하루 일과 중 아이와 단 둘이서만 ‘quality time&#39;을 보낸 적이 있었나요? 단 둘이 산책을 다녀오거나, 아이가 좋아하는 놀이를 함께 집중해서 하는 것과 같은 시간 말이에요. 자신 있게 ’네!‘라고 대답할 수 있는 분은 많지 않을 거예요. 그 시간을 내기 위해서는 추가적인 노력이 필요합니다.",
      text_3:
        "엄마, 아빠와 질 높은 시간을 많이 보낸 아이들은 정서적인 안정감을 많이 느낀다고 해요. 그 시간동안 나에게만 집중해주는 한 사람이 있다는 것은 아이에게 사랑 받는 느낌을 주고, 나를 지지해주는 사람이 있다는 것을 알게 됩니다. 그런 아이들은 정서적으로 강해져요. 위기의 순간에 한 사람이 그 시간동안 주었던 사랑의 힘으로 일어서는 것이지요.",
      text_4:
        "질 높은 시간은 구체적으로 이렇게 해보세요. 되도록 엄마와 아이, 아빠와 아이 이렇게 1:1의 시간을 보내는 것이 좋습니다. 15분도 괜찮아요. 엄마, 아빠가 부담되지 않는 선에서 시작하는 것이 좋아요. 짧은 시간이라도 꾸준히 갖는 것이 중요합니다. 아이가 좋아하는 슬라임 만들기를 같이 해도 좋고요. 로봇 조립하기, 그림 그리기도 좋아요. 중요한 것은 아이가 선택한 놀이라는 점, 엄마, 아빠는 집중해서 참여한다는 점입니다. 놀이가 어렵다면 산책하거나 편의점에 다녀오는 것도 좋습니다. 우리 아이와의 퀄리티 타임, 오늘 바로 시작해 봐요!",
      thumbnail: "Resilience_thumbnail",
      img: "Resilience3_img",
      readDt: "",
    },
    {
      index: 4,
      isRead: false,
      title1: "정서탄력성 높이기 (3)",
      content: "- 정서조절 전략 (3): 기분대화 나누기",
      text_1:
        "벌써 두 개의 팁을 배웠네요. 잘 따라오고 계신가요? 이제 마지막 팁이 남았어요. 세 번째 팁은 ‘아이와 기분대화 나누기’입니다. 첫 번째 팁에서 배고파서 짜증내는 아이에게 “배고파서 짜증이 나는구나. 그럴 수 있어”라고 이야기 해보자고 했던 것, 기억하시나요? 그게 바로 기분대화에요. ",
      text_2:
        "기분대화 나누기는 아이와 함께 일상 가운데서 느끼는 기분에 대해 이야기해보는 것이에요. 그 시간을 통해 아이는 많은 것을 배우게 됩니다. 특정 상황에서 내가 느끼는 감정이 무엇인지, 감정의 이름과 특징에 대해 알게 돼요. 그 감정을 느껴서 내가 어떻게 행동했는지에 대해서도 돌이켜볼 수 있어요. 그리고 무엇보다 감정을 신뢰할만한 다른 사람과 나누는 방법을 알게 되고, 나누었을 때 마음이 편안해지는 것도 경험할 수 있습니다.",
      text_3:
        "여기서 유의할 점은 해결책을 제시해주는 시간이 아니라는 것입니다. 우리는 아이가 더 잘 대처했으면 하는 바람에 자꾸 가르쳐주고 싶어져요. 물론 적합한 행동을 가르쳐주는 것도 중요하지만, ‘기분대화’ 시간에는 감정에만 집중해 보도록 해요. “그때 네 기분은 어땠어?”, “그래서 어떻게 행동했어?”, “행동하고 나서 상황이 좀 나아졌니?” 이렇게요. ",
      text_4:
        "그리고 아이의 감정을 ‘수용’해주세요. 수용은 “그랬구나. 그런 상황이었으면 엄마였어도 그랬을 것 같아.”와 같이 말로 표현할 수 있어요. 우리가 힘든 일이 있을 때 누군가 옆에서 “그래. 너 정말 힘들었겠다. 그럴 수 있어.”라고 해준다면 다시 일어설 힘이 생기죠? 바로 우리 감정을 ‘수용’받았기 때문이에요. 정말 신비롭게도, 내가 느끼는 감정을 부정하지 않고, 그렇게 느낄 수 있다고 인정하는 순간 그 감정이 해소가 되고 이후 해결책이 떠오르게 됩니다. 이게 심리상담의 기본 원리이기도 해요. 엄마, 아빠가 우리 아이의 전담 상담사가 되어주세요. ",
      thumbnail: "Resilience_thumbnail",
      img: "Resilience4_img",
      readDt: "",
    },
  ],
  Sadness: [
    {
      index: 1,
      isRead: false,
      title1: "슬픔이란 무엇인가?",
      content: "- 슬픔의 정의/표현 (우울과의 차이)",
      text_1:
        "정서를 오랫동안 연구한 학자들은 서로 다른 문화권에서 공통적으로 관찰되는 정서들에 대해 관심이 많았어요. 각 학자마다 그런 정서들을 ‘기본정서’라고 하여 분류하기 시작했어요. 학자마다 기본정서의 수가 다르긴 했지만, 모든 학자들이 포함하고 있는 기본정서는 행복(기쁨), 슬픔, 분노, 공포 이렇게 네 가지였다고 합니다. 앞으로는 이 기본정서들 중 슬픔과 분노에 대해 좀 더 자세히 살펴보고자 해요. ",
      text_2:
        "먼저 슬픔에 대해 자세히 이야기 나누어 봐요. 슬픔은 상실감에 대한 정서적 반응이에요. 우리가 지갑을 잃어버리거나, 친한 친구가 멀리 다른 나라로 이민을 가거나, 직장에서 나쁜 평가를 받는 상황에서 슬픔을 느낄 수 있겠죠. ",
      text_3:
        "슬픔은 종종 우울과 비슷하다고 느껴지기도 합니다. 슬픔은 어느 한 상황에서 나타나는 하나의 기분인 반면, 우울은 특별한 상황이 없을 때조차도 오랫동안 지속되는 기분이에요. 예를 들어, 최근 사랑하는 가족과 사별하여 느끼는 감정은 슬픔이라고 볼 수 있고, 이를 우울하다고 생각할 수는 없는 것이지요.  ",
      text_4:
        "기분이 어떻게 표현되는지를 통해서도 슬픔과 우울의 차이를 살펴볼 수 있어요. 울음은 대표적인 슬픔 표현 방식이에요. 이에 반해, 우울의 표현은 그렇지 않습니다. 한 연구에서 우울을 많이 느끼는 사람들이 슬픈 영화를 보는 동안에 평균적인 사람들에 비해 더 많이 운 것은 아니라는 것이 밝혀졌다고 해요. 우울과의 비교를 통해 슬픔에 대해 알아보았어요. 우울에 대해서는 이후에 따로 더 자세히 다루기로 하고, 슬픔에 대해 좀 더 파헤쳐봅시다!",
      thumbnail: "Sadness_thumbnail",
      img: "Sadness1_img",
      readDt: "",
    },
    {
      index: 2,
      isRead: false,
      title1: "슬픔표현의 성차와 문화차",
      content: "- 슬픔표현의 성차와 문화차",
      text_1:
        "우리 아이가 슬퍼서 엉엉 울고 있는 것을 보면 어떤 생각이 드시나요? 아마 집에서 우는지, 많은 사람들이 있는 곳에서 우는지에 따라 다른 생각이 들 수 있고요. 우리 아이가 아들인지 딸인지, 몇 살인지에 따라서도 다르게 생각이 들 거예요. 아빠와 엄마가 느끼는 것이 서로 다를 수 있고, 한국 부모와 미국 부모가 서로 생각이 다를 수 있겠죠.",
      text_2:
        "이렇듯 슬픔을 표현하는 것과 그 표현을 받아들이는 것에는 문화차와 성차가 있습니다. 즉, 아이가 어떤 문화권에서 자랐는지에 따라 슬픔을 표현할 때 받는 피드백이 달라지고, 표현방식도 그에 맞게 바뀌는 것이지요. 남아인지 여아인지에 따라서도 동일하고요. ",
      text_3:
        "연구에 따르면, 집단주의 문화권에 있는 사람들이 부정적 또는 긍정적 정서를 표현하는 것을 꺼리는 경향이 있었다고 해요. 다른 사람들에게 피해 주기 싫고 관계의 조화를 중시하기 때문이죠. 또 다른 연구에서는 여아들이 슬픔을 밖으로 표현하는 것에 대해서는 좀 더 허용적인 반면, 남아들은 슬픔을 억누르거나 잘 관리하도록 요구받는 경향이 있다고 밝혔습니다. 남아들은 슬퍼서 울면 다른 사람들이 약하다고 볼까봐, 혹은 놀림받을까봐 슬픔을 억제하게 됩니다.",
      text_4:
        "계속 반복하여 이야기 했지만, 슬픈 감정 자체는 잘못이 없어요. 슬픔의 표현 중 하나인 울음도 잘못이 없죠. 우리가 어떻게 해석하고 받아들이느냐에 따라 다르게 보일 수 있는 거예요. 어쩌면 우리도 어릴 때부터 슬픔을 포함한 여러 감정들을 표현하는 데 있어 제지를 받아왔을 수 있어요. 감정 자체는 자연스러운 것이며 우리 삶에 꼭 필요한 요소라는 것을 기억하며, 우리 스스로, 그리고 우리 아이의 감정 표현에 대해 조금 편안한 마음을 가져 봐요.",
      thumbnail: "Sadness_thumbnail",
      img: "Sadness2_img",
      readDt: "",
    },
    {
      index: 3,
      isRead: false,
      title1: "슬픔조절에 효과적 전략",
      content: "- 인지적 재평가",
      text_1:
        "나와 아이의 감정에 대해 좀 더 편안한 마음을 가져 보는 것, 그게 바로 ‘감정수용’의 다른 표현일거에요. 감정 수용 연습이 조금씩 진행되고 있나요? 잘 되고 있다면 비로소 ‘조절’의 단계로 들어가 볼 수 있겠어요. 오늘은 슬픔 조절에 특히 효과적인 전략을 알아보아요.",
      text_2:
        "감정 조절 전략에 대해 연구한 많은 학자들은 슬픔을 관리하는 데 특히 효과적인 전략으로 ‘인지적 재평가’ 전략을 꼽았어요. ‘인지적 재평가’는 나의 감정을 유발하는 상황에 대해 긍정적인 방식으로 다시 평가해보는 것이에요. 사건을 바라보는 내 생각을 바꾸는 것입니다. 이 전략은 부정적 정서를 조절하는 데 유용한 전략인데요, 특히 슬픔을 조절하는 데 가장 효과가 좋았다고 합니다. ",
      text_3:
        "부정적 감정을 유발하는 사건에 대한 해석을 바꾸면 부정적 정서가 줄어들고 긍정적 정서가 증가하며 이후 행동이 달라져요. 이 전략을 잘 사용하는 사람들은 부정적 사건과 감정 모두에 대해서 긍정적인 측면을 바라볼 수 있습니다. 시각 자체가 긍정적으로 바뀌면서 감정도 달라지는 것이지요. ",
      text_4:
        "예를 들어 볼게요. 한 예능 프로에서 어떤 사람이 영화 ‘라라랜드’의 남녀 주인공이 서로 이루어지지 않는 결말에 대해 이런 이야기를 했어요. “라라랜드 결말을 보고 처음엔 정말 슬펐는데, 평론 글을 읽고 좀 나아졌어. 사랑에 대한 얘기가 아니래. 꿈에 대한 얘기래. 꿈의 관점에서는 둘 다 해피엔딩이잖아. 그렇게 생각하니깐 마음이 편해졌어.” 정말 단순한 예이지만 인지적 재평가를 잘 보여주는 대사입니다. 정서를 조절하기 위해 내 생각을 활용하는 것이 꽤 도움이 될 수 있겠죠?",
      thumbnail: "Sadness_thumbnail",
      img: "Sadness3_img",
      readDt: "",
    },
    {
      index: 4,
      isRead: false,
      title1: "슬픔조절과 관련된 변인",
      content: "- 정서적, 사회적 지지체계",
      text_1:
        "오늘은 슬픔에 대해 알아보는 마지막 시간입니다. 사실 슬픔에 대한 연구는 분노나 불안, 우울 등과 같은 다른 정서 연구에 비해 많지 않습니다. 아마 슬픔을 느끼는 것이 일상생활에 지장을 줄 정도의 강도로 나타나는 경우는 드물고, 스스로 자연스럽게 겪고 넘어갈 수 있는 감정이기 때문일 거예요. ",
      text_2:
        "하지만 그럼에도 일상에서 큰 슬픔을 주는 사건들을 마주하게 될 수가 있습니다. 가까운 사람이 병에 걸려 아픈 상황이나 하늘나라로 먼저 가게 되는, 큰 상실의 사건과 같이요. 그런 경우에 잘 관리해주지 못 하면 그 사건을 기점으로 우울의 감정으로 이어질 수 있어요. 그러니 관리 방법을 미리 알아두는 게 좋습니다. ",
      text_3:
        "슬픔을 잘 조절하는 사람들에 대해 연구해보니, 사회적, 정서적 지지체계를 잘 활용했다고 해요. 즉, 슬픈 일이 있을 때 나의 이야기를 들어주고 위로해줄 친구들을 잘 찾고 의지했다는 뜻이지요. 이렇게 사회적 지지체계를 잘 찾는 것은 아동과 청소년들이 슬픔을 포함한 자신의 감정을 잘 조절하는 데에도 아주 효과적인 전략이었다고 합니다. ",
      text_4:
        "아동기에 들어서며 또래관계가 확장됩니다. 그렇기 때문에 또래로부터 정서적 지지를 받을 수 있는 것이 더욱 중요해지게 되는 거예요. 실제로 우리 아이들이 자신의 기분을 잘 조절하기 위해 가장 자주 활용하는 전략이 ‘친구에게 이야기하기’인 것으로 밝혀졌어요. 나의 말을 들어줄 단 한명의 친구만 있어도 힘든 순간을 극복해낼 수 있습니다.",
      thumbnail: "Sadness_thumbnail",
      img: "Sadness4_img",
      readDt: "",
    },
  ],
  Anger: [
    {
      index: 1,
      isRead: false,
      title1: "분노란 무엇인가?",
      content: "- 분노의 정의/ 예시",
      text_1:
        "오늘부터는 분노라는 감정에 대해 자세히 배워볼 거예요. 혹시 이 시간을 기다리셨나요? 대부분의 이 글을 읽고 있는 부모님들이 슬픔보다는 분노에 대해 궁금한 점이 많으셨을 거예요. 아마 분노가 좀 더 다루기 힘들고, 다른 사람들에게 피해를 주기도 하며, 행동으로 많이 드러나기 때문이겠죠.",
      text_2:
        "우리가 분노에 대해 느끼는 것과 비슷하게, 학자들도 분노에 대해 어떤 사람에게 상처를 주거나 그 사람을 몰아내려는 욕구와 관련된 정서 상태라고 이야기했어요. 굉장히 강렬하고 통제하기 어려운 감정이죠. 색깔로 표현하자면 빨간색이 떠오르기도 해요.",
      text_3:
        "분노는 어떨 때 느끼는 감정일까요? 다른 사람에 의해 고의적으로 유발된 불쾌하고 불공정한 상황에서 경험할 수 있어요. 여기서 중요한 것은 우리가 상대방의 행동을 ‘고의적이다’라고 해석할 때 더 분노를 강하게 느낀다는 점입니다. 예를 들어, 우리 아이가 내 말을 잘 안 들어 화가 난 상황을 떠올려볼게요. 다른 곳에 집중하느라 정말 못 들었다고 생각하면 화가 많이 나지 않을 수 있어요. 그런데 ‘일부러 못 들은 척 하나?’, ‘나를 무시하나?’ 하고 생각하면 더 화가 많이 납니다.",
      text_4:
        "그리고 분노는 좌절감을 경험할 때 많이 느끼는 감정입니다. 좌절감과 관련된 분노는 우리 아이들에게서 더욱 많이 관찰할 수 있어요. 혼자서 퍼즐을 맞추고 싶은데 잘 되지 않아서 좌절했을 때, 화를 낼 수 있어요. 마트에서 사고 싶은 것을 못 샀을 때 욕구가 좌절되어 화를 내기도 합니다. ",
      thumbnail: "Anger_thumbnail",
      img: "Anger1_img",
      readDt: "",
    },
    {
      index: 2,
      isRead: false,
      title1: "분노조절 전략 (1)",
      content: "- 유발요인 이해하기- 화에 대한 신체반응 알아차리기",
      text_1:
        "아이들은 교실에서, 집에서, 마트 등 다양한 장소에서 분노를 경험하는데요. 우리가 보기에 아이들이 분노를 경험하는 순간들은 정말 사소한 도전처럼 보이지만, 아이들에게는 큰 것일 수 있습니다. 분노는 정말 강렬하고 다루기 힘들기 때문이에요. 그리고 그런 사실에 대해 누가 알려주기도 전에 그 감정을 겪게 되거든요. ",
      text_2:
        "우리아이의 분노 조절을 위해 가장 먼저 짚고 넘어가야 할 것은 ‘화’ 자체가 문제가 아니라는 거예요. 우리는 모두 이런 감정들을 경험합니다. 화를 내는 우리 아이, 아주 평범하고 건강한 거예요. 더 중요한 건 아이가 그 화와 좌절을 건강한 방식으로 잘 관리하도록 도와주는 것입니다. 오늘은 아이가 화가 나지 않았을 때, 평온한 상태에서 미리 화를 조절할 수 있는 전략들을 알아볼게요. ",
      text_3:
        "먼저 ‘유발요인(trigger) 이해하기’입니다. 우리 아이가 언제, 어떻게, 왜 좌절하고 화가 나는지에 대해 관찰해보세요. 종종 화를 유발하는 요인이 있고, 그걸 찾으면 미리 계획하여 예방할 수 있어요. 예를 들어, 갑자기 스케줄이 바뀔 때마다 화를 낸다고 가정해볼게요. 그럼 우리는 아이에게 스케줄에 대해 미리 안내를 해주고, 바꿔야 할 때마다 아이와 의논해볼 수 있겠죠. 바뀌는 스케줄에 대해 궁금한 것을 질문해보도록 해 아이가 마음속으로 준비하도록 도울 수 있어요.",
      text_4:
        "두 번째는 ‘화에 대한 신체반응 알아차리기’입니다. 화가 나면 신체반응이 나타나는데요, 그 신호를 미리 알아차릴 수 있으면 잠시 스스로를 멈추고 조절 전략을 바로 활용할 수 있습니다. 신체반응으로는 심장이 빠르게 뛰는 것, 손바닥에 땀이 나는 것, 얼굴이 빨개지고 열감이 느껴지는 것이 있습니다. 평소 우리 아이에게 화가 났을 때 나타나는 신체 반응을 알려주세요. 알고 경험하는 것과 모르고 경험하는 것의 차이는 굉장히 크답니다.",
      thumbnail: "Anger_thumbnail",
      img: "Anger2_img",
      readDt: "",
    },
    {
      index: 3,
      isRead: false,
      title1: "분노조절 전략 (2)",
      content: "- 폭발적인 행동으로 표현하는 아이 이해하기",
      text_1:
        "우리 아이의 화를 다루기 어렵다고 느끼는 이유 중 하나는 아마 폭발적인 행동으로 나타나기 때문일 거예요. 분노는 공격성과 깊은 연관이 있습니다. 분노가 표현되는 흔한 방식 중 하나가 바로 공격성이거든요. ",
      text_2:
        "아이들이 화가 나면 소리를 지르거나 위험한 물건을 던지고, 사람이나 물건을 때릴 수도 있습니다. 만약 우리 아이가 이런 행동을 보인다면, 정말 무섭고 스트레스 받을 거예요. 그런데 우리 아이도 똑같이 느낍니다. 아이에게도 자신이 화를 참지 못하고 폭발적으로 행동하는 그 순간은 무서운 사건으로 기억돼요. 대부분의 아이들이 진정된 후에 미안함을 느끼거든요. ",
      text_3:
        "그러니 먼저 아이의 폭발적 행동이 무엇을 이야기하고 있는지 생각해 보는 게 좋아요. 소리 지르고 누군가를 때릴 정도로 화에 압도된 아이는 정말 고통스러울 것입니다. 자신의 감정을 다룰 수 있는 기술이 부족해서 그런 미숙한 방식으로 표현하는 것이지요. 충동 통제 능력이나 문제해결 능력이 부족할 수도 있고, 언어표현 방식이 미숙한 것일 수도 있어요. 잘 표현하는 방식을 아직 배우지 못 한 것일 수도 있고요.",
      text_4:
        "하지만 그렇다고 해서 그 행동이 옳은 건 절대 아니죠. 그러니 아이의 그런 행동에 우리가 어떻게 반응하는지가 굉장히 중요해요. 우리의 반응에 따라 아이가 똑같이 행동할지, 아니면 화를 더 성숙한 방법으로 다루는 법을 배워 감정에 압도되지 않을지가 결정되거든요. 내일은 폭발하는 아이에게 어떻게 대처하면 좋을지 함께 배워 봐요.",
      thumbnail: "Anger_thumbnail",
      img: "Anger3_img",
      readDt: "",
    },
    {
      index: 4,
      isRead: false,
      title1: "분노조절 전략 (3)",
      content: "- 차분한 태도 유지- 항복하지 않기- 긍정행동 강화",
      text_1:
        "우리 아이가 다른 친구들에 비해 화를 폭발적인 행동으로 표현하는 경향이 있다면 오늘 내용이 도움이 되실 거예요. 아이가 폭발하는 순간에 꼭 기억해야 하는 태도 두 가지와 평소 아이에게 도움이 될 수 있는 양육태도를 알려드릴게요. ",
      text_2:
        "아이가 폭발한 순간 가장 중요한 것은 차분한 태도로 대하는 것입니다. 폭발한 아이를 볼 때 우리도 화가 나서 소리 지르게 될 수 있어요. 하지만 우리가 소리 지르면 아이가 더 공격적이고 반항적으로 될 수 있습니다. 정말 쉽지 않겠지만, 그 순간 우리의 감정을 잘 조절하여 차분한 상태를 유지하기 위해 노력해 봐요. 그 자체가 우리 아이에게 좋은 모델이 된답니다. ",
      text_3:
        "두 번째로, 폭발하는 아이에게 절대 항복해서는 안 됩니다. 이전 시간에도 잠깐 언급한 적이 있는데요. 아이가 폭발했다고 해서 원하는 것을 들어주는 것은 그 행동을 허락해주는 것과 다름없어요. 그 행동은 자신이 원하는 걸 갖기 위해, 또는 내 의견을 표현하기에 적합한 방법이 아니라는 걸 알려줘야 해요. 이 역시 쉽지는 않겠지만, 반드시 지켜내야 할 것이에요. ",
      text_4:
        "마지막으로, 화를 공격적으로 표현하는 아이는 평소에 아이의 좋은 행동을 많이 찾아 칭찬해줘야 합니다. 아이가 일상생활을 하는 동안 많은 관심을 표현해주어야 해요. 폭발적인 행동을 많이 하는 아이들은 그런 부정적인 방식으로 관심을 얻고자 할 때가 많기 때문이에요. 그리고 아이가 자기 기분을 말로, 차분하게 표현하려는 시도를 했을 때 놓치지 않고 칭찬해주세요. 그렇게 우리 아이는 적절한 표현 방식을 하나씩 배워나가게 된답니다.",
      thumbnail: "Anger_thumbnail",
      img: "Anger4_img",
      readDt: "",
    },
  ],
  metaCognitive: [
    {
      index: 1,
      isRead: false,
      title1: "메타인지란 무엇인가?",
      content: "- 일반적인 메타인지 정의/예시",
      text_1:
        "‘메타인지(meta-cognition)’라는 용어에 대해 들어보신 적 있으신가요? 메타인지란, 간단히 말해 생각에 대한 생각이에요. 내가 무슨 생각을 하고 있는지 자각하고 있고, 그 생각을 조절할 수 있는 능력을 뜻하죠. ",
      text_2:
        "직장에서 오늘 처음 만난 사람의 이름이 생각나지 않아 ‘아, 그 분 이름 까먹었네.’할 때, 방금 우리 아이와 같은 반 친구를 만나고 헤어지며 ‘**이라고 했지. 저 친구 이름은 꼭 기억해야겠다.’고 생각할 때, 텔레비전에서 퀴즈 프로를 보며 ‘아, 저거 답 아는데, 지금 기억이 안 나네!’하는 생각이 들 때. 이런 순간들 있으시죠? 바로 메타인지가 나타나는 일상의 예라고 할 수 있어요.  ",
      text_3:
        "위의 첫 번째 예에서, 상대방의 이름을 잊어버린 것은 그냥 생각이에요. 그리고 잊어버렸다는 사실을 인지하는 것이 생각에 대한 생각, 즉 메타인지이죠. 메타인지는 효과적인 학습을 위해서 반드시 필요한 기술입니다. 메타인지가 어떻게 학습에 도움이 되는지 간단한 예를 보여드릴게요. ",
      text_4:
        "한 연구에서 독해력이 좋은 사람은 글을 읽는 동안 자신의 이해도에 대해 지속적으로 평가하고 있었다고 해요. 특히 ‘무엇이 이해되지 않았는지’에 대해 잘 알고 있었고, 그 부분을 해결하기 위해 다시 읽기, 잠시 멈추고 생각해보기, 이해되지 않는 부분에 대해 따로 적어놓기, 질문하기와 같은 것들을 시도했습니다. 상당히 전략적이죠? 이게 바로 메타인지의 역할입니다.",
      thumbnail: "metaCognitive_thumbnail",
      img: "metaCognitive1_img",
      readDt: "",
    },
    {
      index: 2,
      isRead: false,
      title1: "메타인지의 발달",
      content: "- 메타인지의 발달",
      text_1:
        "메타인지 능력은 몇 살부터 발달할까요? 초기에 메타인지를 연구한 많은 학자들은 만 8-10세 사이에 그 능력이 발달하기 시작한다고 밝혔어요. 하지만 이후 연구가 거듭될수록 기존에 밝혀진 사실에 반박하는 결과들이 나타났습니다. 만 8-10세보다 훨씬 이전부터 메타인지 능력이 출현한다는 것이죠. ",
      text_2:
        "연구 결과에 차이가 나타났던 이유는 바로 메타인지 측정방법의 변화 때문이었어요. 기존에는 아이들의 메타인지 수준이 어느 정도인지 측정하기 위해 질문을 하여 대답하도록 하거나, 인위적인 실험 상황을 만들어 과제를 주고 풀어보도록 하는 방법을 사용했어요. 그러니 일단 질문에 대답할 수 있으려면 언어로 자신의 생각을 표현할 수 있는 언어표현 능력이 갖추어져야 했고, 실험 상황에서는 긴장이 유발되기 때문에 진짜 ‘메타인지’만을 측정하기는 어려웠던 것이죠.",
      text_3:
        "최근 연구자들은 그동안 연구에 참여했던 더 어린 연령의 아이들의 메타인지 능력이 과소평가 되었을 확률이 높았다고 주장했어요. 실제로 측정방법을 바꾸어서 실험해 보았더니 결과가 다르게 나타났습니다. 좀 더 일상생활과 유사한 환경에서, 아이들이 친숙하게 느끼는 과제물을 제시한 뒤, 질문 대신 관찰의 방식으로만 평가해보았어요. 그랬더니 영유아기의 아이들도 이미 매일 마주하는 문제들을 해결하기 위해 메타인지 능력을 활용하고 있는 것이 밝혀졌습니다. ",
      text_4:
        "심지어 또 다른 연구에서는 더 어린 나이, 12-18개월의 영아들 역시 메타인지를 활용해 자신의 행동을 결정하고, 돌아보고, 실수를 교정하여 다시 시도한다는 사실을 발견했습니다. 그런 과정을 통해 수많은 행동을 배우고 성장해가는 것이라고 설명했어요. 생각에 대해 생각하는 고차원적인 인지능력인 메타인지, 우리의 예상보다 빨리 발달하기 시작하네요!",
      thumbnail: "metaCognitive_thumbnail",
      img: "metaCognitive2_img",
      readDt: "",
    },
    {
      index: 3,
      isRead: false,
      title1: "메타인지와 학습 (1)",
      content: "- 학습상황에서 메타인지 예시 (1)",
      text_1:
        "메타인지는 삶의 다양한 영역에서 이점을 가져다주지만, 가장 크게 영향을 미치는 영역은 바로 ‘학습영역’이에요. 이전에도 잠깐 소개해드렸죠. 성인이 된 우리들도 여전히 직장에서 일을 하고, 집안일을 하고, 자기개발을 하기 위해 공부하거나 책을 읽을 때 메타인지를 활용할 수 있어요.",
      text_2:
        "우리 아이들은 어떤가요? 매일 매일이 학습의 연속이에요. 아이들이 달성해야 하는 주된 목표 중 한 가지가 학습이라고 해도 과언이 아닐 정도로 학습이 중요한 때입니다. 그렇기 때문에 당연히 우리 아이의 메타인지에 주목해 볼 필요가 있겠죠. 오늘은 아이들이 학습하는 동안 나타나는 다양한 메타인지의 예시를 살펴보아요. ",
      text_3:
        "다음과 같은 생각들이 모두 메타인지의 예입니다. “오늘 수학시간에 **을 배웠어.”, “근데 나는 **이 궁금해.”, “아, 방금 선생님이 말씀해주신 걸 들으니 어제 배운 **이 생각나네!”, “이 문제를 풀 때는 어떤 순서로 풀어야 할까?”, “이 주제에 대해 내가 이미 아는 것은 무엇이지?”, “이 문제를 해결할 때 어느 지점에서 막혔을까?”, “내가 오늘 해야 하는 숙제가 무엇이지?”. ",
      text_4:
        "메타인지의 예를 보니 좀 더 이해가 되셨나요? 우리 아이에게 위의 질문들이 필요한 상황들을 떠올려 보세요. 그리고 아이와 보내는 하루 중 딱 한 가지의 질문만 던져보세요. 간단한 방법이지만 메타인지를 연습해볼 수 있습니다. 우리 아이가 스스로 생각해볼 수 있도록 기회를 제공해주세요. ",
      thumbnail: "metaCognitive_thumbnail",
      img: "metaCognitive3_img",
      readDt: "",
    },
    {
      index: 4,
      isRead: false,
      title1: "메타인지와 학습 (2)",
      content: "- 학습상황에서 메타인지 예시 (2)",
      text_1:
        "오늘은 메타인지가 잘 발달된 아이들이 학습할 때 어떤 특징이 있는지 알아보아요. 첫째로 무언가를 배우는 과정에서 스스로를 돌아볼 수 있고, 학습 과정을 교정할 수 있는 능력이 있습니다. 내가 무엇을 아는지, 무엇을 모르는지, 모를 때는 무엇을 해야 하는지를 아는 것이에요. 예를 들어, ‘나는 받아 올림 없는 덧셈은 이해했는데, 받아 올림 있는 덧셈은 아직 모르겠어.’와 같이 스스로가 이해한 바에 대해 알고 있는 것이에요.",
      text_2:
        "둘째로, 자신이 선택한 문제해결 방법이 효과가 없을 때, 이를 알아차리고 다른 방법을 시도해볼 수 있습니다. 9+3과 같이 받아 올림 있는 덧셈을 하는 상황을 생각해볼게요. 손가락을 활용하여 덧셈을 해보았는데 잘 안 되었다면, 말로 “구, 십, 십일, 십이” 이렇게 ‘이어 세기’ 방법으로 바꾸어 시도해볼 수 있겠지요. ",
      text_3:
        "마지막으로, 스스로 학습할 때 나의 강점이 무엇인지, 약점이 무엇인지에 대해 알 수 있어요. 예를 들어, 우리 아이가 수학 과목에서, 글쓰기에서, 시험을 볼 때 등 학습과 관련된 상황에서 자신의 강점과 약점이 무엇인지 설명할 수 있는 것이지요. 그럼 자신이 잘하는 부분에서는 더욱 효율이 올라가고, 약점은 보완하기 위해 노력할 수 있으니 점점 발전하게 될 거예요. ",
      text_4:
        "어떠신가요? ‘메타인지’라는 단어만 지우면, ‘공부 잘 하는 아이 특징’에 대한 내용 같지요? 이렇듯 메타인지는 빠르게는 유아기 때부터 시작되는 우리 아이의 학습에 있어 필수적인 기술이고, 자신의 목표를 달성하고 성장하는 어른이 되도록 도와줍니다. ",
      thumbnail: "metaCognitive_thumbnail",
      img: "metaCognitive4_img",
      readDt: "",
    },
    {
      index: 5,
      isRead: false,
      title1: "메타인지와 관련된 변인들 (학습 외)",
      content: "- 기본생활 습관 형성 용이- 또래관계 유능성- 정신건강",
      text_1:
        "저번 시간까지 메타인지가 학습능력을 잘 발휘하기 위해 꼭 필요하고 중요한 요인임을 배웠어요. 그렇다면 메타인지가 잘 발달하면 또 우리 아이의 어떤 부분에 긍정적인 영향을 미칠까요? 다른 이점도 많답니다. 함께 살펴봐요.",
      text_2:
        "먼저 기본생활 습관이 좋습니다. 기본생활 습관은 손 씻기, 양치하기, 바르게 앉아서 밥 먹기, 입었던 옷, 썼던 물건 제 자리에 정리하기 등과 같은 활동이 포함됩니다. 메타인지가 잘 발달한 아이들은 자기인식과 자기조절 능력이 뛰어나기 때문에 생활 습관 형성에 기초가 되는 행동 조절을 비교적 수월하게 해낼 수 있어요. 그리고 스스로 습관을 형성하지 못 했을 때 나타나는 부정적 결과에 대해 돌아볼 수 있고 좋은 방향으로 행동을 수정할 수 있습니다. ",
      text_3:
        "두 번째는 또래와 잘 소통합니다. 메타인지 능력이 발달하면, 또래와의 관계 속에서의 자신의 말과 행동에 대해 성찰할 수 있어요. ‘내가 이런 말을 하면 이 친구가 어떤 기분일까?’, ‘이 행동이 다른 친구들에게 피해를 주지는 않을까?’와 같은 생각들을 하는 것이지요. 또한 자신의 생각에 대한 이해도가 높고 이를 평소에 잘 조절하기 때문에, 말로 자신의 의사를 뚜렷하게 표현할 수 있습니다. ",
      text_4:
        "세 번째는 마음이 건강합니다. 메타인지 능력이 좋은 아이들은 자기인식 능력이 뛰어나다고 했었지요? 자신에 대해 많이 들여다볼수록 마음을 잘 돌보게 되고, 걱정, 불안, 스트레스, 화와 같은 부정적 감정들을 잘 다룰 수 있게 됩니다. 즉, 스스로 기분을 조절할 수 있기 때문에 마음이 건강해지는 것이지요. 마음이 힘든 사람들에게 ‘메타인지 치료’라는 것을 적용할 만큼, 메타인지의 효과는 대단하답니다. ",
      thumbnail: "metaCognitive_thumbnail",
      img: "metaCognitive5_img",
      readDt: "",
    },
  ],
  Monitoring: [
    {
      index: 1,
      isRead: false,
      title1: "메타인지가 부족한 아이들",
      content: "- 메타인지가 부족한 아이들 특징- 구체적 예시",
      text_1:
        "지금까지 메타인지의 개념과 예시, 이점과 꼭 필요한 이유들에 대해 알아보았어요. 오늘부터는 메타인지 능력이 부족한 아이들은 어떤 어려움이 있는지, 이유는 무엇인지, 어떻게 도와줄 수 있는지 배워볼 거예요. 이전 글을 읽으며 ‘어, 우리 아이는 이 능력이 좀 부족한 것 같은데’하는 생각이 드셨다면, 앞으로 잘 따라와 주세요!",
      text_2:
        "보통 메타인지를 잘 하지 못 하는 아이들은 학습문제가 나타납니다. 자신의 생각을 체계적으로 조직화하거나 중요한 학습주제를 파악하는 등 학습에 필수적인 정신적 기술을 활용하는 데 어려움이 있기 때문이에요. 이런 아이들은 어떤 도전적인 과제가 있으면 하다가 중간에 쉽게 포기하는 모습을 보이고, 심지어는 시작조차 못하는 경우가 많습니다. 과제를 어떻게 풀어나가야 할지 방법을 모르니 포기해버리거나 시작할 엄두를 못 내는 것이지요.",
      text_3:
        "예를 들어, 아이가 책을 선택해 읽고 독후감을 써야 하는 상황을 가정해 볼게요. 먼저 독후감을 완성하기 위한 계획을 세워야겠죠. 책을 읽는다, 이해한 내용을 상기시켜본다, 독후감 작성에 필요한 부분을 책에서 찾아 밑줄 친다, 글로 쓴다, 다시 읽어보고 수정하여 완성한다, 이렇게요. 하지만 메타인지 문제를 겪는 아이들은 최종적인 목표, ‘독후감 쓰기’를 달성하기 위해 어떤 것부터 먼저 시작해야 하는지를 알아차리지 못 해요. 그래서 책상에 책을 쌓아만 놓고 앉아있거나, 공책의 빈 면만을 들여다보고 있기도 합니다. ",
      text_4:
        "이런 친구들은 학교생활이 정말 쉽지 않겠죠. 매일 매일이 좌절과 실패의 연속일 것입니다. 선생님들로부터 ‘**이는 학습에 대한 흥미가 없어요.’, ‘자기 할 일을 잘 안 해요.’, ‘뭔가 시작하면 끝까지 해내지를 못 해요.’라는 피드백을 들을 수 있습니다. ",
      thumbnail: "Monitoring_thumbnail",
      img: "Monitoring1_img",
      readDt: "",
    },
    {
      index: 2,
      isRead: false,
      title1: "메타인지 문제의 원인 (1)",
      content: "- 실행기능의 미성숙",
      text_1:
        "‘메타인지’는 여러 심리학 분야 중 학습심리학과 인지심리학에서 나온 개념이에요. ‘생각하는 것에 대한 생각’을 하는 것이 어려운 것이기 때문에, 간단한 숙제나 장기적인 학습에 필요한 학습기술에 영향을 미치는 것이죠. ",
      text_2:
        "그렇다면 왜 다른 친구들보다 메타인지 수준이 낮은 걸까요? 여러 가지 이유가 있겠지만, 세 가지 이유를 살펴보려고 해요. 첫 번째로 이야기할 것은 실행기능 전반의 문제입니다. 뇌의 전전두엽이 담당하는 기능에는 여러 가지가 있는데요, 그중 한 가지가 실행기능이에요. 실행기능은 사고와 행동을 의식적, 체계적으로 조절하고, 억제하고, 문제해결을 하는 등 많은 역할을 담당하고 수행합니다.",
      text_3:
        "메타인지가 어려운 아이들이 과제를 끝까지 완수하지 못 한다고 했던 것, 기억하시죠? ‘숙제하기’를 예로 들어보면, ‘숙제하기’에는 숙제를 시작하는 것, 숙제를 하기 위한 자료를 찾는 것, 숙제를 완성하기 위한 순서를 기억하는 것, 숙제를 하기 위한 계획을 세우는 것이 모두 포함됩니다. 각각의 행동들은 실행기능이 담당하는 시작하기, 자료의 조직화, 작업기억, 계획세우기에 해당해요. 그러니 실행기능이 아직 덜 발달한 아이들은 메타인지 능력이 조금 부족할 수 있고, 과제 완수가 힘들 수 있겠죠. ",
      text_4:
        "하지만 꼭 기억해야 할 것이 있습니다! 바로 실행기능을 포함한 인지적 능력은 청소년기를 지나 초기 성인기까지도 발달이 지속된다는 것이에요. 어느 누구도 처음부터 완전히 성숙한 실행기능 능력을 갖고 있지는 않습니다. 그러니 괜찮아요. 앞으로 발달하고 배워 가면 되니까요. ",
      thumbnail: "Monitoring_thumbnail",
      img: "Monitoring2_img",
      readDt: "",
    },
    {
      index: 3,
      isRead: false,
      title1: "메타인지 문제의 원인 (2)",
      content: "- 쉽게 압도되는 특성- 자기점검 문제",
      text_1:
        "저번 시간에 이어서 메타인지 수준이 낮은 이유에 대해 살펴볼 거예요. 두 번째 이유로는 쉽게 압도되는 특성이 있습니다. 메타인지 영역에 도움이 필요한 아이들은 자신의 머릿속에 쌓여있는 ‘할 일 목록’에 쉽게 압도당하는 경향이 있어요. 그 친구들의 머릿속에는 이미 엄청난 양의 ‘할 일 목록’이 있어, 누군가가 새로운 것을 추가하면 ‘아 망했어. 다 해내는 건 불가능이야.’라고 생각하게 됩니다. ",
      text_2:
        "이런 특성을 보완해주기 위해서는 조력자가 필요한데요. 조력자는 옆에서 “하나씩 차근차근 해보자”라고 말해주는 게 중요해요. “한 번에 하나씩 해보면 돼”라고 안내를 해주어, 어떤 일이든 해내기 위해서는 단계별로 하면 된다는 사실을 상기시켜 주는 것이에요. 이런 안내가 있으면 성공적으로 일을 시작하고 끝마칠 수 있습니다. ",
      text_3:
        "세 번째 이유는 자기점검 문제입니다. 메타인지 수준이 낮은 아이들은 어떤 글을 읽고 나서 내용에 대해 기억을 못 하는 경우가 있어요. 자기점검에 문제가 있기 때문이에요. 읽으면서 “잠깐, 지금 이게 무슨 뜻이지?”, “이 단락은 무슨 내용이었지?”, “이게 이해가 됐나?”와 같은 질문들을 스스로 던져보지 않고, 그냥 읽기만 한 것이죠. 이 역시 평소에 어른들이 학습에 대한 스스로의 이해도를 점검할 수 있는 질문들을 던져주는 것이 도움이 됩니다.",
      text_4:
        "지금까지 어떤 이유 때문에 메타인지 수준이 낮을 수 있는지에 대해 살펴보았어요. 더 다양한 이유가 있지만, 실행기능의 미성숙, 할 일 목록에 쉽게 압도되는 특성, 자기점검 문제에 대해 이야기 나눠 보았습니다. 우리 아이가 메타인지에 어려움을 겪고 있다면, 아이에 대해 조금 더 깊이 이해하는 시간이 되었길 바라요. 아이의 상태에 대해 더 잘 이해할수록, 더 정확하고 확실한 도움을 줄 수 있습니다! ",
      thumbnail: "Monitoring_thumbnail",
      img: "Monitoring3_img",
      readDt: "",
    },
    {
      index: 4,
      isRead: false,
      title1: "전문가의 도움이 필요한 경우",
      content: "- 일상/학교생활에 어려움이 있을 때",
      text_1:
        "메타인지는 실행기능이기 때문에, 아동기와 청소년기를 거쳐 지속적으로 발달합니다. 아직 발달 중이기 때문에 현재는 메타인지 능력이 다소 부족해 보여도 곧 성장해 갈 것이라 했지요. ",
      text_2:
        "하지만 자연스러운 발달과정의 미숙함으로 볼 수 없는 경우가 있어요. 우리 아이의 학교생활과 일상생활이 원활하게 돌아가지 않고 삐거덕 거릴 때예요. 할 일을 너무 자주 잊어버려 어른이 계속 챙겨줘야 하고, 일을 시작하고 끝맺기 어려워하여 학교에서 계속 지적을 받으며, 성적이 지속적으로 떨어지는 등 메타인지와 관련된 문제들이 학교 및 일상생활에 큰 지장을 줄 정도로 심한지 살펴보셔야 합니다. ",
      text_3:
        "이런 경우에는 임상심리 전문가를 찾아가 보시길 권해드려요. 실행기능을 평가하는 검사를 수행하여, 메타인지를 포함한 고차원적 문제해결 능력 전반에 대한 정보를 얻을 수 있어요. 우리 아이가 어떤 부분에서 얼마만큼 어려움이 있는지 정확하게 확인할 수 있고, 어떤 도움이 필요한지 알 수 있습니다. 전문가를 찾아가기까지의 결정은 정말 쉽지 않겠지만, 단 한 번의 용기로 우리 아이의 인생은 180도 달라질 수 있어요. 용기 내 주실 것을 믿고, 미리 박수 보내드립니다! ",
      text_4:
        "이후부터는 우리 아이의 메타인지 능력을 향상시켜 주기 위해 가정에서 시도해볼 수 있는 것들에 대해 살펴보고자 해요. 우리도 메타인지를 발휘하여, 하나씩 차근차근 배우고 실천해 보아요!",
      thumbnail: "Monitoring_thumbnail",
      img: "Monitoring4_img",
      readDt: "",
    },
  ],
  Neat: [
    {
      index: 1,
      isRead: false,
      title1: "메타인지 배우기 (1)",
      content: "- 향상될 수 있는 메타인지- 엄마, 아빠가 선생님이 되는 방법",
      text_1:
        "메타인지는 배우고 연습해서 향상시킬 수 있을까요? 이 질문에 대한 답은 “YES!”입니다. 한 연구에서 학생 집단을 둘로 나누어 한 집단 학생들에게만 메타인지에 대한 교육을 진행하고 두 집단의 차이를 살펴보았습니다. ",
      text_2:
        "연구 진행 결과, 메타인지에 대해 공부한 학생들이 자기 인식, 자기 평가, 목표 설정 능력이 향상되었고, 학업 수행뿐만 아니라 전반적인 일상생활의 문제해결 능력도 향상되었습니다. 더욱 의미 있었던 결과는 그 교육의 효과가 단기적으로만 나타난 것이 아니라, 7개월 뒤의 평가 때에도 유지되었다는 것입니다. 즉, 메타인지는 배워서 향상시킬 수 있고, 이 능력은 이후 삶을 살아가며 지속적으로 긍정적인 영향을 줄 수 있다는 것이지요. ",
      text_3:
        "그럼 메타인지는 어디서, 누구에게 배울까요? 메타인지 학원이 있으면 좋을 텐데 그런 건 없으니 말이죠. 오늘부터 엄마, 아빠가 메타인지 선생님이 되어주세요. 선생님이 될 수 있는 방법은 간단해요. 1번, 메타인지에 대해 배우기. 2번, 나의 삶에 메타인지 적용하기입니다. 이전 시간까지 메타인지에 대해 충분히 배우셨으니 이미 반은 끝내셨어요. ",
      text_4:
        "다음 시간부터 메타인지를 발달시키는 구체적인 방법들과 간단한 팁들에 대해 알려드릴 건데요. 메타인지에 대해 단순히 아는 것과, 그 메타인지 기술을 직접 적용시켜 보는 것에는 차이가 있습니다. 우리 아이에게 가장 효과적으로 메타인지를 가르칠 수 있는 방법은 내가 직접 적용시켜본 후 그 개념에 대해 완전히 이해하는 것이에요. 그러니 엄마, 아빠도 직장일, 가사일, 육아, 취미활동 등 일상생활에서 실천해보면서 메타인지를 마스터해 봅시다! ",
      thumbnail: "Neat_thumbnail",
      img: "Neat1_img",
      readDt: "",
    },
    {
      index: 2,
      isRead: false,
      title1: "메타인지 배우기 (2)",
      content: "- 목표 세우기",
      text_1:
        "자, 오늘부터는 실전입니다! 집에서 메타인지 향상시키는 방법에 대해 함께 공부하고 적용해보는 시간을 가져볼 거예요. 제가 알려드리는 방법들을 따라하려면, 그 과정에서 메타인지를 사용할 수밖에 없어요. 크게 두 가지로 설명하려고 합니다. 첫 번째는 ‘목표 세우기’, 두 번째는 ‘되돌아보고 평가하기’입니다. 오늘은 첫 번째 방법에 대해 알아볼게요.",
      text_2:
        "메타인지 과정의 가장 중요한 첫 단계는 바로 목표 세우기입니다. 내가 목표로 하는 것이 무엇인지 정확히 알아야 세부 계획들을 세울 수 있기 때문이죠. 여기서 중요한 팁은 아이와 함께 목표를 정하는 것입니다. 그 목표를 달성하기 위해 노력하는 사람은 아이이기 때문에, 아이가 직접 목표를 정하고 부모는 옆에서 약간의 가이드만 주는 것이에요. 목표 세우기에 직접 참여한 아이는 주인의식을 갖게 되고 목표를 달성하기 위한 동기가 생깁니다.",
      text_3:
        "목표를 세울 때 구체적으로 고려할 것들에는 무엇이 있을까요? 우선 실천할 수 있으면서도 도전적인 목표가 되도록 고려하면서 세우는 것이 좋습니다. 실천하기 너무 어려우면 계속 실패하여 의지가 꺾이고요, 너무 쉬워도 그 역시 동기부여가 되지 않는답니다. 그 다음엔 목표를 세분화 하여 장기목표와 단기목표를 나누어봅니다. 장기목표는 좀 더 동기를 부여해주는 큰 목표이고 단기목표는 장기목표를 이루기 위한 세부목표를 뜻해요. ",
      text_4:
        "이번학기 수학시험에서 좋은 점수를 받고 싶은 상황을 가정하여 볼게요. 이전학기 점수가 70점이었다면, 갑자기 100점으로 목표설정을 하기보다는 80점이나 90점으로 하는 것이 좋겠지요. 고민 끝에 ‘이번학기 수학시험 85점 맞기!’를 목표로 세웠습니다. 이건 장기목표가 될 수 있어요. 단기목표로, 85점을 맞기 위해 오늘부터 차근차근 해나가야 하는 세부 목표를 정해보는 거예요. 학습지 하루에 2장씩 풀기, 주말마다 틀린 문제 복습하기, 주말마다 엄마, 아빠에게 모르는 개념 설명해보기 등이 될 수 있어요. ",
      thumbnail: "Neat_thumbnail",
      img: "Neat2_img",
      readDt: "",
    },
    {
      index: 3,
      isRead: false,
      title1: "메타인지 배우기 (3)",
      content: "- 되돌아보기와 평가하기: 스스로 질문하기",
      text_1:
        "메타인지의 두 번째 과정은 ‘되돌아보기와 평가하기’입니다. 저번 시간에 설정한 목표를 이루기 위해 시도한 것들에 대해 되돌아보고 목표를 이루는 데 도움이 되었는지 평가해보는 과정이에요. 내가 목표를 이루기 위해 시도한 전략들이 효과적이었는지, 잘한 점은 무엇인지, 다음부터 다르게 시도해볼 것은 무엇인지에 대해 생각해보는 것이죠. ",
      text_2:
        "‘되돌아보기와 평가하기’를 실천해 볼 수 있도록 하는 구체적인 전략으로 두 가지를 소개해드리려고 해요. 먼저 첫 번째는 ‘스스로 질문하기’입니다. 우리 아이가 위의 질문들을 스스로에게 던져볼 수 있다면, 메타인지를 활용하는 순간이 됩니다. 그 과정을 통해 자기지각 능력과 메타인지 능력이 향상되는 것이에요.  ",
      text_3:
        "아이가 자기 자신에게 질문을 던질 수 있을 때까지 엄마, 아빠, 선생님과 같은 조력자가 필요해요. 대신 질문들을 던져주고 그 질문에 계속 답해보는 연습을 반복하다 보면 초등학교 고학년, 중학교, 고등학교 과정을 거치며 그 질문들을 스스로에게 해볼 수 있게 됩니다. 비로소 ‘스스로 질문하기’ 마스터가 되는 것이죠. ",
      text_4:
        "‘스스로 질문하기’ 전략은 설정한 목표를 돌아보고 평가하는 데에 적용할 수도 있지만, 일반적인 학습상황에서도 충분히 적용 가능하답니다. 아직 초등학교에 입학하지 않았거나 이제 막 입학한 아이들이라면, 간단한 질문부터 해주세요. “오늘 뭐 배웠어?”, “뭐가 (어떤 문제가) 제일 어려웠어?”, “그걸 해결하기 위해(문제를 풀기 위해) 어떤 시도를 해봤어?”, “그게 효과가 있었니?” 이렇게요. 고학년으로 올라갈수록 “여기서 가장 중요한 게 뭘까?”, “A개념과 B개념에서 유사점은 뭐가 있어?”, “A 의견에 동의하니? (왜 그렇게 생각하니?)” 와 같은 좀 더 깊이 생각해볼 수 있는 질문을 해 보는 것이 좋습니다. ",
      thumbnail: "Neat_thumbnail",
      img: "Neat3_img",
      readDt: "",
    },
    {
      index: 4,
      isRead: false,
      title1: "메타인지 배우기 (4)",
      content: "- 되돌아보기와 평가하기: 일기쓰기",
      text_1:
        "저번 시간에 ‘스스로 질문하기’ 전략을 통해 목표와 학습에 대해 되돌아보고 평가해보는 과정을 연습해보았어요. 오늘은 두 번째 전략, ‘일기쓰기’에 대해 이야기해볼 거예요. 일기쓰기는 곧 자기성찰이죠. 목표를 적고, 목표에 대해 노력한 과정들을 글로 적으며 자연스럽게 돌아보는 것이에요. 더 나아지기 위한 방법들도 함께 적으며 목표 달성과 가까워집니다. 목표에 대한 일기뿐만 아니라 학습이나 오늘 하루에 대한 일기를 쓸 수도 있어요. ",
      text_2:
        "‘일기쓰기’는 메타인지 능력을 향상시키는 데 아주 효과적인 활동이지만, 그 외에 다른 이점도 많이 있답니다. 먼저는 스스로에 대한 이해도가 증가한다는 거예요. 일기는 나의 하루, 내가 좋아하는 것, 내가 느꼈던 것, 즉 주로 나에 대한 이야기를 쓰지요. 그렇기 때문에 나의 감정,  생각과 소통하는 시간이 될 수 있습니다. 그냥 흘려보내고 눌러놓았던 생각과 감정을 다시 풀어서 들여다볼 수 있게 도와줘요. ",
      text_3:
        "더불어 자신의 부정적 감정을 잘 다루는데도 도움이 됩니다. 긴장과 불안과 같은 감정들이요. 내가 불편함을 느꼈던 상황에 대해 글로 자세히 써보는 거예요. 자세히 적다보면 상황 자체를 더 잘 이해할 수 있고요. 그 때의 나를 위로해줄 수 있어요. 다 마치고 나면 긴장과 불안이 줄어들고 차분해진 마음을 느낄 수 있을 거예요.",
      text_4:
        "결국 일기쓰기를 통해 자기인지와 자기조절이 가능해지는 것이지요. 일기쓰기와 관련된 연구에서 역시 일기를 쓰는 사람의 마음이 더 건강하고 행복한 삶을 사는 경향이 있었다고 밝혔어요. 스스로에 대해 이해하고, 나를 돌아보고, 내가 나를 잘 조절할 수 있다는 것이 전반적인 정신건강과 행복감에 영향을 준 것이지요. 오늘부터 우리 가족 모두 일기를 쓰며 하루를 돌아보는 시간을 가져보면 어떨까요?",
      thumbnail: "Neat_thumbnail",
      img: "Neat4_img",
      readDt: "",
    },
  ],
  Mindful: [
    {
      index: 1,
      isRead: false,
      title1: "메타인지 향상시키기 (1) - 일상생활 팁",
      content: "- 체크리스트 만들기- 부모 모델링",
      text_1:
        "저번 시간까지 배운 것들을 통해 우리 아이에게 메타인지를 가르쳐 줄 수 있는 메타인지 선생님이 되었습니다! 축하드려요! 오늘은 ‘학습’보다는 ‘일상생활’ 문제해결 능력에 좀 더 초점을 맞춘 간단한 팁들을 배워보려고 해요. 하교 후 손 씻기, 가방 스스로 정리하기, 가정통신문 꺼내놓기, 옷 제자리에 정리하기, 준비물과 숙제 챙기기, 쓴 물건 제자리에 정리하기 등과 같은 기본적인 생활습관 형성에 도움이 될 거예요.",
      text_2:
        "먼저 체크리스트를 만들어 화이트보드나 벽에 붙여놓습니다. 전날 간단하게 다음 날 등교 전, 혹은 하교 후 해야 할 일에 대해서 쭉 적은 리스트를 함께 적어요. 적는 과정만으로도 해야 할 일을 좀 더 명확하게 알 수 있고, 막연히 할 일이 많은 것 같다는 심리적 부담감으로부터 자유로워질 수 있습니다. 그리고 하나씩 실천했을 때마다 줄을 그어 지우고 하이파이브, 박수 등 격하게 칭찬해주셔야 해요!",
      text_3:
        "다만, 지나치게 엄격한 태도로 관리하지 않도록 유의하셔야 해요. 우리 아이가 한 가지를 해냈을 때 “그래, 이제 그 다음 거 해봐.”하며 더 잘하도록 요구할 때가 있을 거예요. 그런 말이 즉각 튀어나오는 이유는 보통 그 일이 ‘아이의 것’이 아닌 ‘나의 것’이라고 생각하기 때문이에요. 그 말을 들은 아이는 자신의 노력에 대해 인정받지 못 한다는 기분이 느끼고 내일부터는 체크리스트를 안 하겠다고 할 수도 있습니다. 조금 덜 해도 괜찮으니, 이룬 것에 대해 많이 칭찬해주세요.",
      text_4:
        "마지막으로 간단한 팁은 엄마, 아빠가 일상생활 문제해결 과정의 모델이 되는 것입니다. ‘큰 소리로 생각하기’ 기법을 사용하면 아이에게 모델링이 될 수 있어요. 어떤 일을 할 때 생각의 과정을 말하며 하는 거예요. 예를 들어, 저녁을 할 때 “음, 먼저 레시피를 꺼내서 보고, 그 다음에 재료를 꺼내자. 도마, 칼 꺼내서 올려놓고, 프라이팬을 달군 다음에..” 이런 식으로요. 아이가 문제해결 과정을 직접 관찰하고 배우는 기회가 됩니다.",
      thumbnail: "Mindful_thumbnail",
      img: "Mindful1_img",
      readDt: "",
    },
    {
      index: 2,
      isRead: false,
      title1: "메타인지 향상시키기 (2) - 우선순위 정하기 연습 (1)",
      content: "- 우선순위 정하는 원리",
      text_1:
        "오늘부터는 메타인지 영역에 도움이 좀 더 필요한 아이들과 함께 할 수 있는 연습을 알려드릴 거예요. 항상 준비물을 까먹는 아이, 주변이 늘 지저분한 아이, 해야 할 일을 시작하거나 끝맺지 못 하는 아이, 학교에서 이와 관련된 부정적 피드백을 받는 아이. 이런 아이들에게 더욱 도움이 될 거예요. 이 내용도 역시 엄마, 아빠, 아이가 다 같이 공부하고 실천해보면 좋으니, 함께 해보길 추천 드려요. ",
      text_2:
        "메타인지를 잘 활용하지 못 하면, 어떤 순서로 일을 처리해야 하고 어떻게 시작해야 하는지를 알지 못해 어려움을 겪습니다. 해야 할 일은 많은데 다 똑같이 중요하다고 느껴지는 것이지요. 그럼 일은 시작하지 못 하고, 시간은 흘러가고, 점점 그 일의 양과 스트레스에 압도돼 버립니다. 이런 아이들에게는 ‘우선순위 정하기 연습’이 필요해요. 늘 말씀드렸듯이, 연습하면 좋아질 수 있습니다.",
      text_3:
        "우선순위를 정하는 것은 많은 일들을 어떤 순서로, 언제 시작해야 할지에 대한 가이드를 줍니다. 우선순위를 정할 때는 딱 두 가지 원리가 작동합니다. ‘급한 일’과 ‘중요한 일’입니다. 급한 일은 마감 기한과 같이 시간의 압박이 있는 일을 뜻해요. 그리고 중요한 일은 목표를 달성하고자, 혹은 내 가치를 지켜내고자 하려는 일을 말합니다. ",
      text_4:
        "대부분의 일들은 두 가지 원리가 함께 작용하여 우선순위를 결정하게 되는 것이에요. 다음 시간에는 이 두 가지 원리에 따라 할 일을 나눠보는 연습을 해보고, 우리가 어떤 일에 시간을 많이 쓰고 있는지를 알아볼 거예요. ",
      thumbnail: "Mindful_thumbnail",
      img: "Mindful2_img",
      readDt: "",
    },
    {
      index: 3,
      isRead: false,
      title1: "메타인지 향상시키기 (3) - 우선순위 정하기 연습 (2)",
      content: "- 급한일과 중요한일 표",
      text_1:
        "한 학자는 ‘급한 일’과 ‘중요한 일’을 표로 그려 우선순위를 정하는 방법에 대해 제시했어요. 다음과 같이 4분할 표를 만들어보고 그 안에 들어갈 만한 일들을 생각해보는 것이에요. 급한 일급하지 않은 일중요한 일AB중요하지 않은 일CD",
      text_2:
        "A는 마감일이 정해져 있으면서도 중요한 일이에요. 이 일은 1순위로 처리해야 합니다. B는 마감일에 여유가 있지만 인생에 있어 중요한 일을 의미합니다. 운동이나 자기개발을 위한 활동, 취미생활 등이 여기에 해당되죠. C는 급하지만 중요하지는 않은 일이에요. 나에게는 중요하진 않지만 급하게 처리해야 하는 업무나 회의, 약속 등이 될 수 있어요. D는 중요하지도 않고 급하지도 않은 일입니다. 수많은 전화, 문자, 웹 서핑, SNS, 게임 이런 것들이 있어요. ",
      text_3:
        "이제 나의 하루를 어느 칸에 많이 투자하는지 살펴봅시다. 나의 할 일 목록이 A에 많이 할당되어 있고 이곳에 시간을 많이 쓴다면, 우선순위를 잘 정하지 못 하고 미루는 습관이 있을 수 있어요. 어떤 것을 먼저 처리해야 하는지 알지 못해 미루다가 모든 일이 급한 일이 되어 쌓여버린 것이지요. A에 있는 일들은 확실히 동기부여가 되지만, 그만큼 스트레스를 많아요. 그러니 A에 많은 할 일이 들어가지 않도록 관리해 주는 것이 중요합니다. ",
      text_4:
        "C에 시간을 많이 쓰는 사람은 갑자기 걸려오는 전화나 업무 부탁과 같은 것에 대해 명확한 경계를 설정하는 것이 어려운 사람일 수 있어요. 그리고 D구간에 시간을 많이 쓰고 있다면 내가 해야 할 일을 회피하고 있는 상태라고 볼 수 있습니다. 우리 가족의 시간은 어느 곳에 많이 사용되고 있나요? 한 번 점검해 보세요. 좀 더 효율적인 시간관리에 도움이 될 거예요. ",
      thumbnail: "Mindful_thumbnail",
      img: "Mindful3_img",
      readDt: "",
    },
    {
      index: 4,
      isRead: false,
      title1: "메타인지 향상시키기 (4) - 우선순위 정하기 연습 (3)",
      content: "- 적용해보기 3단계",
      text_1:
        "오늘은 엄마, 아빠, 우리 아이의 하루 할 일들에 대해 우선순위를 정해보아요. 먼저 할 일 목록을 어디에 적을지를 정합니다. 작은 노트, 스마트폰, 태블릿 어디든 좋아요. 단, 매번 이곳저곳 나누어 적지 않도록 딱 하나를 정하는 것이 중요합니다. 정하셨나요? 그 곳에 할 일을 생각나는 대로 적어봅니다. 한 번에 다 적지 않아도 괜찮아요. 다음에 생각났을 때 다시 추가하면 됩니다. ",
      text_2:
        "이제 각 할 일에 우선순위를 매길 거예요. 우선순위의 중요한 두 가지 원리인 ‘급한 것’과 ‘중요한 것’을 평가하여 무엇을 먼저 할지 최종 결정하는 단계랍니다. 이 단계가 가장 오래 걸리고 막히는 지점입니다. 대부분의 사람들이 ‘다 비슷하게 중요해 보이는데..’라고 생각하며 점수 매기기를 어려워하거든요. ",
      text_3:
        "점수를 매기기 위해 세 가지의 질문을 해보면 도움이 됩니다. “내가 이 일을 안 했을 때 어떤 결과가 나타나는가?”, “내가 이 일을 하면 결과가 나타나는가?”, “어떤 일을 계속 미루고 싶어 하는가?”. 어떤 일을 하거나 하지 않았을 때 나타나는 결과를 살펴보면 점수를 매기기 쉬워져요. 그리고 보통 하기 싫은 마음이 드는 것일수록, 더 빨리 시작해야 하는 것일 확률이 높습니다. ",
      text_4:
        "이 과정에 있어서 서로가 서로의 조력자가 되어 주면 좋습니다. 조력자가 있을수록 우선순위를 결정하기 더 쉬워져요. 무엇이 더 급한지, 중요한지에 대해 이야기 나누는 과정은 우선순위를 정하는 것과, 더 나아가 메타인지 능력을 향상시키는 데 많은 도움이 됩니다. 그러니 가족 모두가 이 활동에 참여하는 것이 효과가 배가 되겠죠. ",
      thumbnail: "Mindful_thumbnail",
      img: "Mindful4_img",
      readDt: "",
    },
  ],
  gloom: [
    {
      index: 1,
      isRead: false,
      title1: "아동기 우울증",
      content: "- 아동기 우울증 증상- 가면 우울증",
      text_1:
        "막 태어난 아이에게 가장 필요한 건 때에 맞춰 배를 채워주고 기저귀를 갈아주며 울 때 안아주는 어른이지요. 신체적인 욕구가 얼마만큼 즉각적으로 충족되느냐가 결국 그 아이의 정서적 안정감 수준을 결정합니다. 하지만 아이가 점점 커가면서 부모의 역할은 조금씩 확대돼요. 흔히 말하는 ‘멘탈케어’를 해주는 어른이 필요합니다. 아이의 마음건강을 돌봐줘야 하는 것이에요. 오늘부터는 우리 아이의 마음상태를 들여다보고 도울 수 있는 방법들을 알아볼 거예요. 먼저는 ‘우울’입니다.",
      text_2:
        "요즘은 정신건강에 대한 TV 프로그램이 많아 ‘우울증’이 낯선 증상은 아닐 겁니다. 마음의 감기라는 별명도 있듯이, 누구나 흔히 겪을 수 있는 증상이고 그에 대한 부정적 인식들도 많이 개선되고 있죠. 하지만 우리 아이들의 우울증은 어떤가요? 어른의 ‘우울’하면 흔히 떠오르는 특징들, 기운 없고 표정이 다양하지 않으며 즐거운 일이 없어 보이는 그런 특징들이 동일하게 관찰될까요? ",
      text_3:
        "기본적으로 우울한 어른이 보이는 특성과 유사한 모습이 나타납니다. 가끔 인생에 즐거운 것이 없는 것처럼 무기력하고 피곤하거나 신체적인 통증을 호소하기도 합니다. 자아존중감이 낮고 사회적으로 위축되어 있으며 집중력이 떨어져 학업능력도 함께 저하되죠. 이런 사인이 있다면 우리 아이의 마음상태가 우울하다고 의심해볼 수 있습니다.",
      text_4:
        "하지만 성인의 우울증과 다른 증상이 있습니다. 바로 ‘과민한 기분’, 예민함입니다. 우울감을 겪고 있는 아이들은 신경질적이거나 짜증이 많은 모습을 보이기도 해요. 갑자기 폭발하거나 소리 지르며 눈물을 흘리고, 물건을 집어 던지는 등과 같은 공격적인 행동 말이에요. 그래서 아동기 우울증을 ‘가면우울증’이라는 개념으로 설명하기도 합니다. 기저에 우울증상이 존재하지만, 과잉행동과 공격성, 비행과 같은 다른 문제들에 의해 ‘가려진다’는 것이에요. 이 특징까지 잘 파악하고 있어야 합니다.",
      thumbnail: "gloom_thumbnail",
      img: "gloom1_img",
      readDt: "",
    },
    {
      index: 2,
      isRead: false,
      title1: "우울증의 발달",
      content: "- 학령전기- 학령기- 청소년기",
      text_1:
        "저번 시간에 아이들의 우울증이 어떤 증상으로 나타나는지 배워보았어요. 오늘은 더 자세히 들여다보려고 해요. 유아기부터 청소년기까지, 우울한 아이들은 어떤 특성들을 보이는지에 대해서요. 우리 아이의 마음상태를 살피는 데 조금 더 도움이 되실 거예요.",
      text_2:
        "많은 학자들이 발달시기에 따라 우울증이 어떤 방식으로 표현되는지에 대해 연구했어요. 유아기 아동의 경우, 다른 발달시기에 비해 표출 방식에 다양한 차이가 있었다고 합니다. 활동성이 떨어지고, 밤에 울며 깨는 야경증과 같은 수면문제, 밥을 잘 먹지 않는 섭식문제가 나타나며, 과도하게 우는 모습이 관찰되었습니다. 복통을 호소하거나 잘 가리던 대소변 실수를 하기도 하고 유치원이나 어린이집을 가기 싫어하고 사회적으로 위축된 모습도 나타났습니다.",
      text_3:
        "학령기 아동은 학령전기 아동보다 하루 중 우울감을 보이는 시간이 좀 더 길었습니다. 즉, 우울증상이 장기적인 패턴으로 나타난다는 것이지요. 그리고 저학년과 고학년의 표현 방식에의 차이가 있었어요. 고학년으로 갈수록, 자신이 느끼는 절망감이나 자기비하를 말로 표현하는 경향이 있었습니다. “아, 역시 난 안 돼.”, “망했어.”와 같은 표현을 더 많이 했다는 뜻이지요. ",
      text_4:
        "우울증을 겪는 청소년은 아동기 우울증 증상과 여러 면에서 비슷했는데요. 그러면서도 성인의 증상에 훨씬 더 가까워지기 시작합니다. 아마도 생물학적, 사회적, 인지적인 발달이 이루어지면서 성인과 비슷해지기 때문이겠죠. 따라서 청소년기에 우울증이 발병한 경우, 성인기 우울증까지 이어질 확률이 높았다고 해요. ",
      thumbnail: "gloom_thumbnail",
      img: "gloom2_img",
      readDt: "",
    },
    {
      index: 3,
      isRead: false,
      title1: "우울증의 원인",
      content: "- 분리와 상실의 경험- 인지적 특성",
      text_1:
        "모든 심리적 어려움에는 다양한 원인이 있습니다. 크게 세 가지로 나눠볼 수 있어요. 유전이나 신경전달물질의 역할과 같은 생물학적 원인, 아이 개인의 기질적인 원인, 그리고 아이의 경험이나 일상의 큰 변화, 사고방식, 양육태도와 같은 심리/사회적 원인이에요. ",
      text_2:
        "이 세 가지가 다 서로 상호작용하여 증상이 나타나는 것이기 때문에, 어느 한 가지에 원인을 돌릴 수 없고, 그래서도 안 됩니다. 우울증 역시 이런 복합적인 것들의 작용으로 나타나는 것인데요. 우리는 오늘 심리/사회적 원인에 대해 몇 가지 살펴보려고 해요. ",
      text_3:
        "첫 번째는 ‘분리와 상실의 경험’입니다. 우울증에 대한 아주 일반적인 심리학적 설명이에요. 분리는 주양육자와 분리되는 경험을 뜻하고, 아주 어린 시기부터 주양육자와 분리된 아이들은 우울증 증상과 유사한 행동특성을 보였다고 해요. 상실은 부모가 사망하거나 이혼하는 것과 같은 실제적 상실도 있고요. 실제 부모는 존재하지만 심리적으로 상실한 것과 같은 충격적 경험을 겪은 상징적 상실도 있어요. ",
      text_4:
        "두 번째는 우울감을 유발하는 ‘인지적 특성’입니다. 많은 연구들은 우울증을 겪는 사람들의 ‘인지적 특성’에 주목했어요. 보통 중립적인 자극을 인지적으로 해석하는 방식의 차이 때문에 우울증을 겪는다고 설명했습니다. 우울한 아동과 성인들은 대부분 부정적인 사건에 대해 자신에게 책임을 돌리고, 그 사건의 원인은 시간이 지나도 변하지 않으며, 모든 사건에 그 원인을 적용할 수 있다고 생각하는 경향이 있었어요. 사건에 대해 이렇게 해석을 한다면 그 누구도 우울감을 느낄 수 있겠죠.",
      thumbnail: "gloom_thumbnail",
      img: "gloom3_img",
      readDt: "",
    },
    {
      index: 4,
      isRead: false,
      title1: "우울한 아동을 돕는 방법",
      content: "- 정서적 지지 제공- 건강한 생활습관 형성- 사회적 지지체계 제공",
      text_1:
        "지금까지 우울한 아동의 특성과 원인들에 대해 살펴보았어요. 오늘은 이런 아이들을 어떻게 도와줄 수 있을지에 대해 이야기해보려 해요. 어쩌면 들어본 내용일 수 있는데요, 그만큼 중요하고 필수적이기 때문에 자주 언급되는 것이겠지요. 항상 들어왔지만 실천하지 못 하고 있다면 그건 제대로 알고 있는 것이 아닙니다. 오늘은 제대로 알고 넘어가도록 해요.",
      text_2:
        "첫 번째로, 아이의 특별한 한 사람이 되어 주세요. 내 마음을 알아주는 사람 단 한명만 있어도 우울감을 극복할 수 있어요. 그 한 사람이 엄마나 아빠, 가족 구성원이면 더욱 좋습니다. 가족의 정서적 지지는 아이가 심리적으로 건강한 아이로 성장하는 든든한 기초가 되어주거든요. 아이와 질 높은 시간을 많이 보내주세요. 그리고 아이의 이야기에 귀 기울여 주세요. 귀 기울여 듣는 건 이야기의 옳고 그름을 평가하지 않는 것을 뜻해요. 관계의 기초가 쌓이면 힘든 일이 있을 때 엄마, 아빠에게 털어놓을 수 있게 됩니다. ",
      text_3:
        "두 번째로, 건강한 생활습관을 형성해 주세요. 많은 연구들을 통해 마음건강과 신체건강이 긴밀하게 연결되어 있음이 밝혀졌어요. 건강한 생활습관을 형성하면 우울증상을 극복하는 데 큰 도움이 됩니다. 규칙적인 운동을 통해 스트레스를 줄일 수 있어요. 건강한 음식을 먹어 속을 편안하게 하면 우울감을 조절하는 뇌 영역을 활성화시킬 수 있어요. 충분하고 규칙적인 수면을 취하면 몸이 덜 피곤해집니다. ",
      text_4:
        "마지막으로, 다른 친구들과 어울릴 수 있게 도와주세요. 우울증을 겪는 아이들은 사회적으로 위축되는 특성이 있어 다른 친구들과의 상호작용이 줄어요. 외로움을 느끼고 우울증이 더 악화되는 악순환으로 이어지죠. 아이가 사회적 경험을 쌓을 수 있도록 격려해주시고 다른 친구들과의 연결감과 소속감을 느낄 수 있도록 도와주세요. 친구들을 집에 초대해 함께 1박하며 노는 경험, 다양한 학교 동아리나 방과 후 활동에 참여하는 경험, 엄마, 아빠의 친구 가족과 노는 경험, 친척들과 어울리는 경험. 이런 경험이 아이를 생기 있게 만듭니다.",
      thumbnail: "gloom_thumbnail",
      img: "gloom4_img",
      readDt: "",
    },
  ],
  anxiety: [
    {
      index: 1,
      isRead: false,
      title1: "불안한 아이",
      content: "- 불안한 아동의 특성",
      text_1:
        "오늘부터는 새로운 감정, 불안에 대해 배워볼 거예요. 불안하면 어떤 모습이 떠오르시나요? ‘어떡하지’ 하며 걱정하고, 발을 동동 구르거나 손을 물어뜯으며 안절부절 못 하고, 혹은 얼어붙어 울어버리는 모습이 떠오르실 거예요. 불안은 어떤 것에 대한 걱정이나 두려움을 뜻해요. 생각, 감정, 신체적인 감각 세 가지 경로를 통해 경험할 수 있어요. ",
      text_2:
        "모든 아이들은 불안을 느낍니다. 흔하게 느낄 수 있는 감정 중 하나에요. 시험보기 전 날이나 학교 처음 가는 날 등 흔히 긴장이 유발될 수 있는 상황에서 불안을 느낄 수 있어요. 자연스러운 불안은 시간이 지나면서 가라앉고, 그런 극복 경험이 쌓일수록 이후 유사한 사건에 대한 불안 수준은 조금씩 낮아질 수 있습니다. ",
      text_3:
        "만약 아이가 불안 수준이 너무 커서 불안함에 압도되어 버리고, 아무 대처도 하지 못 하며, 여러 번 경험을 했음에도 지속적으로 걱정하고 불안해한다면, 불안을 잘 다루지 못 하고 있는 상태일 수 있습니다. 이런 경우에는 두려움을 유발하는 상황을 피해버리거나 혹은 미숙한 방식으로 대처를 하게 됩니다. ",
      text_4:
        "불안한 아이들이 상황을 피하기 위해 보이는 흔한 모습의 예가 등원 혹은 등교 거부입니다. 일단 나에게 불안을 주는 자극을 피해서 마음을 진정시키려 하는 것이지요. 어쩔 수 없이 등원, 등교를 하게 되면, 세상 떠나가듯 울거나 혹은 유치원이나 학교에서 말을 하지 않고 조용히 있는 등의 행동문제를 보일 수도 있어요. 불안해서 견딜 수 없는데 잘 다룰 수 있는 능력이 없으니, 어떻게든 스스로 해결해보려 그런 방법을 선택하는 것이지요. ",
      thumbnail: "anxiety_thumbnail",
      img: "anxiety1_img",
      readDt: "",
    },
    {
      index: 2,
      isRead: false,
      title1: "불안의 원인",
      content: "- 기질적 요인- 심리/시회적 요인",
      text_1:
        "오늘은 왜 어떤 아이는 다른 아이에 비해 불안을 더 잘 느끼고 대처하지 못 하는지, 그 원인에 대해 살펴볼 거예요. 저번 시간에 ‘우울’에 대해 이야기하며 말씀 드렸었죠. 모든 심리적 어려움에는 생물학적 원인, 기질적 원인, 심리/사회적 원인이 함께 작용하여 영향을 미친다고 말이에요. 만약 우리 아이가 불안을 잘 느낀다면, 다양한 이유 중 어떤 이유가 해당되는지 점검해보세요. ",
      text_2:
        "먼저 기질적 요인이에요. 개인의 기질을 파악하기 위해 사용하는 ‘기질 및 성격 검사지(TCI)&#39;가 있는데요, 위험하다고 느끼면 피하거나 멈추는 특성을 측정하는 ’위험회피‘ 점수가 높은 경우 불안이 높을 수 있어요. 이런 아이들은 낯선 사람, 사건을 접할 때 먼저 다가가기 보다는 멈추는 성향이 있고, 부정적 정서, 특히 긴장을 좀 더 잘 느끼는 특성이 있으며, 무서운 것과 같은 부정적 자극에 더 주의를 기울이는 성향이 있습니다. ",
      text_3:
        "심리/사회적 요인으로는 먼저 환경적으로 변화가 있거나 충격적인 사건을 경험한 경우 과도한 불안이 나타날 수 있습니다. 짧은 시간에 이사와 전학을 동시에 가게 되었는데 엄마도 일을 시작한 경우, 동생이 태어난 경우, 학대나 괴롭힘을 직접 겪거나 목격한 경우, 학교에서 시험을 앞두고 있거나 또래관계에서 어려움이 있는 경우가 환경적 위험요인의 예가 될 수 있어요. 만약 아이가 앞서 설명한 기질적 특성을 가지고 있다면 환경적 자극이 생겼을 때 더 큰 어려움을 겪을 수 있겠죠.",
      text_4:
        "마지막으로 주변에 불안을 잘 느끼는 사람이 있으면 아이도 함께 불안해질 수 있습니다. 엄마, 아빠, 혹은 자주 만나는 할머니, 할아버지가 평소에 작은 것에 놀라고 걱정과 두려움이 많은 성격이라면 아이도 그런 특성을 보일 가능성이 높아요. 아무런 정보가 없던 자극이었는데, 나와 가까운 사람이 그 자극에 대해 ‘위험하다’, ‘불안하다’, ‘무섭다’라고 해석한다면 아이도 그렇게 받아들이게 되는 것이지요. 특히 아이가 기질적으로 부정적 자극에 더 주의를 기울인다면, 가까운 사람이 보이는 부정적 반응을 더 잘 학습하게 됩니다.",
      thumbnail: "anxiety_thumbnail",
      img: "anxiety2_img",
      readDt: "",
    },
    {
      index: 3,
      isRead: false,
      title1: "불안한 아동을 돕는 방법 (1)",
      content: "- 하면 안 되는 행동- 안전한 어른과 함께 경험해보기",
      text_1:
        "불안은 순간 아이의 행동을 멈추게 하고 숨거나 회피하게 만들어, 일상생활에 지장을 주는 경우가 많습니다. 일단 아이가 그 순간을 피해버리면 불안이 조금 감소하기 때문에 계속해서 피하는 방법을 사용해서 불안한 상황을 다루려 할 거예요. 그러니 무조건 무서운 것을 피하도록 두는 것은 좋은 방법이 아닙니다. ",
      text_2:
        "그럼 “무서워도 일단 해 봐야 해!”하고 그 상황을 경험시켜 주는 것이 좋을까요? 이것도 별로 좋은 방법은 아니에요. 아직 불안을 다룰 수 있는 능력이 충분히 발달하지 않았기 때문에, 무작정 두려움을 유발하는 상황에 직면시키는 것은 오히려 더 큰 심리적 충격을 불러일으킬 수 있어요. ",
      text_3:
        "적절한 방법은 두려운 상황을 안전한 어른과 함께 경험해보는 것입니다. 그 상황을 피하지 않고 직면하되, 아이 스스로는 아직 힘이 없으니 힘 있는 어른과 함께 극복경험을 쌓아보는 거예요. 그 과정에서 엄마, 아빠와 손 잡기, 심호흡하기, 재미있는 장난감이나 활동으로 주의 전환해보기 등 불안을 낮출 수 있는 다양한 대처방안을 연습해볼 수 있습니다.",
      text_4:
        "치과를 무서워하는 아이를 예로 들어볼게요. 아이가 무서워 치과에 가지 않으려고 하거나 치과에서 계속 울고 있다면 일단은 아이의 두려움이 잘못된 것이 아니라고 인정해주세요. “엄마/아빠도 어렸을 때 치과가 무서웠어. 지금도 가끔 무서울 때가 있어. 무서움을 느끼는 건 자연스러운 거야.” 라고요. 그리고 피하지 않고 함께 겪어볼 것이라고 덧붙여 주세요. “그렇지만 치과 진료는 꼭 필요해. 네 치아가 튼튼해야 맛있는 걸 먹을 수 있거든. 엄마/아빠가 끝날 때까지 옆에 있어줄게.” 이렇게요. 그 이후엔 아이가 가기 싫어하면 번쩍 들어서, 울고 있으면 손잡고 토닥토닥 하며 진료를 보는 거예요. ",
      thumbnail: "anxiety_thumbnail",
      img: "anxiety3_img",
      readDt: "",
    },
    {
      index: 4,
      isRead: false,
      title1: "불안한 아동을 돕는 방법 (2)",
      content: "- 다양한 전략들",
      text_1:
        "저번 시간에 아이가 두려움을 많이 느낄 때 안전한 어른과 함께 그 상황을 경험하는 것이 중요하다고 이야기 나눴어요. 아이의 마음은 공감해주되, 꼭 해야 하는 일의 경우 피하지 않고 해보도록 옆에서 도와주는 것이지요. 이제 한 단계 더 들어가 볼게요. 그 시간은 그냥 견디는 시간이 아닙니다. 불안을 다루는 여러 전략들을 사용해볼 수 있는 기회에요. ",
      text_2:
        "먼저 아이가 평소 두려움을 느낄만한 일정이 계획되어 있다면, 그 일정에 대해 자세히 이야기를 나눠보는 것이 중요해요. 그리고 그 과정에서 어떤 마음이 들 것 같은지, 신체적으로는 어떤 변화가 있을 것 같은지, 그런 상황에서 어떻게 대처해보면 좋을지 함께 이야기를 충분히 나눕니다. 그리고 “엄마/아빠가 옆에 계속 있을 거야.”, “그 시간은 계속되지 않아. 끝이 있어.”, “네가 걱정하는 일 없이 무사히 끝날 거야.”와 같은 이야기를 해주어 마음을 안심시켜 주세요. ",
      text_3:
        "그 다음엔 두려운 상황에서 직접 사용해볼 수 있는 것들을 함께 연습해 봅니다. “우리 무서운 상황이 오면 이렇게 한 번 해보자.”라고 직접적으로 가르쳐주는 것이 좋아요. 가장 보편적인 방법은 심호흡이 있습니다. 평소에 4초간 들이마시고, 4초 참고, 6초간 내쉬는 것을 연습해보셔야 해요. 또 “무서울 때 네가 좋아하는 걸 하면 좀 나아질 수 있어. 뭘 가지고 가볼까?” 혹은 “무서울 때 다른 데 주의를 돌려보면 좀 나아지더라고. 옆에 있는 사람과 이야기를 나눠보는 것도 좋아.”와 같이 주의전환 방법을 알려주시는 것도 좋습니다.",
      text_4:
        "중요한 것은 그 전략들을 미리 배워야 한다는 점이에요. 운동선수들이 경기 도중 새로운 전략을 쓰지는 않지요. 미리 배우고 연습한 후에 경기에서 사용해볼 거예요. 아이가 불안을 느끼는 상황은 실전이에요. 불안을 느끼기 시작하면 엄마, 아빠가 옆에서 무슨 이야기를 해도 들리지 않아요. 화가 머리끝까지 차올랐을 때 옆에서 이성적인 이야기를 해도 진정되지 않는 것처럼 말이에요. 그러니 차분한 상태에서 충분한 대화를 통해 준비시켜주세요.",
      thumbnail: "anxiety_thumbnail",
      img: "anxiety4_img",
      readDt: "",
    },
  ],
  stress: [
    {
      index: 1,
      isRead: false,
      title1: "스트레스의 기능",
      content: "- 스트레스의 긍정적 역할",
      text_1:
        "아이들은 모두 살아가면서 스트레스를 경험합니다. 스트레스는 변화와 도전에 대한 자연스럽고 정상적인 반응이에요. 특히나 아이들의 삶은 스트레스로 가득 차 있지요. 아동기는 변화와 도전의 연속이니까요.",
      text_2:
        "우리는 보통 ‘스트레스’ 하면 힘든 상황에서 나타나는 것, 안 좋은 것이라고 생각하는 경우가 많은데요. 만병의 근원은 스트레스라는 말이 있듯이, 스트레스가 과하면 안 좋은 영향을 끼치기 때문이겠죠. 하지만 기본적으로 스트레스는 우리에게 도움이 되는 친구에요. ",
      text_3:
        "언제 스트레스가 도움이 될까요? 스트레스 수준이 적당하고, 주변에서 적절한 도움을 받을 수 있을 때 스트레스는 긍정적으로 작용할 수 있어요. 도전을 통해 성장할 수 있도록 도와줍니다. 목표를 달성하도록 약간의 책임감을 주고, 목표 달성을 위한 여러 시도들에 집중하게 해주며, 마침내 달성할 수 있도록 합니다. 이러한 종류의 긍정적인 스트레스는 아이의 탄력성과 같은 내면의 힘을 길러줘요. ",
      text_4:
        "그러니 아이의 스트레스가 아이의 목표 달성에 중요한 자원이 될 수 있도록 적극 도와주셔야 합니다. 아이가 일상에서 스트레스를 느낄만한 사건을 경험하고 있다면, 그 시기에는 더욱 신경 써서 정서적인 지지를 주셔야 해요. 스트레스가 과한 수준으로 넘쳐흐르지 않고 오히려 긍정적인 역할을 할 수 있게요. 가족 중 수험생이 있으면 가족 모두가 1년 동안 최고의 컨디션을 위해 노력하는 것과 비슷하답니다.",
      thumbnail: "stress_thumbnail",
      img: "stress1_img",
      readDt: "",
    },
    {
      index: 2,
      isRead: false,
      title1: "스트레스 원인과 도움 (1)",
      content: "- 긍정적인 생활사건- 도움 방법",
      text_1:
        "아이에게 스트레스를 주는 일들에는 무엇이 있을까요? 일상생활에서 스트레스를 유발하는 사건들은 다양합니다. 우리는 보통 부정적인 사건들만 떠올릴 수 있는데요, 우리가 즐겁고 좋다고 여기는 사건들 역시 아이에게 스트레스를 줄 수 있어요. ",
      text_2:
        "좋지만 스트레스를 주는 일들은 반 친구들이 많이 모이는 생일파티, 학교에 처음 가는 날, 졸업식 날, 가족과 가는 여행, 휴가 등이 있어요. 이런 행사가 있으면 즐겁고 기대되는 마음도 있지만, 한편으로 약간의 스트레스도 경험할 수 있습니다. ",
      text_3:
        "스트레스가 너무 지나쳐서 행사 자체에 대한 부정적 인식이 생기지 않도록 도와주시면 좋아요. 처음 학교에 가는 것이 기대되지만 약간의 긴장과 스트레스가 있는 아이를 예로 들어 볼게요. 학교 가는 길, 교실의 모습, 가서 친구들을 만났을 때 나눌 수 있는 대화 등 학교 가는 상황에서 자연스럽게 경험하는 일들에 대해 구체적으로 이야기를 나눠봅니다. 실제로 학교를 미리 방문해 보는 것도 긴장과 스트레스를 낮추는 데 효과적이에요.",
      text_4:
        "또한 학교 가는 것의 긍정적인 면을 바라볼 수 있도록 좋은 점을 찾아 이야기해 주세요. 학교 가면 다양한 친구들을 만나볼 수 있고, 학교 근처에 아이가 좋아하는 간식을 파는 곳이 있다면 그곳을 소개해주는 것도 좋고요. 아이가 스트레스 받는다고 표현을 한다면, “그럴 수 있어.”, “괜찮아.”라고 수용해주세요. 스트레스를 받는 것이 오히려 학교에서 실수하지 않고 잘 해내도록 도와줄 수 있다고 설명해주셔도 좋습니다. 그리고 무엇보다 “네가 필요할 때 엄마, 아빠가 도와줄 수 있어.” 라고 이야기해 주세요. ",
      thumbnail: "stress_thumbnail",
      img: "stress2_img",
      readDt: "",
    },
    {
      index: 3,
      isRead: false,
      title1: "스트레스 원인과 도움 (2)",
      content: "- 부정적인 생활사건- 도움 방법",
      text_1:
        "저번 시간에는 일상생활의 좋은 일들을 통해 스트레스를 느끼는 경우는 무엇이 있는지와 대처방법에 대해 알아보았습니다. 오늘은 우리가 일반적으로 ‘스트레스’라는 말을 떠올리는 일들에는 무엇이 있는지 살펴보려고 해요. 아이의 일상생활 속에서요.",
      text_2:
        "아이들은 인생을 살면서 어쩔 수 없이 다양한 스트레스 사건들을 마주하게 됩니다. 갑자기 몸이 많이 아파 병원에 입원을 하고 치료를 받는 경험, 부모님이 이혼하는 경험, 사랑하는 사람이 죽는 상실의 경험, 새로운 동네에 이사와 전학을 가게 돼 친구들과 헤어지고 새로운 친구들을 사귀는 경험. 이런 것들이 모두 스트레스를 유발하는 사건들이 될 수 있어요.",
      text_3:
        "이런 사건들로 인해 며칠 동안, 혹은 몇 주에 걸쳐 스트레스를 경험할 수 있습니다. 이 스트레스는 변화된 환경에 대한 적응이 끝나면 자연스럽게 줄어들어요. 그러니 아이가 적응하기 위해 보내는 잠깐의 시간동안 부모의 도움이 중요합니다. 스트레스를 직접 줄여주는 것이 부모의 역할이 아니에요. 아이가 스스로 스트레스를 조절하고 환경에 잘 적응할 수 있도록 옆에서 지지해주고 이야기를 들어주며 안정감 있게 있어주는 것이 부모의 역할입니다. ",
      text_4:
        "예를 들어, 새로운 동네에 이사 가 전학까지 가게 된 상황을 가정해 볼게요. 아이가 새 동네와 학교에 적응하는 1-2주의 기간 동안만큼은 매일 이야기 나누는 시간을 가지는 거예요. 하교 후 함께 동네 산책을 할 수 있다면 그 시간을 활용해 이야기도 나누고 동네에 적응해볼 수도 있겠고요. 그 시간이 어렵다면 저녁식사 하면서, 혹은 잠자기 전 시간을 활용해 볼 수 있어요. 오늘 하루 어떤 게 힘들었는지, 내일은 어떨 것 같은지, 오늘은 어떤 친구를 알게 되었는지에 대한 이야기만 나눠도 아이는 스스로 적응할 힘을 얻게 됩니다. ",
      thumbnail: "stress_thumbnail",
      img: "stress3_img",
      readDt: "",
    },
    {
      index: 4,
      isRead: false,
      title1: "만성적인 스트레스",
      content: "- 만성적인 스트레스의 원인- 도움 방법",
      text_1:
        "부정적인 사건에 의해 발생한 스트레스는 며칠, 혹은 몇 주가 지나면 자연스럽게 감소한다고 말씀드렸어요. 아이가 적응하면서 자연스럽게 줄어든다고요. 하지만 스트레스를 유발하는 변화된 환경에 적응하지 못 하고 한 달 넘게 스트레스를 겪고 있다면, 이는 만성적인 스트레스 상태로 볼 수 있습니다.  ",
      text_2:
        "만성적인 스트레스로 이어지는 사건들은 아이가 스스로 적응하기 어려운, 좀 더 심리적인 충격이 큰 사건일 수 있어요. 단순히 며칠 입원하는 것이 아닌, 난치병을 앓아 장기입원과 치료를 병행하는 상황인 경우, 사랑하는 사람 중에서도 부모나 형제와 같은 심리적으로 아주 가까운 대상을 상실한 경우, 혹은 여러 사건이 연달아 발생하는 경우 등이 원인이 될 수 있습니다.",
      text_3:
        "어떻게 도와줄 수 있을까요? 우선 저번 시간에 설명한 부모의 역할을 해주시되, 좀 더 오랫동안 해주셔야 합니다. 몇 주간만 하는 것이 아니라, 일정한 루틴을 만들어 지속하는 것이 중요해요. 하교할 때 함께 있어주는 것, 항상 같은 시간에 함께 저녁을 먹고 잠자리에 드는 것 등과 같이 일정하고 반복되는 루틴 속에서 함께 해주시는 것이 좋아요. 그 시간동안 감정에 대한 대화를 나눠도 좋고요. 반복되는 루틴과 늘 함께해주는 사람의 존재는 아이에게 안정감을 줍니다. ",
      text_4:
        "이와 더불어 즐거운 경험을 많이 하는 것이 필요합니다. 아이가 스트레스 사건을 잠시 잊고 즐거움을 느낄 수 있는 일이면 됩니다. 놀이터에서 놀기, 그림 그리기, 공원 놀러가기, 책 읽기, 악기 연주하기, 친구들과 놀기 그 어떤 것이든 좋아요. 즐거운 활동을 하는 동안 아이는 긍정적인 정서를 많이 느끼게 되고, 이는 스트레스를 극복하고 사건에 적응할 수 있는 새로운 에너지원이 된답니다.",
      thumbnail: "stress_thumbnail",
      img: "stress4_img",
      readDt: "",
    },
  ],
};
